Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ReactDOM = require('react-dom');
var reactI18next = require('react-i18next');
var antd = require('antd');
var reactRedux = require('react-redux');
var connectedReactRouter = require('connected-react-router');
var reselect = require('reselect');
var localeFR = require('antd/es/locale/fr_FR');
var localeEN = require('antd/es/locale/en_US');
var moment = require('moment');
require('moment/locale/fr');
require('antd/dist/antd.min.css');
var icons = require('@ant-design/icons');
var classNames = require('classnames');
var reactBeforeunload = require('react-beforeunload');
var redux = require('redux');
var reduxDevtoolsExtension = require('redux-devtools-extension');
var createSagaMiddleware = require('redux-saga');
var history$1 = require('history');
var effects = require('redux-saga/effects');
var i18n = require('i18next');
var LanguageDetector = require('i18next-browser-languagedetector');
var axios = require('axios');
var _ = require('lodash');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
var localeFR__default = /*#__PURE__*/_interopDefaultLegacy(localeFR);
var localeEN__default = /*#__PURE__*/_interopDefaultLegacy(localeEN);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var createSagaMiddleware__default = /*#__PURE__*/_interopDefaultLegacy(createSagaMiddleware);
var i18n__default = /*#__PURE__*/_interopDefaultLegacy(i18n);
var LanguageDetector__default = /*#__PURE__*/_interopDefaultLegacy(LanguageDetector);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var ___default = /*#__PURE__*/_interopDefaultLegacy(_);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$x = ".ant-layout-sider {\n  background: #42a8dc;\n}\n\n.styles-module_container__AvrVG {\n  padding: 30px 25px;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  flex-grow: 1;\n}\n@media only screen and (max-width: 990px) {\n  .styles-module_container__AvrVG {\n    padding: 30px 20px;\n  }\n}\n.styles-module_container__AvrVG .styles-module_divider__j6cKb {\n  margin-top: 25px;\n  margin-left: -25px;\n  margin-right: -25px;\n  width: auto;\n  padding: 0px;\n}\n@media only screen and (max-width: 990px) {\n  .styles-module_container__AvrVG .styles-module_divider__j6cKb {\n    margin-left: -20px;\n    margin-right: -20px;\n  }\n}\n.styles-module_container__AvrVG .styles-module_title__P9oFI {\n  font-size: 20px;\n  font-weight: bold;\n}\n.styles-module_container__AvrVG .styles-module_subtitle__ErA8F {\n  font-size: 11px;\n}\n.styles-module_container__AvrVG .styles-module_userInfoContainer__uT-l6 {\n  padding: 12px 0px;\n  display: flex;\n  flex-direction: column;\n}\n.styles-module_container__AvrVG .styles-module_userInfoContainer__uT-l6 .styles-module_userContent__tDBlZ {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-bottom: 15px;\n}\n.styles-module_container__AvrVG .styles-module_userInfoContainer__uT-l6 .styles-module_userContent__tDBlZ .styles-module_leftSide__Y0-JI {\n  flex: 1;\n}\n.styles-module_container__AvrVG .styles-module_userInfoContainer__uT-l6 .styles-module_userContent__tDBlZ .styles-module_rightSide__1vllB {\n  flex: 1;\n}\n.styles-module_container__AvrVG .styles-module_userInfoContainer__uT-l6 .styles-module_label__HjPmE {\n  font-size: 10px;\n}\n.styles-module_container__AvrVG .styles-module_userInfoContainer__uT-l6 .styles-module_content__2XkEg {\n  font-size: 16px;\n  font-weight: bold;\n}\n.styles-module_container__AvrVG .styles-module_userInfoContainer__uT-l6 .styles-module_fieldset__DPvY4 {\n  border: 1px solid #ffffff;\n  border-radius: 4px;\n  padding: 5px 10px;\n  margin: 0px;\n}\n.styles-module_container__AvrVG .styles-module_userInfoContainer__uT-l6 .styles-module_fieldset__DPvY4 legend {\n  font-size: 16px;\n  width: unset;\n  margin: 0;\n  padding: 0 8px;\n}\n.styles-module_container__AvrVG .styles-module_userInfoContainer__uT-l6 .styles-module_fieldset__DPvY4 > .styles-module_userContent__tDBlZ:last-child {\n  padding-bottom: 0px;\n}";
var classes$w = {"container":"styles-module_container__AvrVG","divider":"styles-module_divider__j6cKb","title":"styles-module_title__P9oFI","subtitle":"styles-module_subtitle__ErA8F","userInfoContainer":"styles-module_userInfoContainer__uT-l6","userContent":"styles-module_userContent__tDBlZ","leftSide":"styles-module_leftSide__Y0-JI","rightSide":"styles-module_rightSide__1vllB","label":"styles-module_label__HjPmE","content":"styles-module_content__2XkEg","fieldset":"styles-module_fieldset__DPvY4"};
styleInject(css_248z$x);

var stateSelectorHandle$w = reselect.createSelector(function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.nearestAge; }, function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.smoker; }, function (userAge, userSmoker) {
    return {
        userAge: userAge,
        userSmoker: userSmoker,
    };
});
var LeftSide = function (_a) {
    var _b, _c, _d;
    var initialData = _a.initialData;
    var t = reactI18next.useTranslation().t;
    var stateSelector = React.useCallback(stateSelectorHandle$w, []);
    var _e = reactRedux.useSelector(stateSelector), userAge = _e.userAge, userSmoker = _e.userSmoker;
    console.log("::: LeftSide -> initialData", initialData);
    var address = ((_b = initialData === null || initialData === void 0 ? void 0 : initialData.address) === null || _b === void 0 ? void 0 : _b.trim()) ? initialData.address : "";
    var city = ((_c = initialData === null || initialData === void 0 ? void 0 : initialData.city) === null || _c === void 0 ? void 0 : _c.trim()) ? initialData.city : "";
    var postalCode = ((_d = initialData === null || initialData === void 0 ? void 0 : initialData.postal_code) === null || _d === void 0 ? void 0 : _d.trim()) ? initialData.postal_code
        : "";
    var addressText = "";
    if (address && city && postalCode) {
        addressText = address + ", " + city + ", " + postalCode;
    }
    else if (address && city) {
        addressText = address + ", " + city;
    }
    else if (address) {
        addressText = "" + address;
    }
    else if (city && postalCode) {
        addressText = city + ", " + postalCode;
    }
    else if (city) {
        addressText = "" + city;
    }
    else if (postalCode) {
        addressText = "" + postalCode;
    }
    else {
        addressText = "";
    }
    return (React__default["default"].createElement("div", { className: classes$w.container },
        React__default["default"].createElement("div", { className: classes$w.title }, t("Applicant Information")),
        initialData.updated_at && (React__default["default"].createElement("div", { className: classes$w.subtitle },
            t("Last update on"),
            " ",
            initialData.updated_at)),
        React__default["default"].createElement("div", { className: classes$w.userInfoContainer },
            React__default["default"].createElement("div", { className: classes$w.userContent },
                React__default["default"].createElement("div", { className: classes$w.rightSide },
                    React__default["default"].createElement("div", { className: classes$w.label },
                        t("First Name"),
                        ":"),
                    React__default["default"].createElement("div", { className: classes$w.content }, initialData.first_name
                        ? initialData.first_name
                        : "")),
                React__default["default"].createElement("div", { className: classes$w.leftSide },
                    React__default["default"].createElement("div", { className: classes$w.label },
                        t("Last Name"),
                        ":"),
                    React__default["default"].createElement("div", { className: classes$w.content }, initialData.last_name ? initialData.last_name : ""))),
            React__default["default"].createElement("div", { className: classes$w.userContent },
                React__default["default"].createElement("div", { className: classes$w.leftSide },
                    React__default["default"].createElement("div", { className: classes$w.label },
                        t("Phone Number"),
                        ":"),
                    React__default["default"].createElement("div", { className: classes$w.content }, initialData.phone ? initialData.phone : "")),
                React__default["default"].createElement("div", { className: classes$w.rightSide },
                    React__default["default"].createElement("div", { className: classes$w.label },
                        t("Email"),
                        ":"),
                    React__default["default"].createElement("div", { className: classes$w.content }, initialData.email ? initialData.email : ""))),
            React__default["default"].createElement("div", { className: classes$w.userContent },
                React__default["default"].createElement("div", { className: classes$w.leftSide },
                    React__default["default"].createElement("div", { className: classes$w.label },
                        t("Province"),
                        ":"),
                    React__default["default"].createElement("div", { className: classes$w.content }, initialData.province ? initialData.province : ""))),
            React__default["default"].createElement("fieldset", { className: classes$w.fieldset },
                React__default["default"].createElement("legend", null, t("Pre-filled data")),
                React__default["default"].createElement("div", { className: classes$w.userContent },
                    React__default["default"].createElement("div", { className: classes$w.leftSide },
                        React__default["default"].createElement("div", { className: classes$w.label },
                            t("Date of birth"),
                            ":"),
                        React__default["default"].createElement("div", { className: classes$w.content }, initialData.dob ? initialData.dob : "")),
                    React__default["default"].createElement("div", { className: classes$w.rightSide },
                        React__default["default"].createElement("div", { className: classes$w.label },
                            t("Nearest Age"),
                            ":"),
                        React__default["default"].createElement("div", { className: classes$w.content }, userAge != null
                            ? userAge < 1
                                ? t("under one year")
                                : userAge
                            : "-"))),
                React__default["default"].createElement("div", { className: classes$w.userContent },
                    React__default["default"].createElement("div", { className: classes$w.leftSide },
                        React__default["default"].createElement("div", { className: classes$w.label },
                            t("Gender"),
                            ":"),
                        React__default["default"].createElement("div", { className: classes$w.content }, (initialData.gender === "m" && t("Male")) ||
                            (initialData.gender === "f" &&
                                t("Female")) ||
                            "")),
                    React__default["default"].createElement("div", { className: classes$w.rightSide },
                        React__default["default"].createElement("div", { className: classes$w.label },
                            t("Smoking status"),
                            ":"),
                        React__default["default"].createElement("div", { className: classes$w.content }, userSmoker && parseInt(userSmoker) === 1
                            ? t("Yes")
                            : t("No")))),
                React__default["default"].createElement("div", { className: classes$w.userContent },
                    React__default["default"].createElement("div", { className: classes$w.leftSide },
                        React__default["default"].createElement("div", { className: classes$w.label },
                            t("Address"),
                            ":"),
                        React__default["default"].createElement("div", { className: classes$w.content }, addressText))))),
        React__default["default"].createElement(antd.Divider, { className: classes$w.divider }),
        React__default["default"].createElement(QuestionsList$1, null)));
};
var LeftSide$1 = React.memo(LeftSide);

var css_248z$w = ".styles-module_container__wD2nJ {\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  flex-grow: 1;\n  height: 100%;\n  overflow: auto;\n  padding: 70px 100px 70px 100px;\n  position: relative;\n  z-index: 1;\n}\n.styles-module_container__wD2nJ.styles-module_containerForFieldVersion__5bXEP {\n  padding-top: 25px;\n}\n.styles-module_container__wD2nJ .styles-module_video__z6IG7 {\n  position: fixed;\n  /* Sit on top of the page content */\n  width: 100%;\n  /* Full width (cover the whole page) */\n  height: 100%;\n  /* Full height (cover the whole page) */\n  top: 40px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-size: contain;\n  background-image: none;\n  background: white;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.85) 25%, rgba(255, 255, 255, 0.85) 75%, rgba(255, 255, 255, 0.7) 100%);\n}\n.styles-module_container__wD2nJ .styles-module_closeIcon__hkPx7 {\n  font-size: 18px;\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  cursor: pointer;\n  z-index: 999;\n  color: #333333;\n  color: #777;\n  border: 1px solid;\n  padding: 0px 8px;\n}\n.styles-module_container__wD2nJ .styles-module_closeIcon__hkPx7.styles-module_callCenterTopPosition__nfRYW {\n  top: 0px;\n}\n.styles-module_container__wD2nJ .styles-module_menuIcon__LHpRT {\n  font-size: 24px;\n  position: absolute;\n  top: 30px;\n  left: 30px;\n  cursor: pointer;\n  color: #333333;\n  z-index: 1;\n}\n.styles-module_container__wD2nJ .styles-module_menuIcon__LHpRT.styles-module_blackMenuIcon__IVI3- {\n  color: #000000;\n}\n.styles-module_container__wD2nJ .styles-module_menuIcon__LHpRT.styles-module_rippleEffect__eYh6f {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 40px;\n  top: 20px;\n  border-radius: 100%;\n  background: transparent;\n  box-shadow: 0 0 20px 0 rgba(255, 0, 0, 0.25);\n}\n.styles-module_container__wD2nJ .styles-module_menuIcon__LHpRT.styles-module_rippleEffect__eYh6f span {\n  position: relative;\n  font-size: 72px;\n  top: 5px;\n  left: -5px;\n}\n.styles-module_container__wD2nJ .styles-module_menuIcon__LHpRT.styles-module_rippleEffect__eYh6f::after {\n  opacity: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  content: \"\";\n  height: 100%;\n  width: 100%;\n  border: 8px solid rgba(255, 0, 0, 0.2);\n  border-radius: 100%;\n  animation-name: styles-module_ripple__MRrhq;\n  animation-duration: 3s;\n  animation-delay: 0s;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);\n  z-index: -1;\n}\n.styles-module_container__wD2nJ .styles-module_menuIcon__LHpRT.styles-module_rippleEffect__eYh6f::before {\n  opacity: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  content: \"\";\n  height: 100%;\n  width: 100%;\n  border: 8px solid rgba(255, 0, 0, 0.2);\n  border-radius: 100%;\n  animation-name: styles-module_ripple__MRrhq;\n  animation-duration: 3s;\n  animation-delay: 0.5s;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);\n  z-index: -1;\n}\n@keyframes styles-module_ripple__MRrhq {\n  from {\n    opacity: 1;\n    transform: scale3d(0.75, 0.75, 1);\n  }\n  to {\n    opacity: 0;\n    transform: scale3d(1.5, 1.5, 1);\n  }\n}\n.styles-module_container__wD2nJ .styles-module_menuIcon__LHpRT.styles-module_callCenterTopPosition__nfRYW {\n  top: 0px;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_title__v3jRj {\n  text-align: center;\n  color: #42a8dc;\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 {\n  flex: 1;\n  max-width: 400px;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61:first-child {\n  margin-right: 10px;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61:nth-child(2) {\n  margin-left: 10px;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background: #f4f4f4;\n  margin-bottom: 5px;\n  padding: 4px 10px;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik .styles-module_leftSide__gfUbF {\n  display: flex;\n  flex-direction: row;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik .styles-module_leftSide__gfUbF > div:first-child {\n  margin-right: 10px;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik .styles-module_leftSide__gfUbF > div:nth-child(2) {\n  color: #000000;\n  font-size: 12px;\n  line-height: 23px;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik .styles-module_rightSide__bbyvs {\n  font-size: 12px;\n  color: #000000;\n  line-height: 23px;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik .styles-module_boldText__ziBsB {\n  font-weight: bold;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik.styles-module_disabled__JnYnE .styles-module_checkCircleFilled__FBBMN,\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik.styles-module_disabled__JnYnE .styles-module_normalText__LZfqy {\n  opacity: 0.5;\n  cursor: default;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik.styles-module_inactiveList__9hevi .styles-module_leftSide__gfUbF > div:nth-child(2) {\n  color: #b5b5b5;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik.styles-module_inactiveList__9hevi .styles-module_rightSide__bbyvs {\n  color: #b5b5b5;\n}\n.styles-module_container__wD2nJ .styles-module_topContent__XPu4t .styles-module_listContent__SjM61 .styles-module_listElement__v8Mik.styles-module_cursorPointer__sNhbM {\n  cursor: pointer;\n}\n.styles-module_container__wD2nJ video {\n  position: absolute;\n  left: 0;\n  top: 0;\n  min-width: 100%;\n  min-height: 100%;\n  width: 100%;\n  object-fit: cover;\n  height: 100%;\n}";
var classes$v = {"container":"styles-module_container__wD2nJ","containerForFieldVersion":"styles-module_containerForFieldVersion__5bXEP","video":"styles-module_video__z6IG7","closeIcon":"styles-module_closeIcon__hkPx7","callCenterTopPosition":"styles-module_callCenterTopPosition__nfRYW","menuIcon":"styles-module_menuIcon__LHpRT","blackMenuIcon":"styles-module_blackMenuIcon__IVI3-","rippleEffect":"styles-module_rippleEffect__eYh6f","ripple":"styles-module_ripple__MRrhq","topContent":"styles-module_topContent__XPu4t","title":"styles-module_title__v3jRj","listContent":"styles-module_listContent__SjM61","listElement":"styles-module_listElement__v8Mik","leftSide":"styles-module_leftSide__gfUbF","rightSide":"styles-module_rightSide__bbyvs","boldText":"styles-module_boldText__ziBsB","disabled":"styles-module_disabled__JnYnE","checkCircleFilled":"styles-module_checkCircleFilled__FBBMN","normalText":"styles-module_normalText__LZfqy","inactiveList":"styles-module_inactiveList__9hevi","cursorPointer":"styles-module_cursorPointer__sNhbM"};
styleInject(css_248z$w);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

// ENUMS
var EAppActionTypes;
(function (EAppActionTypes) {
    EAppActionTypes["resetStore"] = "reset/store";
    EAppActionTypes["resetStoreSuccess"] = "reset/store/success";
    EAppActionTypes["initFinalAssessment"] = "app/init/finalAssessment";
    EAppActionTypes["finalAssessmentSetRateTerms"] = "finalAssessmentTerms/set/rateTerms";
    EAppActionTypes["finalAssessmentSetOrderedTerms"] = "finalAssessmentTerms/set/orderedTerms";
    EAppActionTypes["fieldApplicationSetBackground"] = "fieldApplication/set/background";
    EAppActionTypes["appSetCanTheAssessmentBeStopped"] = "app/canTheAssessmentBeStopped/set";
    EAppActionTypes["appLoadingSet"] = "app/loading/set";
    EAppActionTypes["appInit"] = "app/init";
    EAppActionTypes["appInitOneSignal"] = "app/oneSignal/init";
    EAppActionTypes["appOneSignalSetInitialized"] = "app/oneSignal/set/init";
    EAppActionTypes["appOneSignalSetId"] = "app/oneSignal/id/set";
    EAppActionTypes["appOneSignalResetId"] = "app/oneSignal/id/reset";
    EAppActionTypes["appInitSet"] = "app/init/set";
    EAppActionTypes["appSetUser"] = "app/set/user";
    EAppActionTypes["appSetData"] = "app/set/data";
    EAppActionTypes["appSetGroup"] = "app/set/group";
    EAppActionTypes["appChangeCommunity"] = "app/change/community";
    EAppActionTypes["updateMessageCounter"] = "app/messageCounter/update";
    EAppActionTypes["toggleSider"] = "app/sider/toggle";
    EAppActionTypes["toggleReaderActive"] = "app/readerActive/toggle";
    EAppActionTypes["setApplicationForceGI"] = "app/set/application/forceGI";
    EAppActionTypes["setApplicationApproved"] = "app/set/application/approved";
    EAppActionTypes["setTheApplicantAgeIsTooLow"] = "app/set/application/the/applicant/age/is/too/low";
    EAppActionTypes["setApplicationGeneralDetails"] = "app/set/application/general/details";
    EAppActionTypes["setShowJenieAssistDrawer"] = "app/set/show/jenie/assist/drawer";
    EAppActionTypes["setTheQuestionnaireStarted"] = "app/set/the/questionnaire/started";
    EAppActionTypes["setHasUsedVoice"] = "app/set/has/used/voice";
    EAppActionTypes["setUseJuvenileProduct"] = "app/set/use/juvenile/product";
    EAppActionTypes["setFinalAssessmentTermAddEverest"] = "app/set/final/assessment/term/add/everest";
})(EAppActionTypes || (EAppActionTypes = {}));
// INTERFACES
var EEnv;
(function (EEnv) {
    EEnv["development"] = "development";
    EEnv["production"] = "production";
})(EEnv || (EEnv = {}));

// ENUMS
var EProductActionTypes;
(function (EProductActionTypes) {
    EProductActionTypes["productLoadingSet"] = "product/set/loading";
    EProductActionTypes["setProduct"] = "product/set";
    EProductActionTypes["getProduct"] = "product/get";
})(EProductActionTypes || (EProductActionTypes = {}));

// ENUMS
var EProductsActionTypes;
(function (EProductsActionTypes) {
    EProductsActionTypes["productsLoadingSet"] = "products/set/loading";
    EProductsActionTypes["getProducts"] = "products/get";
    EProductsActionTypes["setProducts"] = "products/set";
    EProductsActionTypes["setProductsQuery"] = "products/query/set";
})(EProductsActionTypes || (EProductsActionTypes = {}));
// INTERFACES
var EProducts;
(function (EProducts) {
    EProducts["LifeTermJuvenilesProduct"] = "LifeTermJuvenilesProduct";
    EProducts["LifeTermProduct"] = "LifeTermProduct";
})(EProducts || (EProducts = {}));

// ENUMS
var EQuestionActionTypes;
(function (EQuestionActionTypes) {
    EQuestionActionTypes["questionLoadingSet"] = "question/set/loading";
    EQuestionActionTypes["setQuestion"] = "question/set";
    EQuestionActionTypes["setPrevQuestion"] = "question/set/prev";
    EQuestionActionTypes["setNextQuestion"] = "question/set/next";
    EQuestionActionTypes["updateQuestion"] = "question/update";
    EQuestionActionTypes["getQuestion"] = "question/get";
    EQuestionActionTypes["answerQuestion"] = "question/answer";
    EQuestionActionTypes["answerGroupedQuestion"] = "answer/grouped/question";
    EQuestionActionTypes["setPrepopulateQuestion"] = "question/set/prepopulate";
    EQuestionActionTypes["setGroupedQuestions"] = "questions/set/grouped/questions";
})(EQuestionActionTypes || (EQuestionActionTypes = {}));

// ENUMS
var EQuestionsActionTypes;
(function (EQuestionsActionTypes) {
    EQuestionsActionTypes["questionsLoadingSet"] = "questions/set/loading";
    EQuestionsActionTypes["getQuestions"] = "questions/get";
    EQuestionsActionTypes["setQuestions"] = "questions/set";
    EQuestionsActionTypes["setQuery"] = "questions/query/set";
    EQuestionsActionTypes["initQuestions"] = "questions/query/init";
    EQuestionsActionTypes["setFormatedQuestions"] = "questions/formattedQuestions/set";
    EQuestionsActionTypes["setNewRasPayload"] = "questions/newRasPayload/set";
    EQuestionsActionTypes["setLoadingValue"] = "questions/assessmentLoadingValue/set";
    EQuestionsActionTypes["setFinalQuestion"] = "questions/finalQuestion/set";
    EQuestionsActionTypes["setQuestionnaireResolution"] = "questions/set/resolution";
    EQuestionsActionTypes["setQuestionnaireCompleted"] = "questions/set/questionnaire/completed";
    EQuestionsActionTypes["setCompletePrequalificationAssessmentAnswer"] = "questions/set/complete/prequalification/assesment/answer";
    EQuestionsActionTypes["setCompletePrequalificationAssessmentIsCompleted"] = "questions/set/complete/prequalification/assesment/is/completed";
})(EQuestionsActionTypes || (EQuestionsActionTypes = {}));

// ENUMS
var EUserActionTypes;
(function (EUserActionTypes) {
    EUserActionTypes["userLoadingSet"] = "user/set/loading";
    EUserActionTypes["setUser"] = "user/set";
    EUserActionTypes["updateUser"] = "user/update";
    EUserActionTypes["getUser"] = "user/get";
    EUserActionTypes["answerUser"] = "user/answer";
    EUserActionTypes["setRealAge"] = "user/set/real/age";
    EUserActionTypes["setSmoker"] = "user/set/smoker";
    EUserActionTypes["setSmokerFE"] = "user/set/smokerFE";
    EUserActionTypes["setCurrentStatusInCanada"] = "user/set/current/status/canada";
    EUserActionTypes["setBankruptcyStatus"] = "user/set/bankruptcy/status";
})(EUserActionTypes || (EUserActionTypes = {}));
var ECurrentStatusInCanada;
(function (ECurrentStatusInCanada) {
    ECurrentStatusInCanada["CanadianCitizen"] = "CanadianCitizen";
    ECurrentStatusInCanada["LandedImmigrantPermanentResident"] = "LandedImmigrantPermanentResident";
    ECurrentStatusInCanada["Refugee"] = "Refugee";
    ECurrentStatusInCanada["StudentVisa"] = "StudentVisa";
    ECurrentStatusInCanada["SuperVisa"] = "SuperVisa";
    ECurrentStatusInCanada["WorkingPermit"] = "WorkingPermit";
})(ECurrentStatusInCanada || (ECurrentStatusInCanada = {}));

// ENUMS
var ETermsAndRisksActionTypes;
(function (ETermsAndRisksActionTypes) {
    ETermsAndRisksActionTypes["termsAndRisksLoadingSet"] = "termsAndRisks/set/loading";
    ETermsAndRisksActionTypes["getTermsAndRisks"] = "termsAndRisks/get";
    ETermsAndRisksActionTypes["setTermsAndRisks"] = "termsAndRisks/set";
    ETermsAndRisksActionTypes["getFinalAssessmentTermsAndRisks"] = "termsAndRisks/finalAssessment/get";
    ETermsAndRisksActionTypes["setFinalAssessmentTermsAndRisks"] = "termsAndRisks/finalAssessment/set";
    ETermsAndRisksActionTypes["setTermsAndRisksQuery"] = "termsAndRisks/query/set";
    ETermsAndRisksActionTypes["setTerm"] = "termsAndRisks/terms/set";
    ETermsAndRisksActionTypes["setTermAndComputedRisk"] = "termsAndRisks/termAndComputedRisk/set";
    ETermsAndRisksActionTypes["setCoverage"] = "termsAndRisks/coverage/set";
    ETermsAndRisksActionTypes["computeCoverageMinMax"] = "termsAndRisks/coverageMinMax/compute";
    ETermsAndRisksActionTypes["setDisabledTermsAccordingToApplicantAge"] = "termsAndRisks/disabledTermsAccordingToApplicantAge/set";
    ETermsAndRisksActionTypes["setRatesDetails"] = "termsAndRisks/ratesDetails/set";
    ETermsAndRisksActionTypes["setFinalAssessmentRatesDetails"] = "termsAndRisks/finalAssessment/ratesDetails/set";
    ETermsAndRisksActionTypes["getRatesMatch"] = "termsAndRisks/ratesMatch/get";
    ETermsAndRisksActionTypes["getFinalAssessmentRatesMatch"] = "termsAndRisks/finalAssessment/ratesMatch/get";
    ETermsAndRisksActionTypes["setEligibleProducts"] = "termsAndRisks/eligibleProducts/set";
    ETermsAndRisksActionTypes["getEligibleProducts"] = "termsAndRisks/eligibleProducts/get";
    ETermsAndRisksActionTypes["setCICoverage"] = "termsAndRisks/set/CICoverage";
})(ETermsAndRisksActionTypes || (ETermsAndRisksActionTypes = {}));
// INTERFACES
var EShowGp;
(function (EShowGp) {
    EShowGp["FiveToT100"] = "FiveToT100";
    EShowGp["chubb"] = "chubb";
    EShowGp["all"] = "all";
})(EShowGp || (EShowGp = {}));
var EProductTerm;
(function (EProductTerm) {
    EProductTerm["FiveToT100"] = "FiveToT100";
    EProductTerm["chubb"] = "chubb";
    EProductTerm[EProductTerm["T10"] = 10] = "T10";
    EProductTerm[EProductTerm["T20"] = 20] = "T20";
    EProductTerm[EProductTerm["T30"] = 30] = "T30";
    EProductTerm[EProductTerm["T100"] = 100] = "T100";
    EProductTerm[EProductTerm["JuvenileLife"] = 1] = "JuvenileLife";
    EProductTerm[EProductTerm["JuvenileCI"] = 2] = "JuvenileCI";
})(EProductTerm || (EProductTerm = {}));
var EMaxAndMinTermAndRisk;
(function (EMaxAndMinTermAndRisk) {
    EMaxAndMinTermAndRisk[EMaxAndMinTermAndRisk["maxSureAndEvolutionProductsTerm"] = 100] = "maxSureAndEvolutionProductsTerm";
    EMaxAndMinTermAndRisk[EMaxAndMinTermAndRisk["minSureAndEvolutionProductsTerm"] = 10] = "minSureAndEvolutionProductsTerm";
    EMaxAndMinTermAndRisk[EMaxAndMinTermAndRisk["maxJuvenileProductsTerm"] = 2] = "maxJuvenileProductsTerm";
    EMaxAndMinTermAndRisk[EMaxAndMinTermAndRisk["minJuvenileProductsTerm"] = 1] = "minJuvenileProductsTerm";
    EMaxAndMinTermAndRisk[EMaxAndMinTermAndRisk["maxSureAndEvolutionProductsRisk"] = 5] = "maxSureAndEvolutionProductsRisk";
    EMaxAndMinTermAndRisk[EMaxAndMinTermAndRisk["minSureAndEvolutionProductsRisk"] = 1] = "minSureAndEvolutionProductsRisk";
    EMaxAndMinTermAndRisk[EMaxAndMinTermAndRisk["maxJuvenileProductsRisk"] = 4] = "maxJuvenileProductsRisk";
    EMaxAndMinTermAndRisk[EMaxAndMinTermAndRisk["minJuvenileProductsRisk"] = 1] = "minJuvenileProductsRisk";
})(EMaxAndMinTermAndRisk || (EMaxAndMinTermAndRisk = {}));
var ETermKey;
(function (ETermKey) {
    ETermKey["highest"] = "highest";
    ETermKey["lowest"] = "lowest";
    ETermKey["secondLowest"] = "secondLowest";
    ETermKey["thirdLowest"] = "thirdLowest";
})(ETermKey || (ETermKey = {}));

function appInitHandle(data) {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.put(setAppLoading(true))];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 6]);
                return [4 /*yield*/, effects.put(setAppLoading(false))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                error_1 = _a.sent();
                return [4 /*yield*/, effects.put(setAppLoading(false))];
            case 5:
                _a.sent();
                console.log({ error: error_1 });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function rootSaga$6() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([effects.takeEvery(EAppActionTypes.appInit, appInitHandle)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

function setProductHandle(_a) {
    var error_1;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                return [4 /*yield*/, effects.put(setProductLoading(true))];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects.put(setProduct(payload))];
            case 2:
                _b.sent();
                return [4 /*yield*/, effects.put(setProductLoading(false))];
            case 3:
                _b.sent();
                return [3 /*break*/, 5];
            case 4:
                error_1 = _b.sent();
                console.log({ error: error_1 });
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function rootSaga$5() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([effects.takeEvery(EProductActionTypes.getProduct, setProductHandle)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

var en = {
    translation: {
        english: "english",
        "Applicant Information": "Applicant Information",
        Name: "Name",
        "Middle Name": "Middle Name",
        "Phone Number": "Phone Number",
        Email: "Email",
        Province: "Province",
        "Pre-filled data": "Pre-filled data",
        "Date of birth": "Date of birth",
        "Smoking status": "Smoking status",
        Address: "Address",
        "No Data": "No Data",
        Coverage: "Coverage",
        Terms: "Terms",
        Risk: "Risk",
        month: "month",
        Completed: "Completed",
        False: "False",
        True: "True",
        "Results are temporary and they can change based on the answers on the rest of the questions": "Results are temporary and they can change based on the answers on the rest of the questions",
        Resolution: "Resolution",
        resolution: "résolution",
        Accept: "Accept",
        Decline: "Decline",
        Offer: "Offer",
        Question: "Question",
        "Application Details": "Application Details",
        "Previous question": "Previous question",
        "Next question": "Next question",
        "Finish & Proceed": "Finish & Proceed",
        Gender: "Gender",
        No: "No",
        Yes: "Yes",
        "search country": "search country",
        "search region": "search region",
        "First Name": "First Name",
        "Last Name": "Last Name",
        Evolution: "Evolution",
        Advance: "Advance",
        "Stop Reading Questions": "Stop Reading Questions",
        "Start Reading Questions": "Start Reading Questions",
        "Let's get started": "Let's get started",
        welcomeUser: "Hello, my name is Jenie!\n      <br />\n      I'm here to assist you and the applicant with the underwriting assessment process.\n      <br />\n      I will only ask a few questions.\n      <br />\n      The process takes 15 minutes on average.\n      <br />\n      You or the applicant may choose to stop at any time!\n      <br />\n      But by doing so, my assessment may be incomplete and result in only Guaranteed issue option!\n\t",
        IntroMessageUserSpeech: "Hello, my name is Jenie! I'm here to assist you and the applicant with the underwriting assessment process. I will only ask a few questions. The process takes 15 minutes on average. You or the applicant may choose to stop at any time! But by doing so, my assessment may be incomplete and result in only Guaranteed issue option!",
        "input search text": "input search text",
        "Please select": "Please select",
        "Please, add a number": "Please, add a number",
        "Stop the assessment process": "Stop the assessment process",
        "Proceed to the application": "Proceed to the application",
        "Please review your answers before proceeding!": "Please review your answers before proceeding!",
        Review: "Review",
        Proceed: "Proceed",
        "My initial assessment suggests that the applicant may qualify for": "My initial assessment suggests that the applicant may qualify for",
        "Please select your terms of choice, with combined maximum face amount up to": "Please select your terms of choice, with combined maximum face amount up to",
        "Max. value": "Max. value",
        "Total Amount": "Total Amount",
        "Monthly Total Premium": "Monthly Total Premium",
        "Please click here to complete the application": "Please click here to complete the application",
        Required: "Required",
        Background: "Background",
        White: "White",
        Complete: "Complete",
        incompleteAssessmentEvolutionEssenceT100: "Assessment is incomplete! By finishing it now, the applicant would not be able to return to the assessment and most likely can <1>only qualify for Evolution Essence Term 100.</1> Please confirm",
        "Yes, finish the assessment": "Yes, finish the assessment",
        "No, I would like to continue": "No, I would like to continue",
        "Complete the application": "Complete the application",
        "Please review your options before proceeding!": "Please review your options before proceeding!",
        "Our T100 is in the last stages of development and will be available shortly": "Our T100 is in the last stages of development and will be available shortly",
        "Please select another plan": "Please select another plan",
        "Unfortunately, Evolution Life insurance application cannot be considered at this time!": "Unfortunately, Evolution Life insurance application cannot be considered at this time!",
        Live: "Live",
        Male: "Male",
        Female: "Female",
        "Negative values are not allowed.": "Negative values are not allowed.",
        "Nearest Age": "Nearest Age",
        ft: "ft",
        ins: "ins",
        "Guaranteed Protection": "Guaranteed Protection",
        "Please select Evolution Essence or one of the following options.": "Please select Evolution Essence or one of the following options.",
        "Final Expense": "Final Expense",
        "level premiums": "level premiums",
        "quinquennial premiums": "quinquennial premiums",
        "Save & Close": "Save & Close",
        "type here": "type here",
        "type here and select": "type here and select",
        "The medical prequalification assessment is in progress": "The medical prequalification assessment is ",
        "Medical prequalification assessment is completed, click on Jenie Assist to check the results": "Medical prequalification assessment is ___completed___ click on Jenie Assist to check the results",
        ___completed___: "completed,",
        ___in_progress___: "in progress",
        "Height and Weight": "Height and Weight",
        Medical: "Medical",
        Employment: "Employment",
        Juvenile: "Juvenile",
        "Evolution Jr. Standard": "Evolution Jr. Standard",
        "Evolution Jr. Guaranteed Issued": "Evolution Jr. Guaranteed Issued",
        Standard: "Standard",
        "Guaranteed Issued": "Guaranteed Issued",
        "Evolution Jr. Critical Illness": "Evolution Jr. Critical Illness",
        "Evolution Jr. Life": "Evolution Jr. Life",
        "Evolution Jr. CI Standard": "Evolution Jr. CI Standard",
        "Evolution Jr. CI GI": "Evolution Jr. CI GI",
        "Please select one of the following options.": "Please select one of the following options.",
        "Jr. Standard": "Jr. Standard",
        "Jr. Guaranteed Issued": "Jr. Guaranteed Issued",
        "Jr. Critical Illness": "Jr. Critical Illness",
        "Jr. Life": "Jr. Life",
        "Jr. CI Standard": "Jr. CI Standard",
        "Jr. CI GI": "Jr. CI GI",
        incompleteAssessmentSureTerm100: "Assessment is incomplete! By finishing it now, the applicant would not be able to return to the assessment and most likely can <1>only qualify for Sure Term 100 Bronze.</1> Please confirm.",
        "under one year": "under one year",
        "Something went wrong": "Something went wrong",
    },
};

var fr = {
    translation: {
        english: "freeeeeeebbc",
        "Applicant Information": "Information sur le requérant",
        Name: "Nom",
        "Middle Name": "Deuxième prénom",
        "Phone Number": "Numéro de téléphone",
        Email: "Courriel",
        Province: "Province",
        "Pre-filled data": "Données préremplies",
        "Date of birth": "Date de naissance",
        "Smoking status": "Statut de fumeur/non-fumeur",
        Address: "Adresse",
        "No Data": "Aucune donnée",
        Coverage: "Couverture",
        Terms: "Temporaire",
        Risk: "Classe de risque",
        month: "mois",
        Completed: "Rempli",
        False: "Faux",
        True: "Vrai",
        "Results are temporary and they can change based on the answers on the rest of the questions": "Les résultats sont temporaires et peuvent changer en fonction des réponses aux autres questions",
        Resolution: "Résolution",
        resolution: "résolution",
        Accept: "Accepté",
        Decline: "Refusé",
        Offer: "Offre",
        Question: "Question",
        "Application Details": "Détails de la demande",
        "Previous question": "Question précédente",
        "Next question": "Question suivante",
        "Finish & Proceed": "Terminer et Continuer",
        Gender: "Le sexe",
        No: "Non",
        Yes: "Oui",
        "search country": "recherche pays",
        "search region": "région de recherche",
        "First Name": "Prénom",
        "Last Name": "Nom de famille",
        Evolution: "Évolution",
        Advance: "Avantage",
        "Stop Reading Questions": "Arrêtez de lire les questions",
        "Start Reading Questions": "Commencer à lire les questions",
        "Let's get started": "Commençons!",
        welcomeUser: "Bonjour, je m\u2019appelle Jenie!\n      <br />\n      Je suis ici pour vous aider avec la souscription de votre produit d\u2019assurance.\n      <br />\n      Je vous poserai quelques questions.\n      <br />\n      Le processus prendra environ 15 minutes.\n      <br />\n      Vous pouvez choisir d\u2019arr\u00EAter \u00E0 tout moment!\n      <br />\n      Mais en faisant ceci, mon \u00E9valuation pourrait \u00EAtre incompl\u00E8te et vous qualifieras pour notre protection Garantie. Allons-y!      \n\t",
        IntroMessageUserSpeech: "Bonjour, je m\u2019appelle Jenie! Je suis ici pour vous aider avec la souscription de votre produit d\u2019assurance. Je vous poserai quelques questions. Le processus prendra environ 15 minutes. Vous pouvez choisir d\u2019arr\u00EAter \u00E0 tout moment! Mais en faisant ceci, mon \u00E9valuation pourrait \u00EAtre incompl\u00E8te et vous qualifieras pour notre protection Garantie. Allons-y!",
        "input search text": "Saisir le texte",
        "Please select": "Veuillez sélectionner",
        "Please, add a number": "S'il vous plaît, ajoutez un numéro",
        "Stop the assessment process": "Arrêter le processus d'évaluation",
        "Proceed to the application": "Soumettre la proposition",
        "Please review your answers before proceeding!": "Veuillez revoir vos réponses avant de poursuivre!",
        Review: "Revoir",
        Proceed: "Soumettre",
        "My initial assessment suggests that the applicant may qualify for": "Mon évaluation initiale suggère que le demandeur peut se qualifier pour nos produits Évolution",
        "Please select your terms of choice, with combined maximum face amount up to": "Veuillez sélectionner le(s) produit(s) de votre choix, pour un capital décès maximal combiné allant jusqu'à",
        "Max. value": "Valeur maximale",
        "Total Amount": "Montant total",
        "Monthly Total Premium": "Prime Totale Mensuelle",
        "Please click here to complete the application": "Veuillez cliquer ici pour compléter la proposition",
        "Complete the application": "Soumettre la proposition",
        "Please review your options before proceeding!": "Veuillez revoir vos options avant de poursuivre",
        Required: "Obligatoire",
        Background: "Arrière-plan",
        White: "Blanc",
        Complete: "Terminer",
        incompleteAssessmentEvolutionEssenceT100: "L'évaluation est incomplète ! En arrêtant maintenant, le candidat ne pourra pas revenir à l'évaluation <1>et il se qualifiera pour notre produit Évolution Essentielle T-100.</1> Veuillez confirmer",
        "Yes, finish the assessment": "Oui, terminer l’évaluation",
        "No, I would like to continue": "Non, je veux continuer",
        "Our T100 is in the last stages of development and will be available shortly": "Notre T100 est en phase finale de développement et sera bientôt disponible",
        "Please select another plan": "Svp veuillez choisir un autre produit",
        "Unfortunately, Evolution Life insurance application cannot be considered at this time!": "Malheureusement, la demande d'assurance-vie Évolution ne peut être offerte pour le moment!",
        Live: "en direct",
        Male: "Homme",
        Female: "Femme",
        "Negative values are not allowed.": "Les valeurs négatives ne sont pas autorisées.",
        "Nearest Age": "Âge le plus proche",
        ft: "pi",
        ins: "po",
        "Guaranteed Protection": "Protection Garantie",
        "Please select Evolution Essence or one of the following options.": "Veuillez sélectionner le produit Évolution Essentielle ou l’une des options suivantes.",
        "Final Expense": "Dernier frais",
        "level premiums": "primes nivelées",
        "quinquennial premiums": "primes augmentent aux 5 ans",
        "Save & Close": "Sauvegarder et fermer",
        "type here": "écrivez ici",
        "type here and select": "écrivez ici et sélectionnez",
        "The medical prequalification assessment is in progress": "La préqualification médicale est ",
        "Medical prequalification assessment is completed, click on Jenie Assist to check the results": "La préqualification médicale est ___completed___ cliquez sur Jenie Assiste pour voir le résultat.",
        ___completed___: "terminée,",
        ___in_progress___: "en cours",
        "Height and Weight": "Taille et poids",
        Medical: "Médical",
        Employment: "Activité professionnelle",
        Juvenile: "Juvenile",
        "Evolution Jr. Standard": "Évolution Jr. standard",
        "Evolution Jr. Guaranteed Issued": "Évolution Jr. à émission garantie",
        Standard: "Standard",
        "Guaranteed Issued": "Émission garantie",
        "Evolution Jr. Life": "Évolution Jr. Vie",
        "Evolution Jr. Critical Illness": "Évolution Jr. maladies graves",
        "Evolution Jr. CI Standard": "Évolution Jr. maladies graves standard",
        "Evolution Jr. CI GI": "Évolution Jr. maladies graves à émission garantie",
        "Please select one of the following options.": "Veuillez sélectionner l'une des options suivantes.",
        "Jr. Standard": "Jr. standard",
        "Jr. Guaranteed Issued": "Jr. à émission garantie",
        "Jr. Life": "Jr. Vie",
        "Jr. Critical Illness": "Jr. maladies graves",
        "Jr. CI Standard": "Jr. maladies graves standard",
        "Jr. CI GI": "Jr. maladies graves à émission garantie",
        incompleteAssessmentSureTerm100: "L'évaluation est incomplète ! En arrêtant maintenant, le candidat ne pourra pas revenir à l'évaluation <1>et il se qualifiera pour notre produit Sure Term 100 Bronze.</1> Veuillez confirmer",
        "under one year": "moins d'un an",
        "Something went wrong": "Quelque chose s'est mal passé",
    },
};

var resources = /*#__PURE__*/Object.freeze({
  __proto__: null,
  en: en,
  fr: fr
});

// @ts-ignore
i18n__default["default"].use(reactI18next.initReactI18next)
    .use(LanguageDetector__default["default"])
    .init({
    // we init with resources
    resources: resources,
    whitelist: ["en", "fr"],
    fallbackLng: "en",
    debug: true,
    // have a common namespace used around the full app
    ns: ["translation"],
    defaultNS: "translation",
    keySeparator: false,
    interpolation: {
        escapeValue: false,
    },
    react: {
        wait: true,
    },
});

var setAppLoading = function (payload) { return ({
    type: EAppActionTypes.appLoadingSet,
    payload: payload,
}); };
var initFinalAssessmentAction = function (payload) { return ({
    type: EAppActionTypes.initFinalAssessment,
    payload: payload,
}); };
var setCanTheAssessmentBeStopped = function (payload) { return ({
    type: EAppActionTypes.appSetCanTheAssessmentBeStopped,
    payload: payload,
}); };
var setFinalAssessmentCustomOrderedTerms = function (payload) { return ({
    type: EAppActionTypes.finalAssessmentSetOrderedTerms,
    payload: payload,
}); };
var setFinalAssessmentRateTerms = function (payload) { return ({
    type: EAppActionTypes.finalAssessmentSetRateTerms,
    payload: payload,
}); };
var setFieldApplicationBackground = function (payload) { return ({
    type: EAppActionTypes.fieldApplicationSetBackground,
    payload: payload,
}); };
var toggleSiderAction = function () { return ({
    type: EAppActionTypes.toggleSider,
}); };
var toggleReaderAction = function () { return ({
    type: EAppActionTypes.toggleReaderActive,
}); };
var setApplicationForceGI = function (payload) { return ({
    type: EAppActionTypes.setApplicationForceGI,
    payload: payload,
}); };
var setApplicationApproved = function (payload) { return ({
    type: EAppActionTypes.setApplicationApproved,
    payload: payload,
}); };
var setTheApplicatntAgeIsTooLow = function (payload) { return ({
    type: EAppActionTypes.setTheApplicantAgeIsTooLow,
    payload: payload,
}); };
var setApplicationGeneralDetails = function (payload) { return ({
    type: EAppActionTypes.setApplicationGeneralDetails,
    payload: payload,
}); };
var setShowJenieAssistDrawer = function (payload) { return ({
    type: EAppActionTypes.setShowJenieAssistDrawer,
    payload: payload,
}); };
var setTheQuestionnaireStarted = function (payload) { return ({
    type: EAppActionTypes.setTheQuestionnaireStarted,
    payload: payload,
}); };
var setHasUsedVoice = function (payload) { return ({
    type: EAppActionTypes.setHasUsedVoice,
    payload: payload,
}); };
var setUseJuvenileProduct = function (payload) { return ({
    type: EAppActionTypes.setUseJuvenileProduct,
    payload: payload,
}); };
var setFinalAssessmentTermEverest = function (payload) { return ({
    type: EAppActionTypes.setFinalAssessmentTermAddEverest,
    payload: payload,
}); };

var setProductLoading = function (payload) { return ({
    type: EProductActionTypes.productLoadingSet,
    payload: payload,
}); };
var setProduct = function (payload) { return ({
    type: EProductActionTypes.setProduct,
    payload: payload,
}); };

var setProductsLoading = function (payload) { return ({
    type: EProductsActionTypes.productsLoadingSet,
    payload: payload,
}); };
var getProducts = function (payload) { return ({
    type: EProductsActionTypes.getProducts,
    payload: payload,
}); };
var setProducts = function (payload) { return ({
    type: EProductsActionTypes.setProducts,
    payload: payload,
}); };

var setQuestionLoading = function (payload) { return ({
    type: EQuestionActionTypes.questionLoadingSet,
    payload: payload,
}); };
var setQuestion = function (payload) { return ({
    type: EQuestionActionTypes.setQuestion,
    payload: payload,
}); };
var setPrevQuestion = function (_a) {
    var groupedQuestionCategory = (_a === void 0 ? {} : _a).groupedQuestionCategory;
    return ({
        type: EQuestionActionTypes.setPrevQuestion,
        payload: { groupedQuestionCategory: groupedQuestionCategory },
    });
};
var answerQuestion = function (_a) {
    var answer = _a.answer, question = _a.question, _b = _a.isGroupedQuestion, isGroupedQuestion = _b === void 0 ? false : _b, _c = _a.groupedQuestionsAnswer, groupedQuestionsAnswer = _c === void 0 ? false : _c;
    return ({
        type: EQuestionActionTypes.answerQuestion,
        payload: { answer: answer, question: question, isGroupedQuestion: isGroupedQuestion, groupedQuestionsAnswer: groupedQuestionsAnswer },
    });
};

var setQuestionsLoading = function (payload) { return ({
    type: EQuestionsActionTypes.questionsLoadingSet,
    payload: payload,
}); };
var getQuestions = function (payload) { return ({
    type: EQuestionsActionTypes.getQuestions,
    payload: payload,
}); };
var setQuestions = function (payload) { return ({
    type: EQuestionsActionTypes.setQuestions,
    payload: payload,
}); };
var initQuestions = function () { return ({
    type: EQuestionsActionTypes.initQuestions,
}); };
var setFormatedQuestions = function (payload) { return ({
    type: EQuestionsActionTypes.setFormatedQuestions,
    payload: payload,
}); };
var setNewRasPayload = function (payload) { return ({
    type: EQuestionsActionTypes.setNewRasPayload,
    payload: payload,
}); };
var setLoadingValue = function (payload) { return ({
    type: EQuestionsActionTypes.setLoadingValue,
    payload: payload,
}); };
var setQuery = function (payload) { return ({
    type: EQuestionsActionTypes.setQuery,
    payload: payload,
}); };
var setFinalQuestion = function (payload) { return ({
    type: EQuestionsActionTypes.setFinalQuestion,
    payload: payload,
}); };
var setQuestionnaireResolution = function (payload) { return ({
    type: EQuestionsActionTypes.setQuestionnaireResolution,
    payload: payload,
}); };
var setQuestionnaireCompleted = function (payload) { return ({
    type: EQuestionsActionTypes.setQuestionnaireCompleted,
    payload: payload,
}); };
var setCompletePrequalificationAssessmentAnswer = function (payload) { return ({
    type: EQuestionsActionTypes.setCompletePrequalificationAssessmentAnswer,
    payload: payload,
}); };
var setCompletePrequalificationAssessmentIsCompleted = function (payload) { return ({
    type: EQuestionsActionTypes.setCompletePrequalificationAssessmentIsCompleted,
    payload: payload,
}); };

var setUser = function (payload) { return ({
    type: EUserActionTypes.setUser,
    payload: payload,
}); };
var setUserSmoker = function (payload) { return ({
    type: EUserActionTypes.setSmoker,
    payload: payload,
}); };
var setUserSmokerFE = function (payload) { return ({
    type: EUserActionTypes.setSmokerFE,
    payload: payload,
}); };
var setCurrentStatusInCanada = function (payload) { return ({
    type: EUserActionTypes.setCurrentStatusInCanada,
    payload: payload,
}); };
var setUserBankruptcyStatus = function (status) { return ({
    type: EUserActionTypes.setBankruptcyStatus,
    payload: status,
}); };

var setTermsAndRisksLoading = function (payload) { return ({
    type: ETermsAndRisksActionTypes.termsAndRisksLoadingSet,
    payload: payload,
}); };
var getTermsAndRisks = function (payload) { return ({
    type: ETermsAndRisksActionTypes.getTermsAndRisks,
    payload: payload,
}); };
var setTermsAndRisks = function (payload) { return ({
    type: ETermsAndRisksActionTypes.setTermsAndRisks,
    payload: payload,
}); };
var setTerm = function (payload) { return ({
    type: ETermsAndRisksActionTypes.setTerm,
    payload: payload,
}); };
var setTermAndComputedRisk = function (payload) { return ({
    type: ETermsAndRisksActionTypes.setTermAndComputedRisk,
    payload: payload,
}); };
var setCoverage = function (payload) { return ({
    type: ETermsAndRisksActionTypes.setCoverage,
    payload: payload,
}); };
var computeCoverageMinMax = function (payload) { return ({
    type: ETermsAndRisksActionTypes.computeCoverageMinMax,
    payload: payload,
}); };
var setDisabledTermsAccordingToApplicantAge = function (payload) { return ({
    type: ETermsAndRisksActionTypes.setDisabledTermsAccordingToApplicantAge,
    payload: payload,
}); };
var setRatesDetails = function (payload) { return ({
    type: ETermsAndRisksActionTypes.setRatesDetails,
    payload: payload,
}); };
var setFinalAssessmentRatesDetails = function (payload) { return ({
    type: ETermsAndRisksActionTypes.setFinalAssessmentRatesDetails,
    payload: payload,
}); };
var getRatesMatch = function (payload) { return ({
    type: ETermsAndRisksActionTypes.getRatesMatch,
    payload: payload,
}); };
var getFinalAssessmentRatesMatch = function (payload) { return ({
    type: ETermsAndRisksActionTypes.getFinalAssessmentRatesMatch,
    payload: payload,
}); };
var setEligibleProducts = function (payload) { return ({
    type: ETermsAndRisksActionTypes.setEligibleProducts,
    payload: payload,
}); };
var getEligibleProducts = function (payload) { return ({
    type: ETermsAndRisksActionTypes.getEligibleProducts,
    payload: payload,
}); };
var setCICoverage = function (payload) { return ({
    type: ETermsAndRisksActionTypes.setCICoverage,
    payload: payload,
}); };

// Our hook
function useDebounce(value, delay) {
    // State and setters for debounced value
    var _a = React.useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    React.useEffect(function () {
        // Set debouncedValue to value (passed in) after the specified delay
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        // Return a cleanup function that will be called every time ...
        // ... useEffect is re-called. useEffect will only be re-called ...
        // ... if value changes (see the inputs array below).
        // This is how we prevent debouncedValue from changing if value is ...
        // ... changed within the delay period. Timeout gets cleared and restarted.
        // To put it in context, if the user is typing within our app's ...
        // ... search box, we don't want the debouncedValue to update until ...
        // ... they've stopped typing for more than 500ms.
        return function () {
            clearTimeout(handler);
        };
    }, 
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [value, delay]);
    return debouncedValue;
}

var stateSelectorHandle$v = reselect.createSelector(function (state) { return state.user; }, function (state) { var _a; return (_a = state.termsAndRisks) === null || _a === void 0 ? void 0 : _a.eligibleProducts; }, function (state) { return state.termsAndRisks.coverage; }, function (state) { return state.termsAndRisks.ciCoverage; }, function (state) { return state.termsAndRisks.computedRisk; }, function (state) { return state.app.showGP; }, function (state) { return state.app.useJuvenileProduct; }, function (state) { return state.app.add_everest; }, function (user, termsAndRisksEligibleProducts, coverageDetails, ciCoverage, computedRisk, showGP, useJuvenileProduct, appAddEverest) {
    return {
        user: user,
        termsAndRisksEligibleProducts: termsAndRisksEligibleProducts,
        coverageDetails: coverageDetails,
        ciCoverage: ciCoverage,
        computedRisk: computedRisk,
        showGP: showGP,
        useJuvenileProduct: useJuvenileProduct,
        appAddEverest: appAddEverest,
    };
});
function useGetEligibleProducts() {
    var _a, _b;
    var stateSelector = React.useCallback(stateSelectorHandle$v, []);
    var initProducts = React.useRef(false);
    var _c = reactRedux.useSelector(stateSelector), termsAndRisksEligibleProducts = _c.termsAndRisksEligibleProducts, user = _c.user, coverageDetails = _c.coverageDetails, ciCoverage = _c.ciCoverage, computedRisk = _c.computedRisk, showGP = _c.showGP, useJuvenileProduct = _c.useJuvenileProduct, appAddEverest = _c.appAddEverest;
    var dispatch = reactRedux.useDispatch();
    var userIsCallCenter = (_a = user === null || user === void 0 ? void 0 : user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter;
    var userDataProducts = (_b = user === null || user === void 0 ? void 0 : user.data) === null || _b === void 0 ? void 0 : _b.products;
    var coverageValue = coverageDetails.value, coverageForcedMax = coverageDetails.forcedMax, coverageMaxValue = coverageDetails.maxValue;
    var maxCoverage = coverageForcedMax && coverageForcedMax < coverageMaxValue
        ? coverageForcedMax
        : coverageMaxValue;
    React.useEffect(function () {
        var _a;
        if (userIsCallCenter !== 1 && !useJuvenileProduct) {
            var checkAllEligibleProducts = termsAndRisksEligibleProducts &&
                Object.keys(termsAndRisksEligibleProducts).length ===
                    totalNoOfEssenceProducts;
            if (termsAndRisksEligibleProducts && checkAllEligibleProducts) {
                var orderedEvolutionTerms = Object.keys(termsAndRisksEligibleProducts)
                    .filter(function (item) {
                    if (termsAndRisksEligibleProducts === null || termsAndRisksEligibleProducts === void 0 ? void 0 : termsAndRisksEligibleProducts[item]) {
                        if (!isNaN(item)) {
                            // return all numerical terms
                            return item;
                        }
                        else if (isNaN(item) &&
                            item === EProductTerm.FiveToT100 &&
                            (showGP === EShowGp.FiveToT100 ||
                                showGP === EShowGp.all)) {
                            return item;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                })
                    .map(function (item) {
                    return isNaN(item) ? item : parseInt(item);
                })
                    .sort(function (a, b) {
                    if (typeof a === "number") {
                        if (typeof b === "number") {
                            return a - b;
                        }
                        else {
                            return -1;
                        }
                    }
                    return 1;
                });
                var ciTerms = computedRisk !==
                    EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                    ? []
                    : Object.keys(termsAndRisksEligibleProducts).filter(function (item) {
                        if (termsAndRisksEligibleProducts === null || termsAndRisksEligibleProducts === void 0 ? void 0 : termsAndRisksEligibleProducts[item]) {
                            if (isNaN(item) &&
                                item !== EProductTerm.FiveToT100) {
                                if (showGP === EShowGp.all) {
                                    return true;
                                }
                                else if (showGP === EShowGp.chubb &&
                                    item === EProductTerm.chubb) {
                                    return true;
                                }
                                else {
                                    return false;
                                }
                            }
                            else {
                                return false;
                            }
                        }
                        else {
                            return false;
                        }
                    });
                var lowestTerm = null;
                var secondLowestTerm = null;
                var thirdLowestTerm = null;
                var highestTerm = null;
                lowestTerm =
                    (orderedEvolutionTerms === null || orderedEvolutionTerms === void 0 ? void 0 : orderedEvolutionTerms.length) > 0
                        ? orderedEvolutionTerms.shift()
                        : (ciTerms === null || ciTerms === void 0 ? void 0 : ciTerms.length) > 0
                            ? ciTerms.shift()
                            : null;
                secondLowestTerm =
                    (orderedEvolutionTerms === null || orderedEvolutionTerms === void 0 ? void 0 : orderedEvolutionTerms.length) > 0
                        ? orderedEvolutionTerms.shift()
                        : (ciTerms === null || ciTerms === void 0 ? void 0 : ciTerms.length) > 0
                            ? ciTerms.shift()
                            : null;
                thirdLowestTerm =
                    (orderedEvolutionTerms === null || orderedEvolutionTerms === void 0 ? void 0 : orderedEvolutionTerms.length) > 0
                        ? orderedEvolutionTerms.shift()
                        : (ciTerms === null || ciTerms === void 0 ? void 0 : ciTerms.length) > 0
                            ? ciTerms.shift()
                            : null;
                highestTerm =
                    (orderedEvolutionTerms === null || orderedEvolutionTerms === void 0 ? void 0 : orderedEvolutionTerms.length) > 0
                        ? orderedEvolutionTerms.shift()
                        : (ciTerms === null || ciTerms === void 0 ? void 0 : ciTerms.length) > 0
                            ? ciTerms.shift()
                            : null;
                // set all the products as per documentations
                dispatch(setFinalAssessmentCustomOrderedTerms({
                    lowestTerm: lowestTerm,
                    secondLowestTerm: secondLowestTerm,
                    thirdLowestTerm: thirdLowestTerm,
                    highestTerm: highestTerm,
                }));
                if ((userDataProducts === null || userDataProducts === void 0 ? void 0 : userDataProducts.length) && !initProducts.current) {
                    var viableAllEligibleProducts = termsAndRisksEligibleProducts &&
                        Object.values(termsAndRisksEligibleProducts).filter(function (item) { return item; });
                    if (viableAllEligibleProducts.length === (userDataProducts === null || userDataProducts === void 0 ? void 0 : userDataProducts.length)) {
                        for (var item in userDataProducts) {
                            dispatch(setFinalAssessmentRateTerms({
                                term: userDataProducts[item]
                                    .product_order,
                                maxCoverageValue: maxCoverage,
                                inputValue: userDataProducts[item].coverage,
                                computedRisk: computedRisk,
                                isCallCenter: userIsCallCenter,
                                ciMinMaxCoverage: {
                                    minValue: ciCoverage.minValue,
                                    maxValue: ciCoverage.maxValue,
                                },
                                termLabel: userDataProducts[item].product_term,
                                addEverest: typeof appAddEverest !== "undefined"
                                    ? (_a = userDataProducts[item]) === null || _a === void 0 ? void 0 : _a.hasEverest : undefined,
                                callbackOnSuccess: function () {
                                    return (initProducts.current = true);
                                },
                            }));
                        }
                    }
                }
                else {
                    dispatch(setFinalAssessmentRateTerms({
                        term: ETermKey.lowest,
                        maxCoverageValue: maxCoverage,
                        inputValue: 0,
                        computedRisk: computedRisk,
                        isCallCenter: userIsCallCenter,
                        ciMinMaxCoverage: {
                            minValue: ciCoverage.minValue,
                            maxValue: ciCoverage.maxValue,
                        },
                    }));
                }
            }
        }
    }, [
        appAddEverest,
        ciCoverage.maxValue,
        ciCoverage.minValue,
        computedRisk,
        coverageDetails.minValue,
        coverageValue,
        dispatch,
        maxCoverage,
        showGP,
        termsAndRisksEligibleProducts,
        useJuvenileProduct,
        userDataProducts,
        userIsCallCenter,
    ]);
    React.useEffect(function () {
        var _a;
        if (userIsCallCenter !== 1 && useJuvenileProduct) {
            var checkAllEligibleProducts = termsAndRisksEligibleProducts &&
                Object.keys(termsAndRisksEligibleProducts).length ===
                    totalNoOfJuvenileProducts;
            if (termsAndRisksEligibleProducts && checkAllEligibleProducts) {
                var orderedJuvenileTerms = Object.keys(termsAndRisksEligibleProducts)
                    .filter(function (item) {
                    if (termsAndRisksEligibleProducts === null || termsAndRisksEligibleProducts === void 0 ? void 0 : termsAndRisksEligibleProducts[item]) {
                        if (!isNaN(item)) {
                            // return all numerical terms
                            return item;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                })
                    .map(function (item) {
                    return isNaN(item) ? item : parseInt(item);
                })
                    .sort(function (a, b) {
                    if (typeof a === "number") {
                        if (typeof b === "number") {
                            return a - b;
                        }
                        else {
                            return -1;
                        }
                    }
                    return 1;
                });
                var lowestTerm = null;
                var secondLowestTerm = null;
                lowestTerm =
                    (orderedJuvenileTerms === null || orderedJuvenileTerms === void 0 ? void 0 : orderedJuvenileTerms.length) > 0
                        ? orderedJuvenileTerms.shift()
                        : null;
                secondLowestTerm =
                    (orderedJuvenileTerms === null || orderedJuvenileTerms === void 0 ? void 0 : orderedJuvenileTerms.length) > 0
                        ? orderedJuvenileTerms.shift()
                        : null;
                // set all the products as per documentations
                dispatch(setFinalAssessmentCustomOrderedTerms({
                    lowestTerm: lowestTerm,
                    secondLowestTerm: secondLowestTerm,
                }));
                if ((userDataProducts === null || userDataProducts === void 0 ? void 0 : userDataProducts.length) && !initProducts.current) {
                    var viableAllEligibleProducts = termsAndRisksEligibleProducts &&
                        Object.values(termsAndRisksEligibleProducts).filter(function (item) { return item; });
                    if (viableAllEligibleProducts.length === (userDataProducts === null || userDataProducts === void 0 ? void 0 : userDataProducts.length)) {
                        for (var item in userDataProducts) {
                            dispatch(setFinalAssessmentRateTerms({
                                term: userDataProducts[item]
                                    .product_order,
                                maxCoverageValue: maxCoverage,
                                inputValue: userDataProducts[item].coverage,
                                computedRisk: computedRisk,
                                isCallCenter: userIsCallCenter,
                                termLabel: userDataProducts[item].product_term,
                                useJuvenileProduct: useJuvenileProduct,
                                addEverest: typeof appAddEverest !== "undefined"
                                    ? (_a = userDataProducts[item]) === null || _a === void 0 ? void 0 : _a.hasEverest : undefined,
                                callbackOnSuccess: function () {
                                    return (initProducts.current = true);
                                },
                            }));
                        }
                    }
                }
                else {
                    dispatch(setFinalAssessmentRateTerms({
                        term: ETermKey.lowest,
                        maxCoverageValue: maxCoverage,
                        inputValue: 0,
                        computedRisk: computedRisk,
                        isCallCenter: userIsCallCenter,
                        useJuvenileProduct: useJuvenileProduct,
                    }));
                }
            }
        }
    }, [
        appAddEverest,
        computedRisk,
        coverageDetails.minValue,
        coverageValue,
        dispatch,
        maxCoverage,
        termsAndRisksEligibleProducts,
        useJuvenileProduct,
        userDataProducts,
        userIsCallCenter,
    ]);
}

var stateSelectorHandle$u = reselect.createSelector(function (state) { return state.questions.data; }, function (state) { return state.questions.assessmentLoadingValue; }, function (questionsData, assessmentLoadingValue) {
    return {
        questionsData: questionsData,
        assessmentLoadingValue: assessmentLoadingValue,
    };
});
function useQuestionnaireEvaluation() {
    var _a;
    var stateSelector = React.useCallback(stateSelectorHandle$u, []);
    var _b = reactRedux.useSelector(stateSelector), questionsData = _b.questionsData, assessmentLoadingValue = _b.assessmentLoadingValue;
    var resultsProducts = (_a = questionsData === null || questionsData === void 0 ? void 0 : questionsData.results) === null || _a === void 0 ? void 0 : _a.products;
    var questionnaireEvaluation = React.useMemo(function () {
        if (!resultsProducts) {
            return {
                status: false,
            };
        }
        else {
            var status_1;
            if (resultsProducts[0].aggregatedRating.id.toLowerCase() ===
                "Accept".toLowerCase()) {
                status_1 = true;
            }
            else if (resultsProducts[0].aggregatedRating.id.toLowerCase() ===
                "Offer".toLowerCase() &&
                assessmentLoadingValue &&
                assessmentLoadingValue >= 201) {
                status_1 = false;
            }
            else if (resultsProducts[0].aggregatedRating.id.toLowerCase() ===
                "Offer".toLowerCase()) {
                status_1 = true;
            }
            else {
                status_1 = false;
            }
            return {
                status: status_1,
            };
        }
    }, [assessmentLoadingValue, resultsProducts]);
    return { questionnaireEvaluation: questionnaireEvaluation };
}

var stateSelectorHandle$t = reselect.createSelector(function (state) { return state.question.current; }, function (state) { return state.questions.computed; }, function (currentQuestion, computed) {
    return {
        currentQuestion: currentQuestion,
        computed: computed,
    };
});
function useIsLastQuestion() {
    var stateSelector = React.useCallback(stateSelectorHandle$t, []);
    var _a = reactRedux.useSelector(stateSelector), currentQuestion = _a.currentQuestion, computed = _a.computed;
    var isLastQuestion = React.useMemo(function () {
        var _a;
        return ((currentQuestion &&
            ((_a = computed[computed.length - 1]) === null || _a === void 0 ? void 0 : _a.id) === currentQuestion.id) ||
            false);
    }, [computed, currentQuestion]);
    return { isLastQuestion: isLastQuestion };
}

var stateSelectorHandle$s = reselect.createSelector(function (state) { var _a, _b; return (_b = (_a = state.termsAndRisks) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data; }, function (state) { var _a; return (_a = state.app.finalAssessment) === null || _a === void 0 ? void 0 : _a.customOrderedTerms; }, function (state) { return state.termsAndRisks.computedRisk; }, function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter; }, function (termsAndRisksData, finalAssessmentCustomOrderedTerms, computedRisk, isCallCenter) {
    return {
        termsAndRisksData: termsAndRisksData,
        finalAssessmentCustomOrderedTerms: finalAssessmentCustomOrderedTerms,
        computedRisk: computedRisk,
        isCallCenter: isCallCenter,
    };
});
function useGetFinalAssessmentProducts() {
    var stateSelector = React.useCallback(stateSelectorHandle$s, []);
    var _a = reactRedux.useSelector(stateSelector), termsAndRisksData = _a.termsAndRisksData, finalAssessmentCustomOrderedTerms = _a.finalAssessmentCustomOrderedTerms, computedRisk = _a.computedRisk, isCallCenter = _a.isCallCenter;
    var products = React.useMemo(function () {
        if (typeof isCallCenter !== "undefined" &&
            isCallCenter !== 1 &&
            finalAssessmentCustomOrderedTerms &&
            termsAndRisksData) {
            var data = Object.keys(finalAssessmentCustomOrderedTerms)
                .filter(function (item) {
                // @ts-ignore
                return finalAssessmentCustomOrderedTerms[item].label;
            })
                .map(function (item) {
                var _a;
                var termAndRiskData = termsAndRisksData === null || termsAndRisksData === void 0 ? void 0 : termsAndRisksData.find(function (termAndRiskItem) {
                    return termAndRiskItem.risk === computedRisk &&
                        termAndRiskItem.term ===
                            // @ts-ignore
                            finalAssessmentCustomOrderedTerms[item].label;
                });
                var product_term = // @ts-ignore
                 finalAssessmentCustomOrderedTerms[item].label;
                var coverage = 
                // @ts-ignore
                finalAssessmentCustomOrderedTerms[item].rate;
                var ci = product_term === EProductTerm.chubb;
                var resultedItem = {
                    product_order: item,
                    product_term: product_term,
                    product_id: ci
                        ? chubbFinalExpenseProductId
                        : termAndRiskData === null || termAndRiskData === void 0 ? void 0 : termAndRiskData.code,
                    coverage: coverage,
                    chubb: ci,
                    hasEverest: (_a = 
                    // @ts-ignore
                    finalAssessmentCustomOrderedTerms[item]) === null || _a === void 0 ? void 0 : _a.addEverest,
                    product_version: termAndRiskData === null || termAndRiskData === void 0 ? void 0 : termAndRiskData.version,
                };
                return resultedItem;
            });
            return data;
        }
        else {
            return null;
        }
    }, [
        computedRisk,
        finalAssessmentCustomOrderedTerms,
        isCallCenter,
        termsAndRisksData,
    ]);
    return { products: products };
}

var stateSelectorHandle$r = reselect.createSelector(function (state) { return state.question.current; }, function (state) { return state.questions.computed; }, function (currentQuestion, computedQuestions) {
    return {
        currentQuestion: currentQuestion,
        computedQuestions: computedQuestions,
    };
});
function useCheckForPrequalificationAssessment() {
    var stateSelector = React.useCallback(stateSelectorHandle$r, []);
    var _a = reactRedux.useSelector(stateSelector), currentQuestion = _a.currentQuestion, computedQuestions = _a.computedQuestions;
    var dispatch = reactRedux.useDispatch();
    React.useEffect(function () {
        var _a;
        if ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.index) && (computedQuestions === null || computedQuestions === void 0 ? void 0 : computedQuestions.length) !== 0) {
            // check the question 4.1 (Would you like to complete the prequalification assessment?)
            // and 5.1 (In the past three (3) years have you declared bankruptcy for which you have not yet been discharged?)
            var completePreQualificationAssessmentIndex_1 = 0;
            var completePreQualificationAssessment = computedQuestions.find(function (item, index) {
                if (item.id === "TLQ_CompletePreQualificationAssessment") {
                    completePreQualificationAssessmentIndex_1 = index;
                    return true;
                }
                else {
                    return false;
                }
            });
            var haveYouDeclaredBankruptcyLast3YearsIndex_1 = 0;
            var haveYouDeclaredBankruptcyLast3Years = computedQuestions.find(function (item, index) {
                if (item.id ===
                    "InsuredPerson.HaveYouDeclaredBankruptcyLast3Years") {
                    haveYouDeclaredBankruptcyLast3YearsIndex_1 = index;
                    return true;
                }
                else {
                    return false;
                }
            });
            if (haveYouDeclaredBankruptcyLast3Years &&
                completePreQualificationAssessment.answerState === "valid" &&
                ((_a = completePreQualificationAssessment.answer) === null || _a === void 0 ? void 0 : _a.id) === "Yes") {
                // check if there is at least one question betweeen 4.1 and 5.1 (without including them) with answerState === 'missing'
                var checkForMissingQuestions = computedQuestions.filter(function (item, index) {
                    if (index > completePreQualificationAssessmentIndex_1 &&
                        index < haveYouDeclaredBankruptcyLast3YearsIndex_1) {
                        if (item.answerState === "missing") {
                            return item;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                });
                if (checkForMissingQuestions.length > 0) {
                    dispatch(setCompletePrequalificationAssessmentAnswer(1));
                    dispatch(setCompletePrequalificationAssessmentIsCompleted(false));
                }
                else {
                    dispatch(setCompletePrequalificationAssessmentAnswer(1));
                    dispatch(setCompletePrequalificationAssessmentIsCompleted(true));
                }
            }
            else {
                dispatch(setCompletePrequalificationAssessmentAnswer(null));
                dispatch(setCompletePrequalificationAssessmentIsCompleted(false));
            }
        }
    }, [computedQuestions, currentQuestion, dispatch]);
}

var getCurrentQuestion = function (state) { return state.question.current; };

var getRASPayload = function (state) { return state.questions.data; };
var getComputedQuestions = function (state) { return state.questions.computed; };
var getFinalQuestion = function (state) {
    return state.questions.finalQuestionId;
};
var getAssessmentLoadingValue = function (state) {
    return state.questions.assessmentLoadingValue;
};
var getCompletePrequalificationAssessment = function (state) {
    return state.questions.completePrequalificationAssessment;
};

var getUserFromStore = function (state) { return state === null || state === void 0 ? void 0 : state.user; };

var getCurrentProduct = function (state) { return state.product.currentId; };

var getCoverage = function (state) { return state.termsAndRisks.coverage; };
var getTermsAndRisksData = function (state) { return state.termsAndRisks.data; };
var getSelectedTerm = function (state) {
    return state.termsAndRisks.selectedTerm;
};
var getComputedRisk = function (state) {
    return state.termsAndRisks.computedRisk;
};

var selectApplicationAddEverest = function (state) {
    return state.app.add_everest;
};
var selectApplicationShowJennieAssistDrawer = function (state) {
    return state.app.fieldApplication.showJenieAssistDrawer;
};
var getFieldApplicationTheQuestionnaireStarted = function (state) {
    return state.app.fieldApplication.theQuestionnaireStarted;
};
var getApplicationHasUsedVoice = function (state) {
    return state.app.hasUsedVoice;
};
var getApplicationUseJuvenileProduct = function (state) {
    return state.app.useJuvenileProduct;
};
var getApplicationShowGP = function (state) { var _a; return (_a = state.app) === null || _a === void 0 ? void 0 : _a.showGP; };

var audio = new Audio();
var stateSelectorHandle$q = reselect.createSelector(function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.extension; }, function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.language; }, function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter; }, function (state) { return state.app.env; }, function (extension, language, isCallCenter, env) {
    return { extension: extension, language: language, isCallCenter: isCallCenter, env: env };
});
var useGetMp3QuestionTitle = function () {
    var s3Mp3FilesBucket = "https://media.isi.ca/jennie/jenie-mp3s";
    var stateSelector = React.useCallback(stateSelectorHandle$q, []);
    var _a = reactRedux.useSelector(stateSelector), phoneExtension = _a.extension, language = _a.language, isCallCenter = _a.isCallCenter;
    var callAudioApiQuestionIdRef = React.useRef(null);
    //** lastQuestionReadId
    /* Every time when a question is read, a request to http://dial11-dev.dev.isi.ca:8181/v1/audio-playback is made
    /* but when the user stop the reading process I need to send a request to the same endpoint in order to stop the reading process
    /* stopping the audio is not enough, the question's id needs to be sent too.
    */
    // const [questionToReadId, setQuestionToReadId] = useState<string | null>(
    // 	null,
    // );
    var play = React.useCallback(function (url) {
        return new Promise(function (resolve, reject) {
            // return a promise
            audio.preload = "auto"; // intend to play through
            audio.autoplay = true; // autoplay when loaded
            audio.onerror = reject; // on error, reject
            audio.onended = resolve; // when done, resolve
            audio.src = url;
        });
    }, []);
    var stream = React.useCallback(function (_a) {
        var questionsIds = _a.questionsIds;
        return __awaiter(void 0, void 0, void 0, function () {
            var questionsIdsLength, i, newQuestionId, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        questionsIdsLength = questionsIds.length;
                        i = 0;
                        _b.label = 1;
                    case 1:
                        if (!(i < questionsIdsLength)) return [3 /*break*/, 10];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 8, , 9]);
                        newQuestionId = questionsIds[i].split(".").length > 1
                            ? questionsIds[i].split(".").pop()
                            : questionsIds[i];
                        if (!newQuestionId) return [3 /*break*/, 7];
                        if (!language) return [3 /*break*/, 6];
                        if (!(isCallCenter !== 0 && phoneExtension)) return [3 /*break*/, 3];
                        // check if the newQuestionId is among the questions that should not be played
                        // note that this condition should be applied only on isCallCenter = 2
                        if (isCallCenter === 2 &&
                            Object.values(dontPlayQuestionIds).includes(newQuestionId)) {
                            return [2 /*return*/, null];
                        }
                        // @ts-ignore
                        // window.callAudioApiQuestionId = newQuestionId;
                        // TODO: delete the above after testing...
                        callAudioApiQuestionIdRef.current =
                            newQuestionId;
                        exports.callAudioApi === null || exports.callAudioApi === void 0 ? void 0 : exports.callAudioApi({
                            action: "start",
                            // this condition is temporary
                            file: "jennie/jenie-mp3s/" + language + "/" + newQuestionId + "." + language,
                        });
                        return [3 /*break*/, 5];
                    case 3: 
                    //** The 'play' function should be the last function called because it is a function that stops the flow (await).  */
                    return [4 /*yield*/, play(s3Mp3FilesBucket + "/" + language + "/" + newQuestionId + "." + language + ".mp3")];
                    case 4:
                        //** The 'play' function should be the last function called because it is a function that stops the flow (await).  */
                        _b.sent();
                        _b.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6: throw new Error("stream: missing paramenters");
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        error_1 = _b.sent();
                        console.error(error_1);
                        return [3 /*break*/, 9];
                    case 9:
                        i++;
                        return [3 /*break*/, 1];
                    case 10: return [2 /*return*/];
                }
            });
        });
    }, [language, isCallCenter, phoneExtension, play]);
    var pause = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            audio.pause();
            audio.currentTime = 0.0;
            try {
                if (language &&
                    isCallCenter !== 0 &&
                    phoneExtension &&
                    exports.callAudioApi) {
                    exports.callAudioApi({
                        action: "stop",
                        file: "jennie/jenie-mp3s/" + language + "/" + callAudioApiQuestionIdRef.current + "." + language,
                    });
                }
            }
            catch (error) {
                console.error(error);
            }
            return [2 /*return*/];
        });
    }); }, [language, isCallCenter, phoneExtension]);
    return { stream: stream, pause: pause };
};

var getProductVersionAndCodeForCallCenter = function (_a) {
    var products = _a.products, selectedTerm = _a.selectedTerm, risk = _a.risk;
    if (!products || products.length === 0) {
        return null;
    }
    else {
        return products.find(function (item) { return item.risk === risk && item.term === selectedTerm; });
    }
};

var stateSelectorHandle$p = reselect.createSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.nearestAge; }, function (userAge) {
    return {
        userAge: userAge,
    };
});
function useShowEvolutionLabelAccordingToAge(item) {
    var stateSelector = React.useCallback(stateSelectorHandle$p, []);
    var userAge = reactRedux.useSelector(stateSelector).userAge;
    var showEvolutionLabelAccordingToAgeAndTerm = React.useMemo(function () {
        if (userAge != null &&
            ((userAge < ageRangeForEvolutionAndSureTermApi.lowerLimit &&
                item !== EProductTerm.T100) ||
                (userAge >= ageRangeForEvolutionAndSureTermApi.lowerLimit &&
                    userAge <= ageRangeForEvolutionAndSureTermApi.upperLimit &&
                    (item === EProductTerm.T10 || item === EProductTerm.T20)))) {
            return true;
        }
        else
            return false;
    }, [item, userAge]);
    return { showEvolutionLabelAccordingToAgeAndTerm: showEvolutionLabelAccordingToAgeAndTerm };
}

var numberWithCommas = function (number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var totalNoOfEssenceProducts = 6;
var totalNoOfJuvenileProducts = 2;
var availableEvolutionTerms = [10, 20, 30, 100];
var chubbFinalExpenseProductId = 109;
var chubbMinMaxCoverageValues = {
    minValue: 5000,
    maxValue: 25000,
};
var juvenileCIMinMaxCoverageValues = {
    minValue: 1000,
    maxValue: 25000,
};
var chubbExcludedProvincies = [];
var sliderAdultApplicantIncrementStep = 500;
var sliderJuvenileApplicantIncrementStep = 1000;
// age < 41 ani T10, T20, T30 => Evolution T100 => SureTerm
// age > 45 ani: T10, T20, T30, T100 => SureTerm
// 41-45 ani: T10, T20 => Evolution T30, T100 => SureTerm
var ageRangeForEvolutionAndSureTermApi = {
    lowerLimit: 41,
    upperLimit: 45,
};
var roundLikePHP = function (num, dec) {
    var num_sign = num >= 0 ? 1 : -1;
    var floatNumber = (Math.round(num * Math.pow(10, dec) + num_sign * 0.0001) /
        Math.pow(10, dec)).toString();
    return parseFloat(floatNumber).toFixed(dec);
};
var risksLabelsForCallCenter0 = {
    en: {
        1: "Advance +",
        2: "Advance",
        3: "Express +",
        4: "Express",
        5: "Essence",
    },
    fr: {
        1: "Avantage +",
        2: "Avantage",
        3: "Express +",
        4: "Express",
        5: "Essentielle",
    },
};
var risksLabelsForCallCenter2 = {
    en: {
        1: "Diamond (RC1)",
        2: "Platinum (RC2)",
        3: "Gold (RC3)",
        4: "Silver (RC4)",
        5: "Bronze (RC5)",
    },
    fr: {
        1: "Diamant (RC1)",
        2: "Platine (RC2)",
        3: "Or (RC3)",
        4: "Argent (RC4)",
        5: "Bronze (RC5)",
    },
};
var juvenileRisksLabels = {
    en: {
        1: "Evolution Jr. Standard",
        4: "Evolution Jr. Guaranteed Issue",
    },
    fr: {
        1: "Evolution Jr. standard",
        4: "Evolution Jr. à émission garantie",
    },
};
var unitedStatesEnglishAndFrenchValue = {
    en: "United States",
    fr: "États-Unis",
};
var heightAndWeightQuestionsIds = {
    HeightUnits: "InsuredPerson.HeightUnits",
    HeightSI: "InsuredPerson.HeightSI",
    HeightUS: "InsuredPerson.HeightUS",
    WeightUnits: "InsuredPerson.WeightUnits",
    WeightSI: "InsuredPerson.WeightSI",
    WeightUS: "InsuredPerson.WeightUS",
    JuvenilesHeightUS: "InsuredPerson.HeightUS_Juveniles",
    JuvenilesHeightSI: "InsuredPerson.HeightSI_Juveniles",
    JuvenilesWeightUS: "InsuredPerson.WeightUS_Juveniles",
    JuvenilesWeightSI: "InsuredPerson.WeightSI_Juveniles",
};
var groupedQuestionsCategories = {
    "Height and Weight": {
        ids: __spreadArrays(Object.values(heightAndWeightQuestionsIds)),
        title: "height And Weight Units And Values",
        groupQuestionId: "HeightAndWeight",
    },
    Employment: {
        ids: ["InsuredPerson.CurrentOccupation", "InsuredPerson.AnnualIncome"],
        title: "current occupation and income",
        groupQuestionId: "Employment",
    },
    Medical: {
        ids: [
            "HaveYouBeenAdvisedOrWaitingForSurgeryEtc",
            "AbnormalInconclusiveTestForUndiagnosedConditionLastYear",
            "TLQ_HIV",
        ],
        title: "miscellaneous ",
        groupQuestionId: "Medical",
    },
};
var smokerQuestionsIds = {
    TLQ_Smoker: "TLQ_Smoker",
    HowManySmokePerYear: "SmokerAssessment.HowManySmokePerYear",
    IsSmokingLimitedToCigars: "SmokerAssessment.IsSmokingLimitedToCigars",
    TLQ_MarijuanaUseLastYear: "TLQ_MarijuanaUseLastYear",
};
var canadianCitizenStatusQuestionId = {
    CanadianCitizenStatus: "InsuredPerson.CanadianCitizenStatus",
};
var HAVE_YOU_DECLARED_BANKRUPTCY_QUESTION_ID = "InsuredPerson.HaveYouDeclaredBankruptcyLast3Years";
var MAX_COVERAGE = 250000;
var dontPlayQuestionIds = {
    HeightUnits: "HeightUnits",
    WeightUnits: "WeightUnits",
    TLQ_CompletePreQualificationAssessment: "TLQ_CompletePreQualificationAssessment",
};

function getProductsHandle(initialData) {
    var _a, serverPayload, coverage, approved, force_GI, smoker, smokerFE, add_everest, showGP, env, hasUsedVoice, userData, data, selectedProduct, dob, birth, original, pastYear, nextYear, current, differentBetween, difference, realAge, nearestAgeOld, nearestAge, useJuvenileProduct, parsedServerPayload, risk, term, parsedUserData_1, error_1;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = initialData.payload, serverPayload = _a.serverPayload, coverage = _a.coverage, approved = _a.approved, force_GI = _a.force_GI, smoker = _a.smoker, smokerFE = _a.smokerFE, add_everest = _a.add_everest, showGP = _a.showGP, env = _a.env, hasUsedVoice = _a.hasUsedVoice, userData = __rest(_a, ["serverPayload", "coverage", "approved", "force_GI", "smoker", "smokerFE", "add_everest", "showGP", "env", "hasUsedVoice"]);
                _d.label = 1;
            case 1:
                _d.trys.push([1, 24, , 26]);
                return [4 /*yield*/, effects.call(api.products.get, {
                        language: i18n__default["default"].language,
                    })];
            case 2:
                data = (_d.sent()).data;
                if (!!data) return [3 /*break*/, 4];
                return [4 /*yield*/, effects.put(setProductsLoading(false))];
            case 3:
                _d.sent();
                return [3 /*break*/, 23];
            case 4:
                selectedProduct = null;
                dob = new Date(userData.dob);
                birth = moment__default["default"](new Date(dob.getFullYear(), dob.getMonth(), dob.getDate()), "'YYYY-MM-DD'");
                original = moment__default["default"](new Date(dob.getFullYear(), dob.getMonth(), dob.getDate()), "'YYYY-MM-DD'");
                pastYear = moment__default["default"](birth
                    .set("year", moment__default["default"]().year() - 1)
                    .set("month", birth.month() - 1), "'YYYY-MM-DD'");
                nextYear = moment__default["default"](birth.set("year", moment__default["default"]().year()), "'YYYY-MM-DD'");
                current = moment__default["default"]();
                differentBetween = current.diff(pastYear, "days");
                difference = current.diff(original, "days");
                realAge = Math.floor(difference / 365.2422);
                nearestAgeOld = differentBetween >=
                    Math.floor(nextYear.diff(pastYear, "days") / 2)
                    ? realAge + 1
                    : realAge;
                console.log("nearestAgeOld", nearestAgeOld);
                nearestAge = Math.round(current.diff(original, "days") / 365.2422);
                console.log("nearestAgeNew", nearestAge);
                useJuvenileProduct = nearestAge < 18 ? true : false;
                parsedServerPayload = serverPayload &&
                    ((((_b = serverPayload === null || serverPayload === void 0 ? void 0 : serverPayload.products[0]) === null || _b === void 0 ? void 0 : _b.id) ===
                        EProducts.LifeTermProduct &&
                        useJuvenileProduct) ||
                        (((_c = serverPayload === null || serverPayload === void 0 ? void 0 : serverPayload.products[0]) === null || _c === void 0 ? void 0 : _c.id) ===
                            EProducts.LifeTermJuvenilesProduct &&
                            !useJuvenileProduct))
                    ? undefined
                    : serverPayload;
                return [4 /*yield*/, effects.put(setProductsLoading(true))];
            case 5:
                _d.sent();
                return [4 /*yield*/, effects.put(setApplicationApproved(approved))];
            case 6:
                _d.sent();
                return [4 /*yield*/, effects.put(setApplicationForceGI(force_GI))];
            case 7:
                _d.sent();
                return [4 /*yield*/, effects.put(setHasUsedVoice(hasUsedVoice))];
            case 8:
                _d.sent();
                return [4 /*yield*/, effects.put(setUseJuvenileProduct(useJuvenileProduct))];
            case 9:
                _d.sent();
                return [4 /*yield*/, effects.put(initFinalAssessmentAction(userData.isCallCenter !== 1 && (approved || force_GI)))];
            case 10:
                _d.sent();
                return [4 /*yield*/, effects.put(setApplicationGeneralDetails({
                        add_everest: add_everest === "0" || add_everest === "1"
                            ? parseInt(add_everest, 10)
                            : typeof add_everest === "number"
                                ? add_everest
                                : undefined,
                        showGP: showGP,
                        env: env,
                    }))];
            case 11:
                _d.sent();
                risk = userData.risk, term = userData.term;
                return [4 /*yield*/, effects.put(setProducts(data))];
            case 12:
                _d.sent();
                if (data === null || data === void 0 ? void 0 : data.products) {
                    if (useJuvenileProduct) {
                        selectedProduct = data.products.find(function (item) {
                            return item.id === EProducts.LifeTermJuvenilesProduct;
                        });
                    }
                    else {
                        // get the first product that is not 'juvenile'
                        selectedProduct = data.products.find(function (item) {
                            return item.id !== EProducts.LifeTermJuvenilesProduct;
                        });
                    }
                }
                return [4 /*yield*/, effects.put(setProduct({
                        productId: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id,
                        name: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.caption,
                    }))];
            case 13:
                _d.sent();
                parsedUserData_1 = __assign(__assign({}, userData), { realAge: realAge, nearestAge: nearestAge });
                return [4 /*yield*/, effects.put(setUser(Object.keys(__assign({}, parsedUserData_1)).reduce(function (acc, cur) {
                        // @ts-ignore
                        var currentValue = parsedUserData_1[cur];
                        // @ts-ignore
                        acc[cur] = currentValue
                            ? currentValue
                            : currentValue === 0
                                ? currentValue
                                : undefined; // if the value is  "" or null
                        return acc;
                    }, {})))];
            case 14:
                _d.sent();
                return [4 /*yield*/, effects.put(setUserSmoker(smoker === "0" || !smoker ? "0" : "1"))];
            case 15:
                _d.sent();
                return [4 /*yield*/, effects.put(setUserSmokerFE(smokerFE === "0" || !smokerFE ? "0" : "1"))];
            case 16:
                _d.sent();
                return [4 /*yield*/, effects.put(setTermAndComputedRisk({
                        computedRisk: risk
                            ? parseInt(risk)
                            : EMaxAndMinTermAndRisk.minSureAndEvolutionProductsRisk,
                        term: term
                            ? parseInt(term)
                            : useJuvenileProduct
                                ? EMaxAndMinTermAndRisk.minJuvenileProductsTerm
                                : EMaxAndMinTermAndRisk.minSureAndEvolutionProductsTerm,
                    }))];
            case 17:
                _d.sent();
                return [4 /*yield*/, effects.put(setCICoverage({
                        minValue: useJuvenileProduct
                            ? juvenileCIMinMaxCoverageValues.minValue
                            : showGP === EShowGp.chubb || showGP === EShowGp.all
                                ? chubbMinMaxCoverageValues.minValue
                                : 0,
                        maxValue: useJuvenileProduct
                            ? juvenileCIMinMaxCoverageValues.maxValue
                            : showGP === EShowGp.chubb || showGP === EShowGp.all
                                ? chubbMinMaxCoverageValues.maxValue
                                : 0,
                    }))];
            case 18:
                _d.sent();
                return [4 /*yield*/, effects.put(setCoverage({
                        currentStatusInCanada: null,
                        value: !isNaN(parseInt(coverage)) && parseInt(coverage) > 0
                            ? parseInt(coverage)
                            : 0,
                    }))];
            case 19:
                _d.sent();
                return [4 /*yield*/, effects.put(getQuestions({
                        serverPayload: parsedServerPayload,
                    }))];
            case 20:
                _d.sent();
                return [4 /*yield*/, effects.put(getTermsAndRisks({
                        initTheEditProcess: Boolean(parsedServerPayload),
                    }))];
            case 21:
                _d.sent();
                return [4 /*yield*/, effects.put(setProductsLoading(false))];
            case 22:
                _d.sent();
                _d.label = 23;
            case 23: return [3 /*break*/, 26];
            case 24:
                error_1 = _d.sent();
                console.log({ error: error_1 });
                return [4 /*yield*/, effects.put(setProductsLoading(false))];
            case 25:
                _d.sent();
                return [3 /*break*/, 26];
            case 26: return [2 /*return*/];
        }
    });
}
function rootSaga$4() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([effects.takeEvery(EProductsActionTypes.getProducts, getProductsHandle)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

var questionMappingPerProduct = {
    LifeTermProduct: [
        "InsuredPerson.ResidentialAddress",
        "InsuredPerson.Gender",
        "InsuredPerson.DateOfBirth",
        "InsuredPerson.FirstName",
        "InsuredPerson.MiddleName",
        "InsuredPerson.LastName",
        "InsuredPerson.PolicyNumber",
        "InsuredPerson.InsuranceSum",
        "InsuredPerson.ResidenceState",
    ],
    LifeTermJuvenilesProduct: [
        "InsuredPerson.ResidentialAddress",
        "InsuredPerson.Gender",
        "InsuredPerson.DateOfBirth",
        "InsuredPerson.FirstName",
        "InsuredPerson.MiddleName",
        "InsuredPerson.LastName",
        "InsuredPerson.PolicyNumber",
        "InsuredPerson.InsuranceSum",
        "InsuredPerson.ResidenceState",
    ],
};

function getQuestion(data, fallbackIndex, groupCaption) {
    if (fallbackIndex === void 0) { fallbackIndex = undefined; }
    if (groupCaption === void 0) { groupCaption = ""; }
    for (var i in data) {
        if (data[i].type === "group")
            return getQuestion(data[i].questions, data[i].index, data[i].caption);
        else {
            if (!data[i].index)
                data[i].index = fallbackIndex;
            data[i].groupCaption = groupCaption;
            return data[i];
        }
    }
}
function formatQuestions(computedQuestions, excludeIds) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (excludeIds === void 0) { excludeIds = []; }
    var questions = {};
    for (var i = 0; i < computedQuestions.length; i++) {
        var item = computedQuestions[i];
        var key = item.index;
        if (!item ||
            item.answerState === "missing" ||
            (!excludeIds.includes(item.id) &&
                questionMappingPerProduct.LifeTermProduct.includes(item.id)))
            continue;
        switch (item.type) {
            case "struct": {
                var elementsObj = {};
                for (var j = 0; j < item.elements.length; j++) {
                    var elementKey = item.elements[j].caption;
                    var elementAnswer = item.elements[j].answer
                        ? item.elements[j].answer
                        : null;
                    Object.assign(elementsObj, (_a = {}, _a[elementKey] = elementAnswer, _a));
                }
                Object.assign(questions, (_b = {}, _b[key] = elementsObj, _b));
                break;
            }
            case "singleselection": {
                var answer = item.answer ? item.answer.label : null;
                Object.assign(questions, (_c = {},
                    _c[key] = {
                        question: item.caption,
                        answer: answer,
                    },
                    _c));
                break;
            }
            case "assessment-factor-search": {
                var answer = item.answer
                    ? item.answer.map(function (item) { return item.label; })
                    : null;
                Object.assign(questions, (_d = {},
                    _d[key] = {
                        question: item.caption,
                        answer: answer,
                    },
                    _d));
                break;
            }
            case "multiselection": {
                var answer = {};
                var selectedOptionsIds = item.answer.map(function (item) { return item.id; });
                for (var _i = 0, _h = item.options; _i < _h.length; _i++) {
                    var option = _h[_i];
                    answer[option.id] = {
                        optionTxt: option.label,
                        isSelected: selectedOptionsIds.includes(option.id),
                    };
                }
                Object.assign(questions, (_e = {},
                    _e[key] = {
                        question: item.caption,
                        answer: answer,
                    },
                    _e));
                break;
            }
            default:
                if (item.id === heightAndWeightQuestionsIds.HeightUS ||
                    item.id === heightAndWeightQuestionsIds.JuvenilesHeightUS)
                    Object.assign(questions, (_f = {},
                        _f[key] = {
                            question: item.caption,
                            answer: item.answer
                                ? Math.floor(item.answer / 12) + "' " + item.answer % 12
                                : null,
                        },
                        _f));
                else
                    Object.assign(questions, (_g = {},
                        _g[key] = {
                            question: item.caption,
                            answer: item.answer !== "" &&
                                (item.answer || !isNaN(item.answer))
                                ? item.answer
                                : null,
                        },
                        _g));
        }
    }
    return questions;
}
function getQuestionsHandle(_a) {
    var serverPayload, rasPayload, userData, useJuvenileProduct, data, computed, canadianStatusQuestion, bankruptcyQuestion, error_1;
    var _b, _c, _d, _e, _f, _g;
    var payload = _a.payload;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                serverPayload = (payload || {}).serverPayload;
                rasPayload = null;
                return [4 /*yield*/, effects.put(setQuestionsLoading(true))];
            case 1:
                _h.sent();
                _h.label = 2;
            case 2:
                _h.trys.push([2, 20, , 22]);
                if (!serverPayload) return [3 /*break*/, 3];
                rasPayload = serverPayload;
                return [3 /*break*/, 7];
            case 3: return [4 /*yield*/, effects.select(getUserFromStore)];
            case 4:
                userData = _h.sent();
                return [4 /*yield*/, effects.select(getApplicationUseJuvenileProduct)];
            case 5:
                useJuvenileProduct = _h.sent();
                return [4 /*yield*/, effects.call(api.questions.riskAssessmetnResource, {
                        language: userData.data.language,
                        products: [
                            {
                                id: useJuvenileProduct
                                    ? EProducts.LifeTermJuvenilesProduct
                                    : EProducts.LifeTermProduct,
                            },
                        ],
                    })];
            case 6:
                data = (_h.sent()).data;
                rasPayload = data;
                _h.label = 7;
            case 7:
                if (!!rasPayload) return [3 /*break*/, 9];
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 8:
                _h.sent();
                return [3 /*break*/, 19];
            case 9:
                computed = getQuestionsOnly(rasPayload.questionnaire.questions);
                canadianStatusQuestion = computed.find(function (item) {
                    return item.id ===
                        canadianCitizenStatusQuestionId.CanadianCitizenStatus;
                });
                if (!((_b = canadianStatusQuestion === null || canadianStatusQuestion === void 0 ? void 0 : canadianStatusQuestion.answer) === null || _b === void 0 ? void 0 : _b.id)) return [3 /*break*/, 11];
                return [4 /*yield*/, effects.put(setCurrentStatusInCanada({
                        statusInCanada: canadianStatusQuestion.answer.id,
                    }))];
            case 10:
                _h.sent();
                _h.label = 11;
            case 11:
                bankruptcyQuestion = computed.find(function (item) {
                    return item.id === HAVE_YOU_DECLARED_BANKRUPTCY_QUESTION_ID;
                });
                if (!((_c = bankruptcyQuestion === null || bankruptcyQuestion === void 0 ? void 0 : bankruptcyQuestion.answer) === null || _c === void 0 ? void 0 : _c.id)) return [3 /*break*/, 13];
                return [4 /*yield*/, effects.put(setUserBankruptcyStatus(bankruptcyQuestion.answer.id.toLowerCase()))];
            case 12:
                _h.sent();
                _h.label = 13;
            case 13: return [4 /*yield*/, effects.put(setCoverage({
                    currentStatusInCanada: (_e = (_d = canadianStatusQuestion === null || canadianStatusQuestion === void 0 ? void 0 : canadianStatusQuestion.answer) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : null,
                    bankruptcyStatus: (_g = (_f = bankruptcyQuestion === null || bankruptcyQuestion === void 0 ? void 0 : bankruptcyQuestion.answer) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : null,
                    maxValue: MAX_COVERAGE,
                }))];
            case 14:
                _h.sent();
                return [4 /*yield*/, effects.put(setQuestions(rasPayload))];
            case 15:
                _h.sent();
                return [4 /*yield*/, effects.put(setQuestion(getQuestion(rasPayload.questionnaire.questions)))];
            case 16:
                _h.sent();
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 17:
                _h.sent();
                return [4 /*yield*/, effects.put(initQuestions())];
            case 18:
                _h.sent();
                _h.label = 19;
            case 19: return [3 /*break*/, 22];
            case 20:
                error_1 = _h.sent();
                console.log({ error: error_1 });
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 21:
                _h.sent();
                return [3 /*break*/, 22];
            case 22: return [2 /*return*/];
        }
    });
}
function initQuestionsHandle() {
    var user_1, rasPayload, currentProduct, useJuvenileProduct, getInsuredPersonAnnualIncomeAnswerState, reflexProduct, _a, sendData_1, data, computed, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 16, , 18]);
                return [4 /*yield*/, effects.select(getUserFromStore)];
            case 1:
                user_1 = _b.sent();
                return [4 /*yield*/, effects.select(getRASPayload)];
            case 2:
                rasPayload = _b.sent();
                return [4 /*yield*/, effects.select(getCurrentProduct)];
            case 3:
                currentProduct = _b.sent();
                return [4 /*yield*/, effects.select(getApplicationUseJuvenileProduct)];
            case 4:
                useJuvenileProduct = _b.sent();
                getInsuredPersonAnnualIncomeAnswerState = null;
                reflexProduct = useJuvenileProduct
                    ? EProducts.LifeTermJuvenilesProduct
                    : EProducts.LifeTermProduct;
                _a = currentProduct;
                switch (_a) {
                    case EProducts.LifeTermProduct: return [3 /*break*/, 5];
                    case EProducts.LifeTermJuvenilesProduct: return [3 /*break*/, 5];
                }
                return [3 /*break*/, 15];
            case 5:
                sendData_1 = __assign(__assign({}, rasPayload), { questionnaire: __assign({}, rasPayload.questionnaire) });
                questionMappingPerProduct[reflexProduct].forEach(function (element) {
                    switch (element) {
                        case "InsuredPerson.ResidentialAddress":
                            var _a = user_1.data || {}, address = _a.address, city = _a.city, postal_code = _a.postal_code;
                            var parsedAddress = address === null || address === void 0 ? void 0 : address.split(" ");
                            var streetNumber = (parsedAddress === null || parsedAddress === void 0 ? void 0 : parsedAddress.length) > 1
                                ? parsedAddress[0]
                                : "";
                            var streetName = (parsedAddress === null || parsedAddress === void 0 ? void 0 : parsedAddress.length) === 1
                                ? parsedAddress[0]
                                : (parsedAddress === null || parsedAddress === void 0 ? void 0 : parsedAddress.length) > 1
                                    ? parsedAddress
                                        .filter(function (_, index) {
                                        return !!index;
                                    })
                                        .join(" ")
                                    : "";
                            var answers = {
                                "InsuredPerson.ZipCode": postal_code,
                                "InsuredPerson.City": city,
                            };
                            if (streetName) {
                                Object.assign({
                                    "InsuredPerson.StreetName": streetName,
                                }, answers);
                            }
                            if (streetNumber) {
                                Object.assign({
                                    "InsuredPerson.StreetName": streetNumber,
                                }, answers);
                            }
                            sendData_1 = __assign(__assign({}, sendData_1), { questionnaire: __assign(__assign({}, sendData_1.questionnaire), { questions: updatePayload(sendData_1.questionnaire.questions, element, {
                                        elements: answers,
                                    }) }) });
                            break;
                        case "InsuredPerson.Gender": {
                            sendData_1 = __assign(__assign({}, sendData_1), { questionnaire: __assign(__assign({}, sendData_1.questionnaire), { questions: updatePayload(sendData_1.questionnaire.questions, "InsuredPerson.Gender", user_1.data.gender === "m"
                                        ? { id: "Male", label: "Male" } // TODO: I need to update the content for french too
                                        : {
                                            id: "Female",
                                            label: "Female",
                                        }) }) });
                            break;
                        }
                        case "InsuredPerson.DateOfBirth": {
                            sendData_1 = __assign(__assign({}, sendData_1), { questionnaire: __assign(__assign({}, sendData_1.questionnaire), { questions: updatePayload(sendData_1.questionnaire.questions, "InsuredPerson.DateOfBirth", user_1.data.dob) }) });
                            break;
                        }
                        case "TLQ_Smoker": {
                            sendData_1 = __assign(__assign({}, sendData_1), { questionnaire: __assign(__assign({}, sendData_1.questionnaire), { questions: updatePayload(sendData_1.questionnaire.questions, "TLQ_Smoker", parseInt(user_1.data.smoker) === 1
                                        ? { id: "Yes", label: "Yes" }
                                        : { id: "No", label: "No" }) }) });
                            break;
                        }
                    }
                });
                return [4 /*yield*/, effects.call(api.questions.riskAssessmetnResource, sendData_1)];
            case 6:
                data = (_b.sent()).data;
                if (!!data) return [3 /*break*/, 8];
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 7:
                _b.sent();
                return [3 /*break*/, 14];
            case 8:
                computed = getQuestionsOnly(sendData_1.questionnaire.questions);
                return [4 /*yield*/, effects.put(setQuestions({
                        rasPayload: data,
                        computed: computed,
                    }))];
            case 9:
                _b.sent();
                return [4 /*yield*/, effects.put(setFormatedQuestions(formatQuestions(computed)))];
            case 10:
                _b.sent();
                getInsuredPersonAnnualIncomeAnswerState = computed.find(function (item) {
                    return item.id === "TLQ_MarijuanaUseLastYear";
                });
                if (!(getInsuredPersonAnnualIncomeAnswerState &&
                    getInsuredPersonAnnualIncomeAnswerState.answerState ===
                        "valid")) return [3 /*break*/, 12];
                return [4 /*yield*/, effects.put(setCanTheAssessmentBeStopped(true))];
            case 11:
                _b.sent();
                _b.label = 12;
            case 12: return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 13:
                _b.sent();
                _b.label = 14;
            case 14: return [3 /*break*/, 15];
            case 15: return [3 /*break*/, 18];
            case 16:
                error_2 = _b.sent();
                console.log({ error: error_2 });
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 17:
                _b.sent();
                return [3 /*break*/, 18];
            case 18: return [2 /*return*/];
        }
    });
}
function setNewRasPayloadHandle(_a) {
    var selectedRasPayload, sendData, data, computed, currentIndex, nextQuestion;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(payload === "LiveQuestionnaire")) return [3 /*break*/, 2];
                return [4 /*yield*/, effects.put(getQuestions())];
            case 1:
                _b.sent();
                return [3 /*break*/, 17];
            case 2: return [4 /*yield*/, effects.call(api.questions.fetchJsonRasPayload, payload)];
            case 3:
                selectedRasPayload = _b.sent();
                return [4 /*yield*/, effects.put(setQuestionsLoading(true))];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5:
                _b.trys.push([5, 15, , 17]);
                sendData = __assign({}, selectedRasPayload);
                return [4 /*yield*/, effects.call(api.questions.riskAssessmetnResource, sendData)];
            case 6:
                data = (_b.sent()).data;
                if (!!data) return [3 /*break*/, 8];
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 7:
                _b.sent();
                return [3 /*break*/, 14];
            case 8:
                computed = getQuestionsOnly(data.questionnaire.questions);
                currentIndex = 0;
                return [4 /*yield*/, effects.put(setQuestions({
                        rasPayload: data,
                        computed: computed,
                    }))];
            case 9:
                _b.sent();
                if (!(currentIndex < computed.length - 1)) return [3 /*break*/, 11];
                nextQuestion = currentIndex;
                return [4 /*yield*/, effects.put(setQuestion(computed[nextQuestion]))];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [4 /*yield*/, handleReturnedData(computed, data, currentIndex)];
            case 12:
                _b.sent();
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 13:
                _b.sent();
                _b.label = 14;
            case 14: return [3 /*break*/, 17];
            case 15:
                _b.sent();
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 16:
                _b.sent();
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
function rootSaga$3() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([
                    effects.takeEvery(EQuestionsActionTypes.getQuestions, getQuestionsHandle),
                    effects.takeEvery(EQuestionsActionTypes.initQuestions, initQuestionsHandle),
                    effects.takeEvery(EQuestionsActionTypes.setNewRasPayload, setNewRasPayloadHandle),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

function deleteAllAnswersAfterQuestion(questionId, currentIndex) {
    var rasPayload, useJuvenileProduct, reflexProduct, computedQuestions, questions, i, temporaryResults, sendData, data, computed;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.select(getRASPayload)];
            case 1:
                rasPayload = _a.sent();
                return [4 /*yield*/, effects.select(getApplicationUseJuvenileProduct)];
            case 2:
                useJuvenileProduct = _a.sent();
                reflexProduct = useJuvenileProduct
                    ? EProducts.LifeTermJuvenilesProduct
                    : EProducts.LifeTermProduct;
                return [4 /*yield*/, effects.select(getComputedQuestions)];
            case 3:
                computedQuestions = _a.sent();
                questions = [];
                for (i = currentIndex + 1; i < computedQuestions.length; i++) {
                    if (questionMappingPerProduct[reflexProduct].indexOf(computedQuestions[i].id) !== -1)
                        continue;
                    temporaryResults = updatePayload(rasPayload === null || rasPayload === void 0 ? void 0 : rasPayload.questionnaire.questions, computedQuestions[i].id, null);
                    questions = __spreadArrays(temporaryResults);
                }
                sendData = __assign(__assign({}, rasPayload), { questionnaire: __assign(__assign({}, rasPayload === null || rasPayload === void 0 ? void 0 : rasPayload.questionnaire), { questions: questions }) });
                return [4 /*yield*/, effects.call(api.questions.riskAssessmetnResource, sendData)];
            case 4:
                data = (_a.sent()).data;
                computed = getQuestionsOnly(data.questionnaire.questions);
                return [4 /*yield*/, effects.put(setQuestions({
                        rasPayload: data,
                        computed: computed,
                    }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleReturnedData(computedQuestions, serverPayload, currentIndex) {
    var formattedQuestions, currentQuestion, lastAnsweredQuestion, userInfo, coverageValue, assessmentLoadingValue, termsAndRisksData, decisionStatus, selectedTerm, computedRisk, hasUsedVoice, selectedProductData;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                formattedQuestions = formatQuestions(computedQuestions);
                currentQuestion = computedQuestions[currentIndex];
                if (currentQuestion.id === heightAndWeightQuestionsIds.HeightUS ||
                    currentQuestion.id === heightAndWeightQuestionsIds.JuvenilesHeightUS) {
                    // convert the inches in feet and inches
                    lastAnsweredQuestion = {
                        answer: currentQuestion.answer
                            ? Math.floor(currentQuestion.answer / 12) + "' " + currentQuestion.answer % 12
                            : null,
                        question: currentQuestion ? currentQuestion.caption : null,
                    };
                }
                else {
                    lastAnsweredQuestion = {
                        answer: currentQuestion ? currentQuestion.answer : null,
                        question: currentQuestion ? currentQuestion.caption : null,
                    };
                }
                return [4 /*yield*/, effects.put(setFormatedQuestions(formattedQuestions))];
            case 1:
                _d.sent();
                if (!(typeof exports.updateReflex !== "undefined")) return [3 /*break*/, 9];
                return [4 /*yield*/, effects.select(getUserFromStore)];
            case 2:
                userInfo = _d.sent();
                return [4 /*yield*/, effects.select(getCoverage)];
            case 3:
                coverageValue = _d.sent();
                return [4 /*yield*/, effects.select(getAssessmentLoadingValue)];
            case 4:
                assessmentLoadingValue = _d.sent();
                return [4 /*yield*/, effects.select(getTermsAndRisksData)];
            case 5:
                termsAndRisksData = _d.sent();
                decisionStatus = serverPayload.results.products[0].aggregatedRating.id.toLowerCase();
                return [4 /*yield*/, effects.select(getSelectedTerm)];
            case 6:
                selectedTerm = _d.sent();
                return [4 /*yield*/, effects.select(getComputedRisk)];
            case 7:
                computedRisk = _d.sent();
                return [4 /*yield*/, effects.select(getApplicationHasUsedVoice)];
            case 8:
                hasUsedVoice = _d.sent();
                selectedProductData = getProductVersionAndCodeForCallCenter({
                    products: termsAndRisksData === null || termsAndRisksData === void 0 ? void 0 : termsAndRisksData.data,
                    selectedTerm: selectedTerm,
                    risk: computedRisk,
                });
                exports.updateReflex({
                    decision: { status: decisionStatus, reason: "" },
                    application_id: (_a = userInfo.data) === null || _a === void 0 ? void 0 : _a.application_id,
                    term: selectedTerm,
                    risk: computedRisk,
                    smoker: (_b = userInfo.data) === null || _b === void 0 ? void 0 : _b.smoker,
                    smokerFE: (_c = userInfo.data) === null || _c === void 0 ? void 0 : _c.smokerFE,
                    coverage: coverageValue.value,
                    questions: formatQuestions(computedQuestions, []),
                    serverPayload: serverPayload,
                    maxCoverage: coverageValue.forcedMax &&
                        coverageValue.forcedMax < coverageValue.maxValue
                        ? coverageValue.forcedMax
                        : coverageValue.maxValue,
                    forcedStop: (assessmentLoadingValue &&
                        assessmentLoadingValue >= 201) ||
                        (serverPayload === null || serverPayload === void 0 ? void 0 : serverPayload.results.products[0].aggregatedRating.id.toLowerCase()) ===
                            "Decline".toLowerCase(),
                    product_id: selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.code,
                    last_question: lastAnsweredQuestion,
                    product_code: selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.code,
                    product_version: selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.version,
                    hasUsedVoice: hasUsedVoice,
                });
                _d.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}
function updatePayload(payloadData, questionId, answer) {
    var payload = ___default["default"].cloneDeep(payloadData);
    if (answer === undefined) {
        payload = payload.filter(function (item) { return item.id !== questionId; });
    }
    for (var i in payload) {
        if (payload[i].type === "group" ||
            payload[i].type === "assessment-factor-group")
            payload[i].questions = updatePayload(payload[i].questions, questionId, answer);
        else {
            try {
                if (payload[i].id === questionId) {
                    if (answer && answer.elements) {
                        var _loop_1 = function (j) {
                            var index = payload[i].elements.findIndex(function (item) { return item.id === j; });
                            if (index !== -1) {
                                if (answer !== null) {
                                    payload[i].elements[index].answer =
                                        answer.elements[j];
                                }
                                else {
                                    delete payload[i].elements[index].answer;
                                    payload[i].elements[index].answerState =
                                        "missing";
                                }
                            }
                        };
                        for (var j in answer.elements) {
                            _loop_1(j);
                        }
                    }
                    else if (answer !== null) {
                        var clean = [];
                        if (Array.isArray(answer)) {
                            var ids = [];
                            for (var i_1 in answer) {
                                if (ids.indexOf(answer[i_1].id) === -1) {
                                    clean.push(answer[i_1]);
                                    ids.push(answer[i_1].id);
                                }
                            }
                        }
                        else {
                            clean = answer;
                        }
                        payload[i].answer = clean;
                    }
                    else {
                        delete payload[i].answer;
                        payload[i].answerState = "missing";
                    }
                }
                else if (payload[i].hasReflexive && payload[i].questions) {
                    payload[i].questions = updatePayload(payload[i].questions, questionId, answer);
                }
            }
            catch (err) {
                console.log({ err: err });
            }
        }
    }
    return payload;
}
function getQuestionsOnly(data, fallbackIndex, groupCaption) {
    if (fallbackIndex === void 0) { fallbackIndex = undefined; }
    if (groupCaption === void 0) { groupCaption = ""; }
    var result = [];
    for (var i in data) {
        if (data[i].type === "group" ||
            data[i].type === "assessment-factor-group")
            result = result.concat(getQuestionsOnly(data[i].questions, data[i].index, data[i].caption));
        else {
            if (!data[i].index)
                data[i].index = fallbackIndex;
            data[i].groupCaption = groupCaption;
            result.push(data[i]);
            if (data[i].hasReflexive && data[i].questions) {
                result = result.concat(getQuestionsOnly(data[i].questions, data[i].index, data[i].caption));
            }
        }
    }
    return result;
}
function updateQuestionHandle(_a) {
    var error_1;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                return [4 /*yield*/, effects.put(setQuestionLoading(true))];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects.put(setQuestion(payload))];
            case 2:
                _b.sent();
                return [4 /*yield*/, effects.put(setQuestionLoading(false))];
            case 3:
                _b.sent();
                return [3 /*break*/, 5];
            case 4:
                error_1 = _b.sent();
                console.log({ error: error_1 });
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function parseNextQuestion(_a) {
    var useJuvenileProduct, currentIndex, userInfo, assessmentLoadingValue, isQuestionnaireDeclined, isQuestionnaireCompleted, isQuestionnaireStopped, finalQuestionId, finalQuestionIndex, nextQuestion, missingQuestion, nextQuestion, missingQuestion, nextQuestion, nextQuestion, missingQuestion;
    var _b, _c, _d, _e, _f;
    var questionnaireData = _a.questionnaireData, computed = _a.computed, currentQuestion = _a.currentQuestion;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0: return [4 /*yield*/, effects.select(getApplicationUseJuvenileProduct)];
            case 1:
                useJuvenileProduct = _g.sent();
                currentIndex = computed.findIndex(function (item) { return item.id === currentQuestion.id; });
                return [4 /*yield*/, effects.select(getUserFromStore)];
            case 2:
                userInfo = _g.sent();
                return [4 /*yield*/, effects.select(getAssessmentLoadingValue)];
            case 3:
                assessmentLoadingValue = _g.sent();
                isQuestionnaireDeclined = ((_e = (_d = (_c = (_b = questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.results) === null || _b === void 0 ? void 0 : _b.products[0]) === null || _c === void 0 ? void 0 : _c.aggregatedRating) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.toLowerCase()) ===
                    "Decline".toLowerCase();
                isQuestionnaireCompleted = questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.completed;
                isQuestionnaireStopped = isQuestionnaireCompleted ||
                    isQuestionnaireDeclined ||
                    (assessmentLoadingValue && assessmentLoadingValue >= 201);
                return [4 /*yield*/, effects.select(getFinalQuestion)];
            case 4:
                finalQuestionId = _g.sent();
                finalQuestionIndex = computed.findIndex(function (item) { return item.id === finalQuestionId; });
                if (parseInt(finalQuestionIndex) === -1) {
                    finalQuestionIndex = computed.length - 1;
                }
                return [4 /*yield*/, effects.put(setQuestionnaireCompleted(isQuestionnaireStopped))];
            case 5:
                _g.sent();
                if (!(!!finalQuestionId && !isQuestionnaireStopped)) return [3 /*break*/, 7];
                finalQuestionId = null;
                finalQuestionIndex = -1;
                return [4 /*yield*/, effects.put(setFinalQuestion({ questionId: null }))];
            case 6:
                _g.sent();
                _g.label = 7;
            case 7:
                if (!(((_f = userInfo.data) === null || _f === void 0 ? void 0 : _f.isCallCenter) === 1)) return [3 /*break*/, 20];
                if (!(isQuestionnaireStopped === true)) return [3 /*break*/, 17];
                if (!(!isQuestionnaireCompleted && !finalQuestionId)) return [3 /*break*/, 12];
                return [4 /*yield*/, deleteAllAnswersAfterQuestion(currentQuestion.id, currentIndex)];
            case 8:
                _g.sent();
                return [4 /*yield*/, effects.put(setFinalQuestion({
                        questionId: currentQuestion.id,
                    }))];
            case 9:
                _g.sent();
                // 5 => the highest risk class
                // 100 => the highest term
                return [4 /*yield*/, effects.put(setTermAndComputedRisk({
                        term: !useJuvenileProduct
                            ? EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsTerm
                            : undefined,
                        computedRisk: !useJuvenileProduct
                            ? EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                            : EMaxAndMinTermAndRisk.maxJuvenileProductsRisk,
                    }))];
            case 10:
                // 5 => the highest risk class
                // 100 => the highest term
                _g.sent();
                return [4 /*yield*/, effects.put(computeCoverageMinMax({
                        selectedTerm: !useJuvenileProduct
                            ? EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsTerm
                            : undefined,
                        computedRisk: !useJuvenileProduct
                            ? EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                            : EMaxAndMinTermAndRisk.maxJuvenileProductsRisk,
                    }))];
            case 11:
                _g.sent();
                _g.label = 12;
            case 12:
                if (!isQuestionnaireDeclined) return [3 /*break*/, 14];
                return [4 /*yield*/, effects.put(setQuestion(computed[currentIndex]))];
            case 13:
                _g.sent();
                return [3 /*break*/, 16];
            case 14:
                if (!(currentIndex < finalQuestionIndex)) return [3 /*break*/, 16];
                nextQuestion = currentIndex;
                missingQuestion = computed.findIndex(function (item, index) { return item.answerState === "missing"; });
                if (missingQuestion === -1) {
                    do {
                        nextQuestion++;
                    } while (nextQuestion < finalQuestionIndex &&
                        questionMappingPerProduct.LifeTermProduct.indexOf(computed[nextQuestion].id) !== -1);
                }
                else {
                    nextQuestion = missingQuestion;
                }
                return [4 /*yield*/, effects.put(setQuestion(computed[nextQuestion]))];
            case 15:
                _g.sent();
                _g.label = 16;
            case 16: return [3 /*break*/, 19];
            case 17:
                if (!(currentIndex < computed.length - 1)) return [3 /*break*/, 19];
                nextQuestion = currentIndex;
                missingQuestion = computed.findIndex(function (item, index) {
                    return item.answerState === "missing";
                });
                if (missingQuestion === -1) {
                    do {
                        nextQuestion++;
                    } while (nextQuestion < computed.length &&
                        questionMappingPerProduct.LifeTermProduct.indexOf(computed[nextQuestion].id) !== -1);
                }
                else {
                    nextQuestion = missingQuestion;
                }
                return [4 /*yield*/, effects.put(setQuestion(computed[nextQuestion]))];
            case 18:
                _g.sent();
                _g.label = 19;
            case 19: return [3 /*break*/, 29];
            case 20:
                if (!(isQuestionnaireStopped === true)) return [3 /*break*/, 27];
                if (!(!isQuestionnaireCompleted && !finalQuestionId)) return [3 /*break*/, 24];
                // yield deleteAllAnswersAfterQuestion(
                //   currentQuestion.id,
                //   currentIndex
                // );
                return [4 /*yield*/, effects.put(setFinalQuestion({
                        questionId: currentQuestion.id,
                    }))];
            case 21:
                // yield deleteAllAnswersAfterQuestion(
                //   currentQuestion.id,
                //   currentIndex
                // );
                _g.sent();
                // 5 => the highest risk class
                // 100 => the highest term
                return [4 /*yield*/, effects.put(setTermAndComputedRisk({
                        term: !useJuvenileProduct
                            ? EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsTerm
                            : undefined,
                        computedRisk: !useJuvenileProduct
                            ? EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                            : EMaxAndMinTermAndRisk.maxJuvenileProductsRisk,
                    }))];
            case 22:
                // 5 => the highest risk class
                // 100 => the highest term
                _g.sent();
                return [4 /*yield*/, effects.put(computeCoverageMinMax({
                        selectedTerm: !useJuvenileProduct
                            ? EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsTerm
                            : undefined,
                        computedRisk: !useJuvenileProduct
                            ? EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                            : EMaxAndMinTermAndRisk.maxJuvenileProductsRisk,
                    }))];
            case 23:
                _g.sent();
                _g.label = 24;
            case 24:
                nextQuestion = void 0;
                if (!(currentIndex <= computed.length - 1)) return [3 /*break*/, 26];
                nextQuestion = computed.length - 1;
                // nextQuestion = computed.length - 1;
                // if in the questions list exists a question with array's index < currentIndex where answer state is missing
                // the user will be redirected to that specific question
                // const missingQuestion = computed.findIndex(
                //   (item: { answerState: "valid" | "missing" }, index: number) =>
                //     item.answerState === "missing"
                // );
                // if (missingQuestion === -1) {
                // do {
                //   nextQuestion++;
                // } while (
                //   nextQuestion < finalQuestionIndex &&
                //   questionMappingPerProduct.LifeTermProduct.indexOf(
                //     computed[nextQuestion].id
                //   ) !== -1
                // );
                // } else {
                //   nextQuestion = missingQuestion;
                // }
                if (isQuestionnaireDeclined) {
                    if (finalQuestionId) {
                        if (currentIndex < finalQuestionIndex)
                            nextQuestion = currentIndex + 1;
                        else
                            nextQuestion = finalQuestionIndex;
                    }
                    else {
                        nextQuestion = currentIndex;
                    }
                }
                return [4 /*yield*/, effects.put(setQuestion(computed[nextQuestion]))];
            case 25:
                _g.sent();
                _g.label = 26;
            case 26: return [3 /*break*/, 29];
            case 27:
                if (!(currentIndex < computed.length - 1)) return [3 /*break*/, 29];
                nextQuestion = currentIndex;
                missingQuestion = computed.findIndex(function (item, index) {
                    return item.answerState === "missing";
                });
                if (missingQuestion === -1) {
                    do {
                        nextQuestion++;
                    } while (nextQuestion < computed.length &&
                        questionMappingPerProduct.LifeTermProduct.indexOf(computed[nextQuestion].id) !== -1);
                }
                else {
                    nextQuestion = missingQuestion;
                }
                return [4 /*yield*/, effects.put(setQuestion(computed[nextQuestion]))];
            case 28:
                _g.sent();
                _g.label = 29;
            case 29: return [2 /*return*/];
        }
    });
}
function parseAnswerData(_a) {
    var useJuvenileProduct, user, currentIndex, smokingRelatedQuestions, smokingFEStatus_1, riskClass, term, assessmentLoadingValue, questionnaireResolution, messagesErrorType, productsMessages, premiumLoadingElement, exclusion, max;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var questionnaireData = _a.questionnaireData, currentQuestion = _a.currentQuestion, questionAnswered = _a.questionAnswered, computed = _a.computed, isGroupedQuestion = _a.isGroupedQuestion;
    return __generator(this, function (_x) {
        switch (_x.label) {
            case 0: return [4 /*yield*/, effects.select(getApplicationUseJuvenileProduct)];
            case 1:
                useJuvenileProduct = _x.sent();
                return [4 /*yield*/, effects.select(getUserFromStore)];
            case 2:
                user = _x.sent();
                currentIndex = computed.findIndex(function (item) { return item.id === currentQuestion.id; });
                if (!(questionAnswered.id === smokerQuestionsIds.TLQ_MarijuanaUseLastYear ||
                    questionAnswered.id === smokerQuestionsIds.TLQ_Smoker)) return [3 /*break*/, 6];
                smokingRelatedQuestions = computed.filter(function (item) {
                    return item.id === smokerQuestionsIds.TLQ_Smoker ||
                        item.id === smokerQuestionsIds.TLQ_MarijuanaUseLastYear;
                });
                smokingFEStatus_1 = "0";
                smokingRelatedQuestions.forEach(function (question) {
                    var _a;
                    if (((_a = question === null || question === void 0 ? void 0 : question.answer) === null || _a === void 0 ? void 0 : _a.id) === "Yes") {
                        smokingFEStatus_1 = "1";
                    }
                });
                if (!(((_b = questionAnswered.answer) === null || _b === void 0 ? void 0 : _b.id) === "Yes")) return [3 /*break*/, 4];
                return [4 /*yield*/, effects.put(setUserSmokerFE(smokingFEStatus_1))];
            case 3:
                _x.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects.put(setUserSmokerFE(smokingFEStatus_1))];
            case 5:
                _x.sent();
                _x.label = 6;
            case 6:
                if (!(questionAnswered.id === smokerQuestionsIds.HowManySmokePerYear)) return [3 /*break*/, 11];
                if (!(parseInt(questionAnswered.answer) <= 12)) return [3 /*break*/, 8];
                return [4 /*yield*/, effects.put(setUserSmoker("0"))];
            case 7:
                _x.sent();
                return [3 /*break*/, 10];
            case 8:
                if (!(parseInt(questionAnswered.answer) > 12)) return [3 /*break*/, 10];
                return [4 /*yield*/, effects.put(setUserSmoker("1"))];
            case 9:
                _x.sent();
                _x.label = 10;
            case 10: return [3 /*break*/, 17];
            case 11:
                if (!(questionAnswered.id === smokerQuestionsIds.IsSmokingLimitedToCigars)) return [3 /*break*/, 15];
                if (!(((_c = questionAnswered.answer) === null || _c === void 0 ? void 0 : _c.id) === "Yes")) return [3 /*break*/, 12];
                return [3 /*break*/, 14];
            case 12:
                if (!(((_d = questionAnswered.answer) === null || _d === void 0 ? void 0 : _d.id) === "No")) return [3 /*break*/, 14];
                return [4 /*yield*/, effects.put(setUserSmoker("1"))];
            case 13:
                _x.sent();
                _x.label = 14;
            case 14: return [3 /*break*/, 17];
            case 15:
                if (!(questionAnswered.id === smokerQuestionsIds.TLQ_Smoker)) return [3 /*break*/, 17];
                if (!(((_e = questionAnswered.answer) === null || _e === void 0 ? void 0 : _e.id) === "No")) return [3 /*break*/, 17];
                return [4 /*yield*/, effects.put(setUserSmoker("0"))];
            case 16:
                _x.sent();
                _x.label = 17;
            case 17: return [4 /*yield*/, effects.select(getComputedRisk)];
            case 18:
                riskClass = _x.sent();
                return [4 /*yield*/, effects.select(getSelectedTerm)];
            case 19:
                term = _x.sent();
                assessmentLoadingValue = 0;
                if (!((_f = questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.results) === null || _f === void 0 ? void 0 : _f.products)) return [3 /*break*/, 21];
                questionnaireResolution = undefined;
                questionnaireResolution = {
                    id: questionnaireData.results.products[0].aggregatedRating.id || "",
                    caption: (questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.results.products[0].aggregatedRating.caption) || "",
                };
                return [4 /*yield*/, effects.put(setQuestionnaireResolution(questionnaireResolution))];
            case 20:
                _x.sent();
                return [3 /*break*/, 24];
            case 21:
                if (!((questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.products) && ((_g = questionnaireData.products[0]) === null || _g === void 0 ? void 0 : _g.messages))) return [3 /*break*/, 24];
                messagesErrorType = questionnaireData.products[0].messages.find(function (item) { return item.type === "error"; });
                if (!messagesErrorType) return [3 /*break*/, 24];
                productsMessages = questionnaireData.products[0].messages;
                // TODO: setTheApplicatntAgeIsTooLow should be renamed in something more generic because the error messages can be different.
                return [4 /*yield*/, effects.put(setTheApplicatntAgeIsTooLow({
                        messages: productsMessages,
                    }))];
            case 22:
                // TODO: setTheApplicatntAgeIsTooLow should be renamed in something more generic because the error messages can be different.
                _x.sent();
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 23:
                _x.sent();
                return [2 /*return*/];
            case 24:
                if (((_l = (_k = (_j = (_h = questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.results) === null || _h === void 0 ? void 0 : _h.products[0]) === null || _j === void 0 ? void 0 : _j.aggregatedRating) === null || _k === void 0 ? void 0 : _k.id) === null || _l === void 0 ? void 0 : _l.toLowerCase()) ===
                    "Accept".toLowerCase()) {
                    riskClass = useJuvenileProduct
                        ? EMaxAndMinTermAndRisk.minJuvenileProductsRisk
                        : EMaxAndMinTermAndRisk.minSureAndEvolutionProductsRisk;
                }
                else if (((_q = (_p = (_o = (_m = questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.results) === null || _m === void 0 ? void 0 : _m.products[0]) === null || _o === void 0 ? void 0 : _o.aggregatedRating) === null || _p === void 0 ? void 0 : _p.id) === null || _q === void 0 ? void 0 : _q.toLowerCase()) ===
                    "Offer".toLowerCase()) {
                    premiumLoadingElement = (_s = (_r = questionnaireData.results.products[0].aggregatedRating) === null || _r === void 0 ? void 0 : _r.attributes) === null || _s === void 0 ? void 0 : _s.find(function (item) { return item.id.toLowerCase().indexOf("loading") !== -1; });
                    // TODO: Talk with Rares about this. Is this available for Juvenile?
                    if (premiumLoadingElement) {
                        assessmentLoadingValue = premiumLoadingElement.value;
                        if (!useJuvenileProduct) {
                            if (assessmentLoadingValue >= 201) {
                                riskClass =
                                    EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk;
                                term = EProductTerm.T100;
                            }
                            else if (assessmentLoadingValue >= 1 &&
                                assessmentLoadingValue <= 25) {
                                riskClass = 1;
                            }
                            else if (assessmentLoadingValue >= 26 &&
                                assessmentLoadingValue <= 74) {
                                riskClass = 2;
                            }
                            else if (assessmentLoadingValue >= 75 &&
                                assessmentLoadingValue <= 125) {
                                riskClass = 3;
                            }
                            else if (assessmentLoadingValue >= 126 &&
                                assessmentLoadingValue <= 200) {
                                riskClass = 4;
                            }
                        }
                        else {
                            if (assessmentLoadingValue < 126) {
                                riskClass = EMaxAndMinTermAndRisk.minJuvenileProductsRisk;
                            }
                            else {
                                riskClass = EMaxAndMinTermAndRisk.maxJuvenileProductsRisk;
                            }
                        }
                    }
                    else {
                        // if there is no loading value, risk class should be 1
                        riskClass = useJuvenileProduct
                            ? EMaxAndMinTermAndRisk.minJuvenileProductsRisk
                            : EMaxAndMinTermAndRisk.minSureAndEvolutionProductsRisk;
                    }
                }
                return [4 /*yield*/, effects.put(setLoadingValue(assessmentLoadingValue))];
            case 25:
                _x.sent();
                return [4 /*yield*/, effects.put(setTermAndComputedRisk({ term: term, computedRisk: riskClass }))];
            case 26:
                _x.sent();
                return [4 /*yield*/, effects.put(computeCoverageMinMax({
                        selectedTerm: parseInt(term.toString()),
                        computedRisk: parseInt(riskClass.toString()),
                    }))];
            case 27:
                _x.sent();
                exclusion = (_w = (_v = (_u = (_t = questionnaireData === null || questionnaireData === void 0 ? void 0 : questionnaireData.results) === null || _t === void 0 ? void 0 : _t.products[0]) === null || _u === void 0 ? void 0 : _u.aggregatedRating) === null || _v === void 0 ? void 0 : _v.attributes) === null || _w === void 0 ? void 0 : _w.find(function (item) { return item.id.toLowerCase().indexOf("exclusion") !== -1; });
                if (!((exclusion === null || exclusion === void 0 ? void 0 : exclusion.value.toLowerCase().indexOf("maximum ")) === 0 ||
                    (exclusion === null || exclusion === void 0 ? void 0 : exclusion.value.toLowerCase().indexOf("le montant maximum ")) === 0)) return [3 /*break*/, 29];
                max = exclusion.value.match(/(\d+)/g);
                if (!(max && max.length && user.data)) return [3 /*break*/, 29];
                return [4 /*yield*/, effects.put(setCoverage({
                        currentStatusInCanada: user.data.currentStatusInCanada,
                        bankruptcyStatus: user.data.bankruptcyStatus,
                        maxValue: parseInt(max.join("")),
                    }))];
            case 28:
                _x.sent();
                _x.label = 29;
            case 29:
                if (!!isGroupedQuestion) return [3 /*break*/, 31];
                return [4 /*yield*/, parseNextQuestion({
                        questionnaireData: questionnaireData,
                        computed: computed,
                        currentQuestion: currentQuestion,
                    })];
            case 30:
                _x.sent();
                _x.label = 31;
            case 31: return [4 /*yield*/, handleReturnedData(computed, questionnaireData, currentIndex)];
            case 32:
                _x.sent();
                return [2 /*return*/];
        }
    });
}
function answerQuestionHandle(_a) {
    var answer, question, isGroupedQuestion, groupedQuestionsAnswer, currentQuestion_1, _b, rasPayload, updatedPayload, sendData, data, resultedRasPayload, computed, currentIndex, questionAnswered, errorMessages;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 20, , 22]);
                answer = payload.answer, question = payload.question, isGroupedQuestion = payload.isGroupedQuestion, groupedQuestionsAnswer = payload.groupedQuestionsAnswer;
                return [4 /*yield*/, effects.put(setQuestionsLoading(true))];
            case 1:
                _c.sent();
                if (!question) return [3 /*break*/, 2];
                _b = question;
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, effects.select(getCurrentQuestion)];
            case 3:
                _b = _c.sent();
                _c.label = 4;
            case 4:
                currentQuestion_1 = __rest.apply(void 0, [_b, []]);
                return [4 /*yield*/, effects.select(getRASPayload)];
            case 5:
                rasPayload = __rest.apply(void 0, [_c.sent(), []]);
                updatedPayload = updatePayload(rasPayload.questionnaire.questions, currentQuestion_1.id, answer);
                sendData = __assign(__assign({}, rasPayload), { questionnaire: __assign(__assign({}, rasPayload.questionnaire), { questions: updatedPayload }) });
                return [4 /*yield*/, effects.call(api.questions.riskAssessmetnResource, sendData)];
            case 6:
                data = (_c.sent()).data;
                if (!!data) return [3 /*break*/, 8];
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 7:
                _c.sent();
                return [3 /*break*/, 19];
            case 8:
                resultedRasPayload = data;
                computed = getQuestionsOnly(resultedRasPayload.questionnaire.questions);
                currentIndex = computed.findIndex(function (item) { return item.id === currentQuestion_1.id; });
                questionAnswered = computed[currentIndex];
                // if the answer is not valid set the current question with the new data returned from the server and STOP the process
                if (questionAnswered &&
                    questionAnswered.answerState === "invalid") {
                    errorMessages = [];
                    if (questionAnswered.messages) {
                        errorMessages = questionAnswered === null || questionAnswered === void 0 ? void 0 : questionAnswered.messages.filter(function (item) {
                            return item.type.toLowerCase().trim() === "error";
                        }).map(function (item) { return item.message; });
                    }
                    if (errorMessages.length > 0) {
                        notify("error", errorMessages.join(", "));
                    }
                    else {
                        notify("error", i18n__default["default"].t("Something went wrong"));
                    }
                    throw new Error("Invalid data!");
                }
                return [4 /*yield*/, effects.put(setQuestions({
                        rasPayload: resultedRasPayload,
                        computed: computed,
                    }))];
            case 9:
                _c.sent();
                if (!(questionAnswered.id ===
                    canadianCitizenStatusQuestionId.CanadianCitizenStatus)) return [3 /*break*/, 11];
                return [4 /*yield*/, effects.put(setCurrentStatusInCanada({
                        statusInCanada: questionAnswered.answer.id,
                    }))];
            case 10:
                _c.sent();
                _c.label = 11;
            case 11:
                if (!(questionAnswered.id === HAVE_YOU_DECLARED_BANKRUPTCY_QUESTION_ID)) return [3 /*break*/, 13];
                return [4 /*yield*/, effects.put(setUserBankruptcyStatus(questionAnswered.answer.id.toLowerCase()))];
            case 12:
                _c.sent();
                _c.label = 13;
            case 13:
                if (!groupedQuestionsAnswer) return [3 /*break*/, 15];
                return [4 /*yield*/, parseNextQuestion({
                        questionnaireData: resultedRasPayload,
                        currentQuestion: currentQuestion_1,
                        computed: computed,
                    })];
            case 14:
                _c.sent();
                return [3 /*break*/, 17];
            case 15: return [4 /*yield*/, parseAnswerData({
                    questionnaireData: resultedRasPayload,
                    currentQuestion: currentQuestion_1,
                    questionAnswered: questionAnswered,
                    computed: computed,
                    isGroupedQuestion: isGroupedQuestion,
                })];
            case 16:
                _c.sent();
                _c.label = 17;
            case 17: return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 18:
                _c.sent();
                _c.label = 19;
            case 19: return [3 /*break*/, 22];
            case 20:
                _c.sent();
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 21:
                _c.sent();
                return [3 /*break*/, 22];
            case 22: return [2 /*return*/];
        }
    });
}
function setPrevQuestionHandle(_a) {
    var groupedQuestionCategory, currentQuestion_2, computed, currentIndex, prevQuestion, error_3;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 8]);
                groupedQuestionCategory = (payload || {}).groupedQuestionCategory;
                return [4 /*yield*/, effects.put(setQuestionsLoading(true))];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects.select(getCurrentQuestion)];
            case 2:
                currentQuestion_2 = _b.sent();
                return [4 /*yield*/, effects.select(getComputedQuestions)];
            case 3:
                computed = _b.sent();
                currentIndex = computed.findIndex(function (item) { return item.id === currentQuestion_2.id; });
                prevQuestion = currentIndex;
                do {
                    prevQuestion--;
                } while (prevQuestion > 0 &&
                    questionMappingPerProduct.LifeTermProduct.indexOf(computed[prevQuestion].id) !== -1);
                if (groupedQuestionCategory) {
                    while (
                    // @ts-ignore
                    groupedQuestionsCategories[groupedQuestionCategory].ids.includes(computed[prevQuestion].id)) {
                        prevQuestion--;
                    }
                }
                return [4 /*yield*/, effects.put(setQuestion(computed[prevQuestion]))];
            case 4:
                _b.sent();
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6:
                error_3 = _b.sent();
                console.log({ error: error_3 });
                return [4 /*yield*/, effects.put(setQuestionsLoading(false))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function rootSaga$2() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([
                    effects.takeEvery(EQuestionActionTypes.updateQuestion, updateQuestionHandle),
                    effects.takeEvery(EQuestionActionTypes.answerQuestion, answerQuestionHandle),
                    effects.takeEvery(EQuestionActionTypes.setPrevQuestion, setPrevQuestionHandle),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

function getTermsAndRisksHandle(_a) {
    var initTheEditProcess, user_1, callCenterEvolutionTermsAndRisksData, resultedTermsAndRisksData, applicantAge_1, isCallCenter, useJuvenileProduct, data, termsAndRisksData, parsedCallCenterEvolutionTermsAndRiskData, parsedTermsAndRisksData, mergedData, _b, initProductVersion_1, initRisk_1, initTerm_1, overwriteTermsAndRisksWithInitData, disabledTermsAccordingToApplicantAge, error_1;
    var _c, _d;
    var payload = _a.payload;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                initTheEditProcess = (payload || {}).initTheEditProcess;
                _e.label = 1;
            case 1:
                _e.trys.push([1, 15, , 17]);
                // IMPORTANT NOTE: If the app is in call center mode and the applicant age is <= ageRangeForEvolutionAndSureTermApi.lowerLimit
                // get the terms from evolution api for T10, T20 and T20 products and for T100 product from reflex api
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(true))];
            case 2:
                // IMPORTANT NOTE: If the app is in call center mode and the applicant age is <= ageRangeForEvolutionAndSureTermApi.lowerLimit
                // get the terms from evolution api for T10, T20 and T20 products and for T100 product from reflex api
                _e.sent();
                return [4 /*yield*/, effects.select(getUserFromStore)];
            case 3:
                user_1 = _e.sent();
                callCenterEvolutionTermsAndRisksData = null;
                resultedTermsAndRisksData = null;
                applicantAge_1 = (_c = user_1 === null || user_1 === void 0 ? void 0 : user_1.data) === null || _c === void 0 ? void 0 : _c.nearestAge;
                isCallCenter = (_d = user_1 === null || user_1 === void 0 ? void 0 : user_1.data) === null || _d === void 0 ? void 0 : _d.isCallCenter;
                return [4 /*yield*/, effects.select(getApplicationUseJuvenileProduct)];
            case 4:
                useJuvenileProduct = _e.sent();
                if (applicantAge_1 == null) {
                    throw Error("The applicant's age is missing!");
                }
                if (!(!useJuvenileProduct &&
                    (isCallCenter === 1 || isCallCenter === 2) &&
                    applicantAge_1 <= ageRangeForEvolutionAndSureTermApi.upperLimit)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects.call(api.termsAndRisks.get, {
                        isCallCenter: isCallCenter,
                        useEvolutionApi: true,
                    })];
            case 5:
                data = (_e.sent()).data;
                callCenterEvolutionTermsAndRisksData = data;
                _e.label = 6;
            case 6: return [4 /*yield*/, effects.call(api.termsAndRisks.get, {
                    isCallCenter: isCallCenter,
                    useJuvenileProduct: useJuvenileProduct,
                })];
            case 7:
                termsAndRisksData = (_e.sent()).data;
                if (!callCenterEvolutionTermsAndRisksData) {
                    resultedTermsAndRisksData = termsAndRisksData;
                }
                else {
                    parsedCallCenterEvolutionTermsAndRiskData = callCenterEvolutionTermsAndRisksData.data.filter(function (item) {
                        if ((applicantAge_1 <
                            ageRangeForEvolutionAndSureTermApi.lowerLimit &&
                            item.term !== EProductTerm.T100) ||
                            (applicantAge_1 >=
                                ageRangeForEvolutionAndSureTermApi.lowerLimit &&
                                applicantAge_1 <=
                                    ageRangeForEvolutionAndSureTermApi.upperLimit &&
                                (item.term === EProductTerm.T10 ||
                                    item.term === EProductTerm.T20))) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    });
                    parsedTermsAndRisksData = termsAndRisksData.data.filter(function (item) {
                        if ((applicantAge_1 <
                            ageRangeForEvolutionAndSureTermApi.lowerLimit &&
                            item.term === EProductTerm.T100) ||
                            (applicantAge_1 >=
                                ageRangeForEvolutionAndSureTermApi.lowerLimit &&
                                applicantAge_1 <=
                                    ageRangeForEvolutionAndSureTermApi.upperLimit &&
                                (item.term === EProductTerm.T30 ||
                                    item.term === EProductTerm.T100)) ||
                            applicantAge_1 >
                                ageRangeForEvolutionAndSureTermApi.upperLimit) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    });
                    mergedData = parsedTermsAndRisksData.concat(parsedCallCenterEvolutionTermsAndRiskData);
                    resultedTermsAndRisksData = {
                        success: callCenterEvolutionTermsAndRisksData.success ||
                            termsAndRisksData.success,
                        data: mergedData,
                    };
                }
                if (!(resultedTermsAndRisksData.length === 0)) return [3 /*break*/, 9];
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 8:
                _e.sent();
                return [3 /*break*/, 14];
            case 9:
                _b = user_1.data, initProductVersion_1 = _b.product_version, initRisk_1 = _b.risk, initTerm_1 = _b.term;
                overwriteTermsAndRisksWithInitData = resultedTermsAndRisksData.data.map(function (item) {
                    if (item.term === initTerm_1 && item.risk === initRisk_1) {
                        return __assign(__assign({}, item), { version: initProductVersion_1 });
                    }
                    else {
                        return __assign({}, item);
                    }
                });
                return [4 /*yield*/, effects.put(setTermsAndRisks({
                        data: { data: overwriteTermsAndRisksWithInitData },
                    }))];
            case 10:
                _e.sent();
                disabledTermsAccordingToApplicantAge = termsAndRisksData.data
                    .filter(function (item) {
                    var _a, _b;
                    if (item.max_age < ((_a = user_1 === null || user_1 === void 0 ? void 0 : user_1.data) === null || _a === void 0 ? void 0 : _a.nearestAge) ||
                        item.min_age > ((_b = user_1 === null || user_1 === void 0 ? void 0 : user_1.data) === null || _b === void 0 ? void 0 : _b.nearestAge)) {
                        return item;
                    }
                    else
                        return false;
                })
                    .map(function (item) {
                    return item.term;
                })
                    .filter(function (item, index, self) {
                    return self.indexOf(item) === index;
                });
                return [4 /*yield*/, effects.put(setDisabledTermsAccordingToApplicantAge(disabledTermsAccordingToApplicantAge))];
            case 11:
                _e.sent();
                return [4 /*yield*/, effects.put(computeCoverageMinMax({
                        selectedTerm: initTerm_1
                            ? initTerm_1
                            : EMaxAndMinTermAndRisk.minSureAndEvolutionProductsTerm,
                        computedRisk: initRisk_1
                            ? initRisk_1
                            : EMaxAndMinTermAndRisk.minSureAndEvolutionProductsRisk,
                        initTheEditProcess: initTheEditProcess !== null && initTheEditProcess !== void 0 ? initTheEditProcess : false,
                    }))];
            case 12:
                _e.sent();
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 13:
                _e.sent();
                _e.label = 14;
            case 14: return [3 /*break*/, 17];
            case 15:
                error_1 = _e.sent();
                console.error({ error: error_1 });
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 16:
                _e.sent();
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
function computeCoverageMinMaxHandle(_a) {
    var computedRisk, initTheEditProcess, termsAndRisksData, useJuvenileProduct, maxCoverage, user_2, resultedTerms, termsAndRisksDataLength, i, selectCoverages, selectJuvenileCICoverages_1, computedMinAndMaxCoverage_1, resultedCoverage, userProvince, showGP, error_2;
    var _b, _c, _d, _e, _f, _g, _h;
    var payload = _a.payload;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                computedRisk = payload.computedRisk, initTheEditProcess = payload.initTheEditProcess;
                if (!computedRisk)
                    return [2 /*return*/];
                _j.label = 1;
            case 1:
                _j.trys.push([1, 21, , 23]);
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(true))];
            case 2:
                _j.sent();
                return [4 /*yield*/, effects.select(getTermsAndRisksData)];
            case 3:
                termsAndRisksData = _j.sent();
                if (!(termsAndRisksData === null || termsAndRisksData === void 0 ? void 0 : termsAndRisksData.data)) {
                    throw new Error("Terms and risks data not available!");
                }
                return [4 /*yield*/, effects.select(getApplicationUseJuvenileProduct)];
            case 4:
                useJuvenileProduct = _j.sent();
                return [4 /*yield*/, effects.select(function (state) { var _a, _b; return (_b = (_a = state.termsAndRisks) === null || _a === void 0 ? void 0 : _a.coverage) === null || _b === void 0 ? void 0 : _b.maxValue; })];
            case 5:
                maxCoverage = _j.sent();
                return [4 /*yield*/, effects.select(getUserFromStore)];
            case 6:
                user_2 = _j.sent();
                resultedTerms = new Set();
                termsAndRisksDataLength = (_b = termsAndRisksData === null || termsAndRisksData === void 0 ? void 0 : termsAndRisksData.data) === null || _b === void 0 ? void 0 : _b.length;
                for (i = 0; i < termsAndRisksDataLength; i++) {
                    resultedTerms.add(termsAndRisksData.data[i].term);
                }
                selectCoverages = termsAndRisksData === null || termsAndRisksData === void 0 ? void 0 : termsAndRisksData.data.find(function (item) {
                    var _a, _b;
                    return (item.risk === parseInt(String(computedRisk)) &&
                        item.min_age <= parseInt((_a = user_2 === null || user_2 === void 0 ? void 0 : user_2.data) === null || _a === void 0 ? void 0 : _a.nearestAge) &&
                        parseInt((_b = user_2 === null || user_2 === void 0 ? void 0 : user_2.data) === null || _b === void 0 ? void 0 : _b.nearestAge) <= item.max_age);
                });
                selectJuvenileCICoverages_1 = useJuvenileProduct && (termsAndRisksData === null || termsAndRisksData === void 0 ? void 0 : termsAndRisksData.data)
                    ? termsAndRisksData === null || termsAndRisksData === void 0 ? void 0 : termsAndRisksData.data.find(function (item) {
                        var _a, _b;
                        return (item.term === EProductTerm.JuvenileCI &&
                            item.risk === parseInt(String(computedRisk)) &&
                            item.min_age <=
                                parseInt((_a = user_2 === null || user_2 === void 0 ? void 0 : user_2.data) === null || _a === void 0 ? void 0 : _a.nearestAge) &&
                            parseInt((_b = user_2 === null || user_2 === void 0 ? void 0 : user_2.data) === null || _b === void 0 ? void 0 : _b.nearestAge) <= item.max_age);
                    }) : {};
                if (!useJuvenileProduct) return [3 /*break*/, 8];
                return [4 /*yield*/, effects.put(setCICoverage({
                        minValue: (selectJuvenileCICoverages_1 === null || selectJuvenileCICoverages_1 === void 0 ? void 0 : selectJuvenileCICoverages_1.min_coverage) || 0,
                        maxValue: (selectJuvenileCICoverages_1 === null || selectJuvenileCICoverages_1 === void 0 ? void 0 : selectJuvenileCICoverages_1.max_coverage) || 0,
                    }))];
            case 7:
                _j.sent();
                _j.label = 8;
            case 8:
                computedMinAndMaxCoverage_1 = {};
                if (selectCoverages) {
                    if (useJuvenileProduct) {
                        computedMinAndMaxCoverage_1.min_coverage =
                            selectCoverages.min_coverage;
                        computedMinAndMaxCoverage_1.max_coverage =
                            selectCoverages.max_coverage;
                    }
                    else {
                        resultedCoverage = (_c = selectCoverages === null || selectCoverages === void 0 ? void 0 : selectCoverages.coverages) === null || _c === void 0 ? void 0 : _c.find(function (item) {
                            var _a;
                            return (item.min_age <= user_2.data.nearestAge &&
                                item.max_age >= ((_a = user_2 === null || user_2 === void 0 ? void 0 : user_2.data) === null || _a === void 0 ? void 0 : _a.nearestAge));
                        });
                        if (resultedCoverage) {
                            computedMinAndMaxCoverage_1.min_coverage =
                                resultedCoverage.min_coverage;
                            computedMinAndMaxCoverage_1.max_coverage =
                                resultedCoverage.max_coverage;
                        }
                    }
                }
                return [4 /*yield*/, effects.put(setCoverage({
                        currentStatusInCanada: (_e = (_d = user_2.data) === null || _d === void 0 ? void 0 : _d.currentStatusInCanada) !== null && _e !== void 0 ? _e : null,
                        bankruptcyStatus: (_f = user_2.data) === null || _f === void 0 ? void 0 : _f.bankruptcyStatus,
                        minValue: (computedMinAndMaxCoverage_1 === null || computedMinAndMaxCoverage_1 === void 0 ? void 0 : computedMinAndMaxCoverage_1.min_coverage) || 0,
                        maxValue: (computedMinAndMaxCoverage_1 === null || computedMinAndMaxCoverage_1 === void 0 ? void 0 : computedMinAndMaxCoverage_1.max_coverage) || 0,
                    }))];
            case 9:
                _j.sent();
                if (!((initTheEditProcess ||
                    maxCoverage !== (computedMinAndMaxCoverage_1 === null || computedMinAndMaxCoverage_1 === void 0 ? void 0 : computedMinAndMaxCoverage_1.max_coverage) ||
                    0) &&
                    ((_g = user_2 === null || user_2 === void 0 ? void 0 : user_2.data) === null || _g === void 0 ? void 0 : _g.isCallCenter) !== 1)) return [3 /*break*/, 19];
                // the products are available only for field version.
                // when the max coverage is updated, get the new data for the eligible products
                return [4 /*yield*/, effects.all(Array.from(resultedTerms).map(function (item) {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, effects.put(getEligibleProducts({
                                        product_risk: parseInt(String(computedRisk)),
                                        product_term: item,
                                        benefit_amount: item === EProductTerm.JuvenileCI
                                            ? selectJuvenileCICoverages_1 === null || selectJuvenileCICoverages_1 === void 0 ? void 0 : selectJuvenileCICoverages_1.max_coverage : computedMinAndMaxCoverage_1
                                            ? computedMinAndMaxCoverage_1.max_coverage
                                            : 0,
                                    }))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }))];
            case 10:
                // the products are available only for field version.
                // when the max coverage is updated, get the new data for the eligible products
                _j.sent();
                if (!!useJuvenileProduct) return [3 /*break*/, 19];
                userProvince = (_h = user_2 === null || user_2 === void 0 ? void 0 : user_2.data) === null || _h === void 0 ? void 0 : _h.province;
                return [4 /*yield*/, effects.select(getApplicationShowGP)];
            case 11:
                showGP = _j.sent();
                if (!(computedRisk ===
                    EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk)) return [3 /*break*/, 16];
                if (!(!chubbExcludedProvincies.includes(userProvince ? userProvince : "") &&
                    (showGP === EShowGp.chubb || showGP === EShowGp.all))) return [3 /*break*/, 13];
                return [4 /*yield*/, effects.put(getEligibleProducts({
                        benefit_amount: chubbMinMaxCoverageValues.maxValue,
                        product_id: chubbFinalExpenseProductId,
                        product_term: EProductTerm.chubb,
                    }))];
            case 12:
                _j.sent();
                _j.label = 13;
            case 13:
                if (!(showGP === EShowGp.FiveToT100 ||
                    showGP === EShowGp.all)) return [3 /*break*/, 15];
                return [4 /*yield*/, effects.put(getEligibleProducts({
                        product_risk: computedRisk,
                        product_term: EProductTerm.FiveToT100,
                        benefit_amount: computedMinAndMaxCoverage_1.max_coverage,
                    }))];
            case 14:
                _j.sent();
                _j.label = 15;
            case 15: return [3 /*break*/, 19];
            case 16: return [4 /*yield*/, effects.put(setEligibleProducts({
                    term: EProductTerm.chubb,
                    ratesDetails: null,
                    removeTheTerm: true,
                }))];
            case 17:
                _j.sent();
                return [4 /*yield*/, effects.put(setEligibleProducts({
                        term: EProductTerm.FiveToT100,
                        ratesDetails: null,
                        removeTheTerm: true,
                    }))];
            case 18:
                _j.sent();
                _j.label = 19;
            case 19: return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 20:
                _j.sent();
                return [3 /*break*/, 23];
            case 21:
                error_2 = _j.sent();
                console.log({ error: error_2 });
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 22:
                _j.sent();
                return [3 /*break*/, 23];
            case 23: return [2 /*return*/];
        }
    });
}
function getRatesMatchHandle(_a) {
    var product_term, product_risk, user, _b, realAge, nearestAge, dob, smoker, smokerFE, gender, isCallCenter, province, smokerValue, data, parsedRatesDetails;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                product_term = payload.product_term, product_risk = payload.product_risk;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 10, , 13]);
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(true))];
            case 2:
                _c.sent();
                return [4 /*yield*/, effects.select(getUserFromStore)];
            case 3:
                user = _c.sent();
                _b = user.data, realAge = _b.realAge, nearestAge = _b.nearestAge, dob = _b.dob, smoker = _b.smoker, smokerFE = _b.smokerFE, gender = _b.gender, isCallCenter = _b.isCallCenter, province = _b.province;
                smokerValue = product_term === EProductTerm.chubb
                    ? smokerFE
                    : parseInt(smoker) === 1
                        ? "y"
                        : "n";
                return [4 /*yield*/, effects.call(api.termsAndRisks.getRatesMatch, {
                        payload: __assign(__assign({}, payload), { 
                            // TODO: this is a temporary solution in order to support the FiveToT100 product
                            product_term: product_term === EProductTerm.FiveToT100
                                ? EProductTerm.T100
                                : product_term, isCallCenter: isCallCenter, province: province, smoker: smokerValue, age: product_term === EProductTerm.chubb ? realAge : nearestAge, dob: dob,
                            gender: gender }),
                    })];
            case 4:
                data = (_c.sent()).data;
                if (!!data) return [3 /*break*/, 6];
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 5:
                _c.sent();
                return [3 /*break*/, 9];
            case 6:
                parsedRatesDetails = !data.success
                    ? null
                    : __assign(__assign({}, data.data.rate[nearestAge]), { premium: data.data.rate[nearestAge].premium &&
                            !Number.isNaN(data.data.rate[nearestAge].premium) &&
                            roundLikePHP(data.data.rate[nearestAge].premium, 2), rate: data.data.rate[nearestAge].rate &&
                            !Number.isNaN(data.data.rate[nearestAge].rate) &&
                            roundLikePHP(data.data.rate[nearestAge].rate, 2) });
                return [4 /*yield*/, effects.put(setRatesDetails({
                        risk: data.data.product.risk,
                        ratesDetails: parsedRatesDetails,
                    }))];
            case 7:
                _c.sent();
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9: return [3 /*break*/, 13];
            case 10:
                _c.sent();
                return [4 /*yield*/, effects.put(setRatesDetails({
                        risk: product_risk,
                        ratesDetails: null,
                    }))];
            case 11:
                _c.sent();
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 12:
                _c.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function getFinalAssessmentRatesMatchHandle(_a) {
    var user, _b, isCallCenter, gender, dob, smoker, nearestAge, realAge_1, province, smokerFE, product_term, smokerValue, data, ratesDetails, parsedRatesDetails, parsedRatesDetails;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 12, , 15]);
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(true))];
            case 1:
                _c.sent();
                return [4 /*yield*/, effects.select(getUserFromStore)];
            case 2:
                user = _c.sent();
                _b = user === null || user === void 0 ? void 0 : user.data, isCallCenter = _b.isCallCenter, gender = _b.gender, dob = _b.dob, smoker = _b.smoker, nearestAge = _b.nearestAge, realAge_1 = _b.realAge, province = _b.province, smokerFE = _b.smokerFE;
                product_term = payload.product_term;
                if (!product_term) {
                    throw new Error("Missing parameter: product_term");
                }
                smokerValue = product_term === EProductTerm.chubb
                    ? smokerFE
                    : parseInt(smoker) === 1
                        ? "y"
                        : "n";
                return [4 /*yield*/, effects.call(api.termsAndRisks.getRatesMatch, {
                        payload: __assign(__assign({}, payload), { product_term: product_term === EProductTerm.FiveToT100
                                ? EProductTerm.T100
                                : payload.product_term, isCallCenter: isCallCenter,
                            gender: gender,
                            dob: dob, smoker: smokerValue, age: product_term === EProductTerm.chubb ? realAge_1 : nearestAge, province: province }),
                    })];
            case 3:
                data = (_c.sent()).data;
                if (!!data) return [3 /*break*/, 5];
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 4:
                _c.sent();
                return [3 /*break*/, 11];
            case 5:
                if (!(product_term === EProductTerm.chubb)) return [3 /*break*/, 7];
                ratesDetails = data.forecast.find(function (item) {
                    var age = item[realAge_1].age;
                    return age === realAge_1;
                });
                parsedRatesDetails = {
                    premium: ratesDetails[realAge_1].sliq_month_rate &&
                        !Number.isNaN(ratesDetails[realAge_1].sliq_month_rate) &&
                        roundLikePHP(ratesDetails[realAge_1].sliq_month_rate, 2),
                    rate: ratesDetails[realAge_1].sliq_month_rate &&
                        !Number.isNaN(ratesDetails[realAge_1].sliq_month_rate) &&
                        roundLikePHP(ratesDetails[realAge_1].sliq_month_rate, 2),
                };
                return [4 /*yield*/, effects.put(setFinalAssessmentRatesDetails({
                        term: payload.product_term,
                        ratesDetails: !data ? null : parsedRatesDetails,
                    }))];
            case 6:
                _c.sent();
                return [3 /*break*/, 9];
            case 7:
                parsedRatesDetails = !data.success
                    ? null
                    : __assign(__assign({}, data.data.rate[nearestAge]), { premium: data.data.rate[nearestAge].premium &&
                            !Number.isNaN(data.data.rate[nearestAge].premium) &&
                            roundLikePHP(data.data.rate[nearestAge].premium, 2), rate: data.data.rate[nearestAge].rate &&
                            !Number.isNaN(data.data.rate[nearestAge].rate) &&
                            roundLikePHP(data.data.rate[nearestAge].rate, 2) });
                return [4 /*yield*/, effects.put(setFinalAssessmentRatesDetails({
                        term: payload.product_term,
                        ratesDetails: parsedRatesDetails,
                    }))];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9: return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 10:
                _c.sent();
                _c.label = 11;
            case 11: return [3 /*break*/, 15];
            case 12:
                _c.sent();
                return [4 /*yield*/, effects.put(setFinalAssessmentRatesDetails({
                        term: payload.product_term,
                        ratesDetails: null,
                    }))];
            case 13:
                _c.sent();
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 14:
                _c.sent();
                return [3 /*break*/, 15];
            case 15: return [2 /*return*/];
        }
    });
}
function getEligibleProductsHandle(_a) {
    var product_term, user, addEverest, _b, isCallCenter, gender, dob, nearestAge, realAge_2, province, smoker, smokerFE, smokerValue, data, ratesDetails, parseRatesDetails;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                product_term = payload.product_term;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 14, , 17]);
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(true))];
            case 2:
                _c.sent();
                return [4 /*yield*/, effects.select(getUserFromStore)];
            case 3:
                user = _c.sent();
                return [4 /*yield*/, effects.select(selectApplicationAddEverest)];
            case 4:
                addEverest = _c.sent();
                _b = user === null || user === void 0 ? void 0 : user.data, isCallCenter = _b.isCallCenter, gender = _b.gender, dob = _b.dob, nearestAge = _b.nearestAge, realAge_2 = _b.realAge, province = _b.province, smoker = _b.smoker, smokerFE = _b.smokerFE;
                smokerValue = product_term === EProductTerm.chubb
                    ? smokerFE
                    : parseInt(smoker) === 1
                        ? "y"
                        : "n";
                return [4 /*yield*/, effects.call(api.termsAndRisks.getRatesMatch, {
                        payload: __assign(__assign({}, payload), { product_term: product_term === EProductTerm.FiveToT100
                                ? EProductTerm.T100
                                : product_term, isCallCenter: isCallCenter, gender: gender,
                            dob: dob, smoker: smokerValue, age: product_term === EProductTerm.chubb ? realAge_2 : nearestAge, // only for CI send the real age
                            province: province, add_everest: addEverest !== null && addEverest !== void 0 ? addEverest : 0 }),
                    })];
            case 5:
                data = (_c.sent()).data;
                if (!!data) return [3 /*break*/, 7];
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 6:
                _c.sent();
                return [3 /*break*/, 13];
            case 7:
                if (!(product_term === EProductTerm.chubb)) return [3 /*break*/, 9];
                ratesDetails = data.forecast
                    ? data.forecast.find(function (item) {
                        var age = item[realAge_2].age;
                        return age === realAge_2;
                    })
                    : null;
                parseRatesDetails = ratesDetails
                    ? {
                        premium: ratesDetails[realAge_2].sliq_month_rate,
                        rate: ratesDetails[realAge_2].sliq_month_rate,
                    }
                    : null;
                return [4 /*yield*/, effects.put(setEligibleProducts({
                        term: product_term,
                        ratesDetails: !data.current_request
                            ? null
                            : parseRatesDetails,
                    }))];
            case 8:
                _c.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, effects.put(setEligibleProducts({
                    term: product_term,
                    ratesDetails: data.data.rate[nearestAge],
                }))];
            case 10:
                _c.sent();
                _c.label = 11;
            case 11: return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 12:
                _c.sent();
                _c.label = 13;
            case 13: return [3 /*break*/, 17];
            case 14:
                _c.sent();
                return [4 /*yield*/, effects.put(setEligibleProducts({
                        term: product_term,
                        ratesDetails: null,
                    }))];
            case 15:
                _c.sent();
                return [4 /*yield*/, effects.put(setTermsAndRisksLoading(false))];
            case 16:
                _c.sent();
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
function rootSaga$1() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([
                    effects.takeEvery(ETermsAndRisksActionTypes.getTermsAndRisks, getTermsAndRisksHandle),
                    effects.takeEvery(ETermsAndRisksActionTypes.computeCoverageMinMax, computeCoverageMinMaxHandle),
                    effects.takeEvery(ETermsAndRisksActionTypes.getRatesMatch, getRatesMatchHandle),
                    effects.takeEvery(ETermsAndRisksActionTypes.getFinalAssessmentRatesMatch, getFinalAssessmentRatesMatchHandle),
                    effects.takeEvery(ETermsAndRisksActionTypes.getEligibleProducts, getEligibleProductsHandle),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects.all([
                    rootSaga$6(),
                    rootSaga$5(),
                    rootSaga$4(),
                    rootSaga$2(),
                    rootSaga$3(),
                    rootSaga$1(),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

// const rollbar = process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN ? new Rollbar({
//   accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
//   captureUncaught: true,
//   captureUnhandledRejections: true,
// }) : null;
var initial$6 = {
    initFinalAssessment: false,
    canTheAssessmentBeStopped: false,
    loading: false,
    isSiderOpen: false,
    isReaderActive: null,
    applicationForceGI: false,
    applicationApproved: false,
    fieldApplication: {
        theQuestionnaireStarted: false,
        honeycombBackground: true,
        showJenieAssistDrawer: false,
    },
    finalAssessment: {
        customOrderedTerms: undefined,
    },
    hasUsedVoice: true,
    theApplicantAgeIsTooLow: undefined,
    add_everest: undefined,
    showGP: undefined,
    useJuvenileProduct: false,
    env: EEnv.development,
};
function appReducer(state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = initial$6; }
    switch (action.type) {
        case EAppActionTypes.toggleReaderActive: {
            return __assign(__assign({}, state), { isReaderActive: !state.isReaderActive });
        }
        case EAppActionTypes.toggleSider: {
            return __assign(__assign({}, state), { isSiderOpen: !state.isSiderOpen });
        }
        case EAppActionTypes.appLoadingSet: {
            return __assign(__assign({}, state), { loading: action.payload });
        }
        case EAppActionTypes.initFinalAssessment: {
            return __assign(__assign({}, state), { initFinalAssessment: action.payload });
        }
        case EAppActionTypes.appSetCanTheAssessmentBeStopped: {
            return __assign(__assign({}, state), { canTheAssessmentBeStopped: action.payload });
        }
        case EAppActionTypes.finalAssessmentSetOrderedTerms: {
            var _e = action.payload, lowestTerm = _e.lowestTerm, secondLowestTerm = _e.secondLowestTerm, thirdLowestTerm = _e.thirdLowestTerm, highestTerm = _e.highestTerm;
            return __assign(__assign({}, state), { finalAssessment: __assign(__assign({}, state.finalAssessment), { customOrderedTerms: {
                        lowest: {
                            rate: 0,
                            label: lowestTerm,
                        },
                        secondLowest: {
                            rate: 0,
                            label: secondLowestTerm,
                        },
                        thirdLowest: {
                            rate: 0,
                            label: thirdLowestTerm,
                        },
                        highest: {
                            rate: 0,
                            label: highestTerm,
                        },
                    } }) });
        }
        case EAppActionTypes.finalAssessmentSetRateTerms: {
            /**********
                
                VERY IMPORTANT!!!
                For computedRisk === EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk the maximum no of products that can be shown is 3: T100, 5ToT100/FE (CI) and GP
                For computedRisk !==  EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk the maximum no of products that can be shown is 4: T10, T20, T30 and T100
                If useJuvenileProduct is true the maximum no of products that can be shown is 2.
            
                All the products fall into 2 categories:
                1) ESSENCE
                2) FE (CI)
                3) Juvenile

                When useJuvenileProduct === true
                1) Only Juvenile products will be shown and all the products and the values are not cumulative

                Depending on value of showGP from the app store we have 3 scenarios:
                1) showGP === undefined
                    if computedRisk !== EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk || computedRisk ===  EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                        Only ESSENCE products will be shown and all the products values are cumulative -> all the products are connected to each other, the value of each product will affect the value of the other products, (more products can be selected)
                2) showGP === EProductTerm.FiveToT100
                    This scenario is mostly the same like the first scenario with a small change:
                        if computedRisk !==  EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                            Everything is like in scenario 1
                        if computedRisk ===  EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                             Everything is like scenario 1 with a small change: besides all the ESSENCE products another ESSENCE product will be shown and this is EProductTerm.5ToT100
                3) showGP === EShowGP.chubb
                    Mostly is like scenario 1 but, besides scenario 1 there are a few differences:
                        if computedRisk !==  EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                            Everything is like in scenario 1
                        if computedRisk ===  EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                            The EProductTerm.chubb may be shown.
                            In this specific case ONLY ONE product can be selected.
                4) showGP === EShowGP.all
                        Mostly is like scenario 1 but, besides scenario 1 there are a few differences:
                        if computedRisk !==  EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                            Everything is like in scenario 1
                        if computedRisk ===  EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk
                            The EProductTerm.chubb and EProductTerm.FiveToT100 may be shown.
                            In this specific case can be selected at most TWO Evolution products or ONE CI produc
            **********/
            if (state.finalAssessment.customOrderedTerms) {
                var _f = action.payload, term = _f.term, sliderValue = _f.inputValue, maxCoverageValue = _f.maxCoverageValue, computedRisk = _f.computedRisk, ciMinMaxCoverage = _f.ciMinMaxCoverage, termLabel = _f.termLabel, useJuvenileProduct = _f.useJuvenileProduct, addEverest = _f.addEverest, callbackOnSuccess = _f.callbackOnSuccess;
                var highestTermValue = state.finalAssessment.customOrderedTerms.highest.rate || 0;
                var lowestTermValue = state.finalAssessment.customOrderedTerms.lowest.rate || 0;
                var secondLowestTermValue = state.finalAssessment.customOrderedTerms.secondLowest
                    .rate || 0;
                var thirdLowestTermValue = state.finalAssessment.customOrderedTerms.thirdLowest.rate ||
                    0;
                var newHighestTermValue = highestTermValue;
                var newLowestTermValue = lowestTermValue;
                var newSecondLowestTermValue = secondLowestTermValue;
                var newThirdLowestTermValue = thirdLowestTermValue;
                var inputValue = void 0;
                var ciMaxCoverage = (ciMinMaxCoverage === null || ciMinMaxCoverage === void 0 ? void 0 : ciMinMaxCoverage.maxValue) ? ciMinMaxCoverage === null || ciMinMaxCoverage === void 0 ? void 0 : ciMinMaxCoverage.maxValue : 0;
                var totalAmountOfSlidersForComputedRisk5 = lowestTermValue + secondLowestTermValue;
                var totalAmountOfSliders = highestTermValue +
                    lowestTermValue +
                    secondLowestTermValue +
                    thirdLowestTermValue;
                var productMaxCoverage = 0;
                if (termLabel === EProductTerm.chubb) {
                    productMaxCoverage = ciMaxCoverage;
                }
                else {
                    productMaxCoverage = maxCoverageValue
                        ? maxCoverageValue
                        : 0;
                }
                if (productMaxCoverage) {
                    if (useJuvenileProduct &&
                        computedRisk !==
                            EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk &&
                        state.finalAssessment.customOrderedTerms.lowest
                            .label === EProductTerm.JuvenileLife &&
                        // state.finalAssessment.customOrderedTerms?.secondLowest
                        // 	?.label === EProductTerm.JuvenileCI
                        typeof state.finalAssessment.customOrderedTerms
                            .thirdLowest.label === "undefined" &&
                        typeof state.finalAssessment.customOrderedTerms.highest
                            .label === "undefined" &&
                        (term === ETermKey.lowest ||
                            term === ETermKey.secondLowest)) {
                        switch (term) {
                            case ETermKey.lowest: {
                                inputValue = sliderValue - lowestTermValue;
                                if (inputValue + lowestTermValue >=
                                    productMaxCoverage) {
                                    newLowestTermValue = productMaxCoverage;
                                }
                                else if (inputValue <= 0) {
                                    newLowestTermValue =
                                        lowestTermValue + inputValue;
                                }
                                else if (inputValue > 0) {
                                    newLowestTermValue =
                                        lowestTermValue + inputValue;
                                }
                                break;
                            }
                            case ETermKey.secondLowest: {
                                inputValue =
                                    sliderValue - secondLowestTermValue;
                                if (inputValue + secondLowestTermValue >=
                                    productMaxCoverage) {
                                    newSecondLowestTermValue = productMaxCoverage;
                                }
                                else if (inputValue <= 0) {
                                    newSecondLowestTermValue =
                                        secondLowestTermValue + inputValue;
                                }
                                else if (inputValue > 0) {
                                    newSecondLowestTermValue =
                                        secondLowestTermValue + inputValue;
                                }
                                break;
                            }
                        }
                    }
                    else if (computedRisk ===
                        EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk) {
                        if ((state.showGP === EShowGp.all ||
                            state.showGP === EShowGp.FiveToT100) &&
                            ((_a = state.finalAssessment.customOrderedTerms.lowest) === null || _a === void 0 ? void 0 : _a.label) === EProductTerm.T100 &&
                            state.finalAssessment.customOrderedTerms
                                .secondLowest.label ===
                                EProductTerm.FiveToT100 &&
                            (term === ETermKey.lowest ||
                                term === ETermKey.secondLowest)) {
                            if (state.finalAssessment.customOrderedTerms
                                .thirdLowest.label === EProductTerm.chubb) {
                                newThirdLowestTermValue = 0;
                            }
                            switch (term) {
                                case ETermKey.lowest: {
                                    inputValue = sliderValue - lowestTermValue;
                                    if (inputValue + lowestTermValue >
                                        productMaxCoverage) {
                                        newLowestTermValue = productMaxCoverage;
                                        newSecondLowestTermValue = 0;
                                    }
                                    else if (totalAmountOfSlidersForComputedRisk5 +
                                        inputValue <
                                        productMaxCoverage) {
                                        newLowestTermValue =
                                            lowestTermValue + inputValue;
                                    }
                                    else if (inputValue <= 0) {
                                        newLowestTermValue =
                                            lowestTermValue + inputValue;
                                        newSecondLowestTermValue =
                                            secondLowestTermValue +
                                                Math.abs(inputValue);
                                    }
                                    else if (inputValue > 0) {
                                        newLowestTermValue =
                                            lowestTermValue + inputValue;
                                        var amountToBeSubstracted = inputValue -
                                            Math.abs(totalAmountOfSlidersForComputedRisk5 -
                                                productMaxCoverage);
                                        if (secondLowestTermValue -
                                            amountToBeSubstracted >=
                                            0) {
                                            newSecondLowestTermValue =
                                                secondLowestTermValue -
                                                    amountToBeSubstracted;
                                            amountToBeSubstracted = 0;
                                        }
                                        else {
                                            newSecondLowestTermValue = 0;
                                            amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                                secondLowestTermValue);
                                        }
                                    }
                                    break;
                                }
                                case ETermKey.secondLowest: {
                                    inputValue =
                                        sliderValue - secondLowestTermValue;
                                    if (inputValue + secondLowestTermValue >
                                        productMaxCoverage) {
                                        newLowestTermValue = 0;
                                        newSecondLowestTermValue = productMaxCoverage;
                                    }
                                    else if (totalAmountOfSlidersForComputedRisk5 +
                                        inputValue <
                                        productMaxCoverage) {
                                        newSecondLowestTermValue =
                                            secondLowestTermValue + inputValue;
                                    }
                                    else if (inputValue <= 0) {
                                        newSecondLowestTermValue =
                                            secondLowestTermValue + inputValue;
                                        newLowestTermValue =
                                            lowestTermValue +
                                                Math.abs(inputValue);
                                    }
                                    else if (inputValue > 0) {
                                        newSecondLowestTermValue =
                                            secondLowestTermValue + inputValue;
                                        var amountToBeSubstracted = inputValue -
                                            Math.abs(totalAmountOfSlidersForComputedRisk5 -
                                                productMaxCoverage);
                                        if (lowestTermValue -
                                            amountToBeSubstracted >=
                                            0) {
                                            newLowestTermValue =
                                                lowestTermValue -
                                                    amountToBeSubstracted;
                                            amountToBeSubstracted = 0;
                                        }
                                        else {
                                            newLowestTermValue = 0;
                                            amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                                lowestTermValue);
                                        }
                                    }
                                    break;
                                }
                            }
                        }
                        else {
                            if (state.showGP === EShowGp.chubb ||
                                state.showGP === EShowGp.all) {
                                newHighestTermValue = 0;
                                newLowestTermValue = 0;
                                newSecondLowestTermValue = 0;
                                newThirdLowestTermValue = 0;
                            }
                            switch (term) {
                                case ETermKey.lowest: {
                                    inputValue = sliderValue - lowestTermValue;
                                    if (inputValue + lowestTermValue >=
                                        productMaxCoverage) {
                                        newLowestTermValue = productMaxCoverage;
                                    }
                                    else if (inputValue <= 0) {
                                        newLowestTermValue =
                                            lowestTermValue + inputValue;
                                    }
                                    else if (inputValue > 0) {
                                        newLowestTermValue =
                                            lowestTermValue + inputValue;
                                    }
                                    break;
                                }
                                case ETermKey.secondLowest: {
                                    inputValue =
                                        sliderValue - secondLowestTermValue;
                                    if (inputValue + secondLowestTermValue >=
                                        productMaxCoverage) {
                                        newSecondLowestTermValue = productMaxCoverage;
                                    }
                                    else if (inputValue <= 0) {
                                        newSecondLowestTermValue =
                                            secondLowestTermValue + inputValue;
                                    }
                                    else if (inputValue > 0) {
                                        newSecondLowestTermValue =
                                            secondLowestTermValue + inputValue;
                                    }
                                    break;
                                }
                                case ETermKey.thirdLowest: {
                                    inputValue =
                                        sliderValue - thirdLowestTermValue;
                                    if (inputValue + thirdLowestTermValue >=
                                        productMaxCoverage) {
                                        newThirdLowestTermValue = productMaxCoverage;
                                    }
                                    else if (inputValue <= 0) {
                                        newThirdLowestTermValue =
                                            thirdLowestTermValue + inputValue;
                                    }
                                    else if (inputValue > 0) {
                                        newThirdLowestTermValue =
                                            thirdLowestTermValue + inputValue;
                                    }
                                    break;
                                }
                                case ETermKey.highest: {
                                    inputValue = sliderValue - highestTermValue;
                                    if (inputValue + highestTermValue >=
                                        productMaxCoverage) {
                                        newHighestTermValue = productMaxCoverage;
                                    }
                                    else if (inputValue <= 0) {
                                        newHighestTermValue =
                                            highestTermValue + inputValue;
                                    }
                                    else if (inputValue > 0) {
                                        newHighestTermValue =
                                            highestTermValue + inputValue;
                                    }
                                    break;
                                }
                            }
                        }
                    }
                    else {
                        switch (term) {
                            case ETermKey.lowest: {
                                inputValue = sliderValue - lowestTermValue;
                                if (inputValue + lowestTermValue >
                                    productMaxCoverage) {
                                    newHighestTermValue = 0;
                                    newLowestTermValue = productMaxCoverage;
                                    newSecondLowestTermValue = 0;
                                    newThirdLowestTermValue = 0;
                                }
                                else if (totalAmountOfSliders + inputValue <
                                    productMaxCoverage) {
                                    newLowestTermValue =
                                        lowestTermValue + inputValue;
                                }
                                else if (inputValue <= 0) {
                                    newLowestTermValue =
                                        lowestTermValue + inputValue;
                                    newHighestTermValue =
                                        highestTermValue + Math.abs(inputValue);
                                }
                                else if (inputValue > 0) {
                                    newLowestTermValue =
                                        lowestTermValue + inputValue;
                                    var amountToBeSubstracted = inputValue -
                                        Math.abs(totalAmountOfSliders -
                                            productMaxCoverage);
                                    if (highestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newHighestTermValue =
                                            highestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newHighestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            highestTermValue);
                                    }
                                    if (secondLowestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newSecondLowestTermValue =
                                            secondLowestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newSecondLowestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            secondLowestTermValue);
                                    }
                                    if (thirdLowestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newThirdLowestTermValue =
                                            thirdLowestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newThirdLowestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            thirdLowestTermValue);
                                    }
                                }
                                break;
                            }
                            case ETermKey.secondLowest: {
                                inputValue =
                                    sliderValue - secondLowestTermValue;
                                if (inputValue + secondLowestTermValue >
                                    productMaxCoverage) {
                                    newHighestTermValue = 0;
                                    newLowestTermValue = 0;
                                    newSecondLowestTermValue = productMaxCoverage;
                                    newThirdLowestTermValue = 0;
                                }
                                else if (totalAmountOfSliders + inputValue <
                                    productMaxCoverage) {
                                    newSecondLowestTermValue =
                                        secondLowestTermValue + inputValue;
                                }
                                else if (inputValue <= 0) {
                                    newSecondLowestTermValue =
                                        secondLowestTermValue + inputValue;
                                    newHighestTermValue =
                                        highestTermValue + Math.abs(inputValue);
                                }
                                else if (inputValue > 0) {
                                    newSecondLowestTermValue =
                                        secondLowestTermValue + inputValue;
                                    var amountToBeSubstracted = inputValue -
                                        Math.abs(totalAmountOfSliders -
                                            productMaxCoverage);
                                    if (highestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newHighestTermValue =
                                            highestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newHighestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            highestTermValue);
                                    }
                                    if (lowestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newLowestTermValue =
                                            lowestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newLowestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            lowestTermValue);
                                    }
                                    if (thirdLowestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newThirdLowestTermValue =
                                            thirdLowestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newThirdLowestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            thirdLowestTermValue);
                                    }
                                }
                                break;
                            }
                            case ETermKey.thirdLowest: {
                                inputValue = sliderValue - thirdLowestTermValue;
                                if (inputValue + thirdLowestTermValue >
                                    productMaxCoverage) {
                                    newHighestTermValue = 0;
                                    newLowestTermValue = 0;
                                    newSecondLowestTermValue = 0;
                                    newThirdLowestTermValue = productMaxCoverage;
                                }
                                else if (totalAmountOfSliders + inputValue <
                                    productMaxCoverage) {
                                    newThirdLowestTermValue =
                                        thirdLowestTermValue + inputValue;
                                }
                                else if (inputValue <= 0) {
                                    newThirdLowestTermValue =
                                        thirdLowestTermValue + inputValue;
                                    newHighestTermValue =
                                        highestTermValue + Math.abs(inputValue);
                                }
                                else if (inputValue > 0) {
                                    newThirdLowestTermValue =
                                        thirdLowestTermValue + inputValue;
                                    var amountToBeSubstracted = inputValue -
                                        Math.abs(totalAmountOfSliders -
                                            productMaxCoverage);
                                    if (highestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newHighestTermValue =
                                            highestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newHighestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            highestTermValue);
                                    }
                                    if (lowestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newLowestTermValue =
                                            lowestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newLowestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            lowestTermValue);
                                    }
                                    if (secondLowestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newSecondLowestTermValue =
                                            secondLowestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newSecondLowestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            secondLowestTermValue);
                                    }
                                }
                                break;
                            }
                            case ETermKey.highest: {
                                inputValue = sliderValue - highestTermValue;
                                if (inputValue + highestTermValue >=
                                    productMaxCoverage) {
                                    newHighestTermValue = productMaxCoverage;
                                    newLowestTermValue = 0;
                                    newSecondLowestTermValue = 0;
                                    newThirdLowestTermValue = 0;
                                }
                                else if (totalAmountOfSliders + inputValue <
                                    productMaxCoverage) {
                                    newHighestTermValue =
                                        highestTermValue + inputValue;
                                }
                                else if (inputValue <= 0) {
                                    newHighestTermValue =
                                        highestTermValue + inputValue;
                                    // add the substracted value to lowest
                                    newLowestTermValue =
                                        lowestTermValue + Math.abs(inputValue);
                                }
                                else if (inputValue > 0) {
                                    newHighestTermValue =
                                        highestTermValue + inputValue;
                                    var amountToBeSubstracted = inputValue -
                                        Math.abs(totalAmountOfSliders -
                                            productMaxCoverage);
                                    if (lowestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newLowestTermValue =
                                            lowestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newLowestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            lowestTermValue);
                                    }
                                    if (secondLowestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newSecondLowestTermValue =
                                            secondLowestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newSecondLowestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            secondLowestTermValue);
                                    }
                                    if (thirdLowestTermValue -
                                        amountToBeSubstracted >=
                                        0) {
                                        newThirdLowestTermValue =
                                            thirdLowestTermValue -
                                                amountToBeSubstracted;
                                        amountToBeSubstracted = 0;
                                    }
                                    else {
                                        newThirdLowestTermValue = 0;
                                        amountToBeSubstracted = Math.abs(amountToBeSubstracted -
                                            thirdLowestTermValue);
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
                var resultedState = __assign(__assign({}, state), { finalAssessment: __assign(__assign({}, state.finalAssessment), { customOrderedTerms: __assign(__assign({}, state.finalAssessment.customOrderedTerms), { highest: __assign(__assign({}, state.finalAssessment.customOrderedTerms
                                .highest), { rate: newHighestTermValue, addEverest: term === ETermKey.highest &&
                                    typeof addEverest !== "undefined"
                                    ? addEverest
                                    : state.finalAssessment
                                        .customOrderedTerms.highest
                                        .addEverest }), lowest: __assign(__assign({}, state.finalAssessment.customOrderedTerms
                                .lowest), { rate: newLowestTermValue, addEverest: term === ETermKey.lowest &&
                                    typeof addEverest !== "undefined"
                                    ? addEverest
                                    : state.finalAssessment
                                        .customOrderedTerms.lowest
                                        .addEverest }), secondLowest: __assign(__assign({}, state.finalAssessment.customOrderedTerms
                                .secondLowest), { rate: newSecondLowestTermValue, addEverest: term === ETermKey.secondLowest &&
                                    typeof addEverest !== "undefined"
                                    ? addEverest
                                    : state.finalAssessment
                                        .customOrderedTerms.secondLowest
                                        .addEverest }), thirdLowest: __assign(__assign({}, (_b = state.finalAssessment.customOrderedTerms) === null || _b === void 0 ? void 0 : _b.thirdLowest), { rate: newThirdLowestTermValue, addEverest: term === ETermKey.thirdLowest &&
                                    typeof addEverest !== "undefined"
                                    ? addEverest
                                    : state.finalAssessment
                                        .customOrderedTerms.thirdLowest
                                        .addEverest }) }) }) });
                callbackOnSuccess === null || callbackOnSuccess === void 0 ? void 0 : callbackOnSuccess();
                return __assign({}, resultedState);
            }
            else {
                return __assign({}, state);
            }
        }
        case EAppActionTypes.setApplicationForceGI: {
            return __assign(__assign({}, state), { applicationForceGI: action.payload });
        }
        case EAppActionTypes.fieldApplicationSetBackground: {
            return __assign(__assign({}, state), { fieldApplication: __assign(__assign({}, state.fieldApplication), { honeycombBackground: action.payload }) });
        }
        case EAppActionTypes.setApplicationApproved: {
            return __assign(__assign({}, state), { applicationApproved: action.payload });
        }
        case EAppActionTypes.setTheApplicantAgeIsTooLow: {
            return __assign(__assign({}, state), { theApplicantAgeIsTooLow: __assign(__assign({}, state.theApplicantAgeIsTooLow), { messages: action.payload.messages }) });
        }
        case EAppActionTypes.setApplicationGeneralDetails: {
            var _g = action.payload, add_everest = _g.add_everest, showGP = _g.showGP;
            return __assign(__assign({}, state), { add_everest: add_everest,
                showGP: showGP });
        }
        case EAppActionTypes.setShowJenieAssistDrawer: {
            return __assign(__assign({}, state), { fieldApplication: __assign(__assign({}, state.fieldApplication), { showJenieAssistDrawer: action.payload }) });
        }
        case EAppActionTypes.setTheQuestionnaireStarted: {
            return __assign(__assign({}, state), { fieldApplication: __assign(__assign({}, state.fieldApplication), { theQuestionnaireStarted: action.payload }) });
        }
        case EAppActionTypes.setHasUsedVoice: {
            return __assign(__assign({}, state), { hasUsedVoice: action.payload });
        }
        case EAppActionTypes.setUseJuvenileProduct: {
            return __assign(__assign({}, state), { useJuvenileProduct: action.payload });
        }
        case EAppActionTypes.setFinalAssessmentTermAddEverest: {
            var _h = action.payload, addEverest = _h.addEverest, termOrder = _h.termOrder, _j = _h.resetAllEverestCheckboxes, resetAllEverestCheckboxes = _j === void 0 ? false : _j, _k = _h.setDefaultAddEverestValue, setDefaultAddEverestValue = _k === void 0 ? false : _k;
            if (typeof addEverest === "undefined" &&
                typeof termOrder &&
                setDefaultAddEverestValue && ((_c = state.finalAssessment) === null || _c === void 0 ? void 0 : _c.customOrderedTerms)) {
                var customOrderedTerms = __assign({}, state.finalAssessment.customOrderedTerms);
                var noOftermsWithNonZeroValue = 0;
                for (var key in customOrderedTerms) {
                    // @ts-ignore
                    if (customOrderedTerms[key].rate > 0) {
                        noOftermsWithNonZeroValue++;
                    }
                    if (noOftermsWithNonZeroValue > 1) {
                        break;
                    }
                }
                if (noOftermsWithNonZeroValue !== 1) {
                    return state;
                }
                else {
                    // @ts-ignore
                    customOrderedTerms[termOrder] = __assign(__assign({}, customOrderedTerms[termOrder]), { addEverest: true });
                    return __assign(__assign({}, state), { finalAssessment: __assign(__assign({}, state.finalAssessment), { customOrderedTerms: __assign({}, customOrderedTerms) }) });
                }
            }
            else {
                if ((_d = state.finalAssessment) === null || _d === void 0 ? void 0 : _d.customOrderedTerms) {
                    var customOrderedTerms_1 = __assign({}, state.finalAssessment.customOrderedTerms);
                    if (resetAllEverestCheckboxes) {
                        Object.keys(state.finalAssessment.customOrderedTerms).forEach(function (item) {
                            // reset the 'addEverest' attribute for every custom ordered term.
                            // @ts-ignore
                            customOrderedTerms_1[item] = __assign(__assign({}, customOrderedTerms_1[item]), { addEverest: null });
                        });
                    }
                    if (typeof addEverest !== undefined && termOrder) {
                        customOrderedTerms_1[termOrder].addEverest = addEverest;
                    }
                    return __assign(__assign({}, state), { finalAssessment: __assign(__assign({}, state.finalAssessment), { customOrderedTerms: __assign({}, customOrderedTerms_1) }) });
                }
                else {
                    return state;
                }
            }
        }
        default:
            return state;
    }
}

var initial$5 = {
    loading: false,
    currentId: 0,
    name: "",
};
function productReducer(state, action) {
    if (state === void 0) { state = initial$5; }
    switch (action.type) {
        case EProductActionTypes.productLoadingSet: {
            return __assign(__assign({}, state), { loading: action.payload });
        }
        case EProductActionTypes.setProduct: {
            var _a = action.payload, productId = _a.productId, name_1 = _a.name;
            return __assign(__assign({}, state), { currentId: productId, name: name_1 });
        }
        default:
            return state;
    }
}

var initial$4 = {
    loading: false,
    data: undefined,
};
function productsReducer(state, action) {
    if (state === void 0) { state = initial$4; }
    switch (action.type) {
        case EProductsActionTypes.productsLoadingSet: {
            return __assign(__assign({}, state), { loading: action.payload });
        }
        case EProductsActionTypes.setProducts: {
            return __assign(__assign({}, state), { data: action.payload });
        }
        default:
            return state;
    }
}

var initial$3 = {
    loading: false,
    current: {
        answerState: "",
        assignedTo: "",
        caption: "",
        constraints: { required: false },
        groupCaption: "",
        hasReflexive: false,
        id: "",
        index: "",
        initialAnswerByProductChange: false,
        isNew: false,
        meta: "",
        scope: "",
        type: "",
    },
    groupedQuestions: undefined,
    prepopulateQuestion: false,
};
function questionReducer(state, action) {
    var _a;
    if (state === void 0) { state = initial$3; }
    switch (action.type) {
        case EQuestionActionTypes.questionLoadingSet: {
            return __assign(__assign({}, state), { loading: action.payload });
        }
        case EQuestionActionTypes.setQuestion: {
            return __assign(__assign({}, state), { current: action.payload });
        }
        case EQuestionActionTypes.setPrepopulateQuestion: {
            return __assign(__assign({}, state), { prepopulateQuestion: action.payload });
        }
        case EQuestionActionTypes.setGroupedQuestions: {
            var groupedQuestions = undefined;
            if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.question)) {
                groupedQuestions = undefined;
            }
            else if (state === null || state === void 0 ? void 0 : state.groupedQuestions) {
                groupedQuestions = __spreadArrays(state.groupedQuestions).concat(action.payload.question);
            }
            else {
                groupedQuestions = [action.payload.question];
            }
            return __assign(__assign({}, state), { groupedQuestions: groupedQuestions });
        }
        default:
            return state;
    }
}

var initial$2 = {
    loading: true,
    data: null,
    computed: [],
    assessmentLoadingValue: null,
    formattedQuestions: undefined,
    finalQuestionId: null,
    questionnaireResolution: null,
    query: "",
    questionnaireCompleted: false,
    completePrequalificationAssessment: {
        answer: null,
        isCompleted: null,
    },
};
function questionsReducer(state, action) {
    if (state === void 0) { state = initial$2; }
    switch (action.type) {
        case EQuestionsActionTypes.questionsLoadingSet: {
            return __assign(__assign({}, state), { loading: action.payload });
        }
        case EQuestionsActionTypes.setQuestions: {
            return __assign(__assign({}, state), { data: action.payload.rasPayload || action.payload, computed: action.payload.computed || [] });
        }
        case EQuestionsActionTypes.setFormatedQuestions: {
            return __assign(__assign({}, state), { formattedQuestions: action.payload });
        }
        case EQuestionsActionTypes.setLoadingValue: {
            return __assign(__assign({}, state), { assessmentLoadingValue: action.payload });
        }
        case EQuestionsActionTypes.setQuery: {
            return __assign(__assign({}, state), { query: action.payload });
        }
        case EQuestionsActionTypes.setFinalQuestion: {
            var questionId = action.payload.questionId;
            return __assign(__assign({}, state), { finalQuestionId: questionId });
        }
        case EQuestionsActionTypes.setQuestionnaireResolution: {
            return __assign(__assign({}, state), { questionnaireResolution: action.payload });
        }
        case EQuestionsActionTypes.setQuestionnaireCompleted: {
            return __assign(__assign({}, state), { questionnaireCompleted: action.payload });
        }
        case EQuestionsActionTypes.setCompletePrequalificationAssessmentIsCompleted: {
            return __assign(__assign({}, state), { completePrequalificationAssessment: __assign(__assign({}, state.completePrequalificationAssessment), { isCompleted: action.payload }) });
        }
        case EQuestionsActionTypes.setCompletePrequalificationAssessmentAnswer: {
            return __assign(__assign({}, state), { completePrequalificationAssessment: __assign(__assign({}, state.completePrequalificationAssessment), { answer: action.payload }) });
        }
        default:
            return state;
    }
}

var initial$1 = {
    loading: false,
    data: null,
};
function userReducer(state, action) {
    if (state === void 0) { state = initial$1; }
    switch (action.type) {
        case EUserActionTypes.userLoadingSet: {
            return __assign(__assign({}, state), { loading: action.payload });
        }
        case EUserActionTypes.setUser: {
            return __assign(__assign({}, state), { data: __assign(__assign(__assign({}, state.data), { smoker: "0", smokerFE: "0" }), action.payload) });
        }
        case EUserActionTypes.setSmoker: {
            return __assign(__assign({}, state), { data: state.data
                    ? __assign(__assign({}, state.data), { smoker: action.payload }) : null });
        }
        case EUserActionTypes.setSmokerFE: {
            return __assign(__assign({}, state), { data: state.data
                    ? __assign(__assign({}, state.data), { smokerFE: action.payload }) : null });
        }
        case EUserActionTypes.setCurrentStatusInCanada: {
            return __assign(__assign({}, state), { data: state.data
                    ? __assign(__assign({}, state.data), { currentStatusInCanada: action.payload.statusInCanada }) : null });
        }
        case EUserActionTypes.setBankruptcyStatus: {
            return __assign(__assign({}, state), { data: state.data
                    ? __assign(__assign({}, state.data), { bankruptcyStatus: action.payload }) : null });
        }
        default:
            return state;
    }
}

var initial = {
    loading: false,
    data: {
        success: 0,
        data: undefined,
    },
    selectedTerm: 0,
    computedRisk: 0,
    coverage: {
        value: 0,
        minValue: 0,
        maxValue: 0,
        forcedMax: null,
    },
    ciCoverage: {
        minValue: 0,
        maxValue: 0,
    },
    disabledTermsAccordingToApplicantAge: null,
    ratesDetails: null,
    finalAssessmentRatesDetails: null,
    eligibleProducts: null,
};
function termsAndRisksReducer(state, action) {
    var _a, _b, _c;
    var _d, _e, _f;
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case ETermsAndRisksActionTypes.termsAndRisksLoadingSet: {
            return __assign(__assign({}, state), { loading: action.payload });
        }
        case ETermsAndRisksActionTypes.setTermsAndRisks: {
            var data = action.payload.data;
            return __assign(__assign({}, state), { data: data });
        }
        case ETermsAndRisksActionTypes.setTerm: {
            return __assign(__assign({}, state), { selectedTerm: action.payload });
        }
        case ETermsAndRisksActionTypes.setTermAndComputedRisk: {
            return __assign(__assign({}, state), { computedRisk: ((_d = action === null || action === void 0 ? void 0 : action.payload) === null || _d === void 0 ? void 0 : _d.computedRisk) ? action.payload.computedRisk
                    : state.computedRisk, selectedTerm: ((_e = action === null || action === void 0 ? void 0 : action.payload) === null || _e === void 0 ? void 0 : _e.term) ? (_f = action === null || action === void 0 ? void 0 : action.payload) === null || _f === void 0 ? void 0 : _f.term : state.selectedTerm });
        }
        case ETermsAndRisksActionTypes.setCoverage: {
            var _g = action.payload, value = _g.value, maxValue = _g.maxValue, minValue = _g.minValue, forcedMax = _g.forcedMax, currentStatusInCanada = _g.currentStatusInCanada, bankruptcyStatus = _g.bankruptcyStatus;
            var _h = state.coverage, stateValue = _h.value, stateMaxValue = _h.maxValue, stateMinValue = _h.minValue, stateForcedMax = _h.forcedMax;
            var resultedValue = value !== null && value !== void 0 ? value : stateValue;
            var resultedMaxValue = maxValue !== null && maxValue !== void 0 ? maxValue : stateMaxValue;
            var resultedMinValue = minValue !== null && minValue !== void 0 ? minValue : stateMinValue;
            var resultedForcedMaxValue = forcedMax !== null && forcedMax !== void 0 ? forcedMax : stateForcedMax;
            if ((bankruptcyStatus === null || bankruptcyStatus === void 0 ? void 0 : bankruptcyStatus.toLowerCase()) === "yes" ||
                currentStatusInCanada === ECurrentStatusInCanada.SuperVisa ||
                currentStatusInCanada ===
                    ECurrentStatusInCanada.WorkingPermit ||
                currentStatusInCanada === ECurrentStatusInCanada.StudentVisa) {
                // TODO: rename MAX_COVERAGE into a more generic name to
                // cover the student visa scenario
                if (resultedForcedMaxValue &&
                    resultedForcedMaxValue > MAX_COVERAGE) {
                    resultedMaxValue = MAX_COVERAGE;
                    resultedForcedMaxValue = MAX_COVERAGE;
                }
                else if (resultedMaxValue &&
                    resultedMaxValue > MAX_COVERAGE) {
                    resultedMaxValue = MAX_COVERAGE;
                }
            }
            if (resultedForcedMaxValue &&
                resultedForcedMaxValue < resultedValue) {
                resultedValue = resultedForcedMaxValue;
            }
            else if (resultedMaxValue < resultedValue) {
                resultedValue = resultedMaxValue;
            }
            return __assign(__assign({}, state), { coverage: {
                    value: resultedValue,
                    minValue: resultedMinValue,
                    maxValue: resultedMaxValue,
                    forcedMax: resultedForcedMaxValue,
                } });
        }
        case ETermsAndRisksActionTypes.setDisabledTermsAccordingToApplicantAge: {
            // if the current selected term is included in the disabled terms then reset it with the next term that is not disabled.
            var disabledTerms_1 = action.payload;
            var selectedTerm = state.selectedTerm;
            if (disabledTerms_1.includes(selectedTerm)) {
                selectedTerm = availableEvolutionTerms.find(function (item) { return !disabledTerms_1.includes(item); });
            }
            return __assign(__assign({}, state), { disabledTermsAccordingToApplicantAge: action.payload, selectedTerm: selectedTerm
                    ? selectedTerm
                    : EMaxAndMinTermAndRisk.minSureAndEvolutionProductsTerm });
        }
        case ETermsAndRisksActionTypes.setRatesDetails: {
            var risk = action.payload.risk;
            var ratesDetails = !action.payload.ratesDetails
                ? null
                : __assign({}, action.payload.ratesDetails);
            return __assign(__assign({}, state), { ratesDetails: __assign(__assign({}, state.ratesDetails), (_a = {}, _a[risk] = ratesDetails, _a)) });
        }
        case ETermsAndRisksActionTypes.setFinalAssessmentRatesDetails: {
            var term = action.payload.term;
            var ratesDetails = !action.payload.ratesDetails
                ? null
                : __assign({}, action.payload.ratesDetails);
            return __assign(__assign({}, state), { finalAssessmentRatesDetails: __assign(__assign({}, state.finalAssessmentRatesDetails), (_b = {}, _b[term] = ratesDetails, _b)) });
        }
        case ETermsAndRisksActionTypes.setEligibleProducts: {
            var _j = action.payload, term = _j.term, ratesDetails = _j.ratesDetails;
            if (term) {
                return __assign(__assign({}, state), { eligibleProducts: __assign(__assign({}, state.eligibleProducts), (_c = {}, _c[term] = ratesDetails, _c)) });
            }
            else {
                return state;
            }
        }
        case ETermsAndRisksActionTypes.setCICoverage: {
            var _k = action.payload, maxValue = _k.maxValue, minValue = _k.minValue;
            return __assign(__assign({}, state), { ciCoverage: {
                    minValue: minValue ? minValue : state.ciCoverage.minValue,
                    maxValue: maxValue ? maxValue : state.ciCoverage.maxValue,
                } });
        }
        default:
            return state;
    }
}

var appReducers = function (history) {
    return redux.combineReducers({
        router: connectedReactRouter.connectRouter(history),
        app: appReducer,
        product: productReducer,
        question: questionReducer,
        questions: questionsReducer,
        products: productsReducer,
        user: userReducer,
        termsAndRisks: termsAndRisksReducer,
    });
};
var rootReducer = function (history) { return function (state, action) {
    if (action.type === EAppActionTypes.resetStoreSuccess) {
        state = undefined;
    }
    return appReducers(history)(state, action);
}; };

var products = {
    get: function (payload) {
        return axiosInstance().get("/ras-web/rs/knowledgebases/sli/versions/latest/products", {
            params: {
                language: payload.language,
            },
        });
    },
};

var questions = {
    riskAssessmetnResource: function (payload) {
        return axiosInstance().post("/ras-web/rs/knowledgebases/sli/versions/latest/riskassessments", payload, {
            headers: { "content-type": "application/json;charset=utf-8" },
        });
    },
    fetchAssessmentFactorSearch: function (endpoint, params) {
        return axiosInstance().get("/ras-web/" + endpoint, {
            params: __assign({}, params),
        });
    },
    fetchJsonRasPayload: function (endpoint) {
        return axios__default["default"]
            .get("./assessment/" + endpoint)
            .then(function (response) {
            return response.data;
        })
            .catch(function (err) {
            console.log({ err: err });
        });
    },
};

var termsAndRisks = {
    get: function (payload) {
        var isCallCenter = payload.isCallCenter, _a = payload.useEvolutionApi, useEvolutionApi = _a === void 0 ? false : _a, _b = payload.useJuvenileProduct, useJuvenileProduct = _b === void 0 ? false : _b;
        var evolutionAPI = "/api/evolution/products/latest?limit=100&where=name:CONTAINS:Evolution";
        var juvenileApi = "/api/juvenile/products/latest?limit=100";
        var sureTermApi = "/api/reflexive/products/latest?limit=100&where=name:CONTAINS:SureTerm";
        var url = "";
        if (useJuvenileProduct) {
            url = juvenileApi;
        }
        else if (useEvolutionApi || isCallCenter === 0) {
            url = evolutionAPI;
        }
        else {
            url = sureTermApi;
        }
        return iAppApi().get("" + url, {
            headers: {
                "api-token": "6a27c3373d118d4eb81cd1d4b83f7ffe",
            },
        });
    },
    getRatesMatch: function (data) {
        // isCallCenter = 0
        // - the url can be evolutionRatesMatch or forecastRatesMatch
        // isCallCenter === 1 || isCallCenter === 2.
        // - the url can be reflexiveRatesMatch or evolutionRatesMatch
        var reflexiveRatesMatch = "/api/reflexive/rates/match";
        var evolutionRatesMatch = "/api/evolution/rates/match";
        var forecastRatesMatch = "/api/chubb/rates/match";
        var juvenileRatesMatch = "/api/juvenile/rates/match";
        var _a = data.payload, isCallCenter = _a.isCallCenter, payload = __rest(_a, ["isCallCenter"]);
        var payloadData = __assign({}, payload);
        var url = null;
        var productTerm = payloadData.product_term;
        var applicantAge = payloadData.age;
        if (applicantAge == null) {
            console.error("The applicant's age is missing!");
            return;
        }
        if (productTerm === EProductTerm.JuvenileLife ||
            productTerm === EProductTerm.JuvenileCI) {
            url = juvenileRatesMatch;
        }
        else if (isCallCenter !== 0) {
            if ((applicantAge < ageRangeForEvolutionAndSureTermApi.lowerLimit &&
                productTerm !== EProductTerm.T100) ||
                (applicantAge >=
                    ageRangeForEvolutionAndSureTermApi.lowerLimit &&
                    applicantAge <=
                        ageRangeForEvolutionAndSureTermApi.upperLimit &&
                    (productTerm === EProductTerm.T10 ||
                        productTerm === EProductTerm.T20))) {
                url = evolutionRatesMatch;
            }
            else {
                url = reflexiveRatesMatch;
            }
        }
        else {
            if (productTerm === EProductTerm.chubb) {
                url = forecastRatesMatch;
                payloadData = __assign(__assign({}, payloadData), { product_term: undefined });
            }
            else {
                url = evolutionRatesMatch;
            }
        }
        return iAppApi().post("" + url, payloadData, {
            headers: {
                "api-token": "6a27c3373d118d4eb81cd1d4b83f7ffe",
            },
        });
    },
};

var notify = function (type, message, description) {
    //@ts-ignore
    return antd.notification[type]({
        message: message,
        description: description,
    });
};

var ZONE_BACKEND_URIS = {
    local: "https://us-api.isi.zone/api",
    development: "https://us-api.isi.zone/api",
    demo: "https://us-api.isi.zone/api",
    production: "https://api.usisi.cc/api",
};
var CANADA_PROVINCIES_BACKEND_URIS = {
    local: "https://api-staging.isi.zone/api",
    development: "https://api-staging.isi.zone/api",
    demo: "https://api-staging.isi.zone/api",
    production: "https://api.isi.ca/api",
};
var IAPP_BACKEND_URIS = {
    local: "https://api-staging.isi.zone",
    development: "https://api-staging.isi.zone",
    demo: "https://api-staging.isi.zone",
    staging: "https://api.isi.ca",
    production: "https://api.isi.ca",
};
var OLD_BACKEND_URIS = {
    local: "http://localhost",
    development: "https://reflex-dev-old.iapplication.dev",
    demo: "https://reflex-dev-old.iapplication.dev",
    staging: "https://reflex-prod-old.isi.zone",
    production: "https://reflex-prod.old.isi.zone",
};
var BACKEND_URIS = {
    local: "http://localhost",
    development: "https://reflex-dev.iapplication.dev",
    demo: "https://reflex-dev.iapplication.dev",
    staging: "https://reflex-prod.isi.zone",
    production: "https://reflex-prod.isi.zone",
};
var auth = {
    local: "Qwer!234",
    development: "1VVBM96oNok1YJtVamAf",
    demo: "1VVBM96oNok1YJtVamAf",
    staging: "Qwer!234",
    production: "8WDpQ0yMIrXKqPu1w2ix",
};
// const env = "development";
var env = "production";
var defaultOptions = {
    baseURL: BACKEND_URIS[env],
    headers: {
        "Content-Type": "application/json;charset=utf-8",
    },
    auth: {
        username: "isi",
        password: auth[env],
    },
};
// Create instance
var instance = axios__default["default"].create(defaultOptions);
var iAppInstance = axios__default["default"].create({
    baseURL: IAPP_BACKEND_URIS[env],
    headers: {
        "Content-Type": "application/json;charset=utf-8",
    },
});
var isiZoneInstance = axios__default["default"].create({
    baseURL: ZONE_BACKEND_URIS[env],
    headers: {
        "Content-Type": "application/json;charset=utf-8",
    },
});
var isiCanadaProvincesInstance = axios__default["default"].create({
    baseURL: CANADA_PROVINCIES_BACKEND_URIS[env],
    headers: {
        "Content-Type": "application/json;charset=utf-8",
    },
});
// if (responseInterceptor)
//   instance.interceptors.response.eject(responseInterceptor);
// Add a response interceptor
axios__default["default"].interceptors.response.use(function (response) {
    // Do something with the response
    return response;
}, function (error) {
    // try {
    //   const response = JSON.parse(
    //     String.fromCharCode.apply(
    //       null,
    //       // @ts-ignore
    //       new Uint8Array(error.response.data)
    //     )
    //   );
    //   if (response && response.errors === "Unauthorized access!") {
    //     history.push("/auth/sign-out");
    //   }
    // } catch (e) {}
    return Promise.reject(error);
});
var axiosInstance = function () { return instance; };
var iAppApi = function () { return iAppInstance; };
var isiZoneApi = function () { return isiZoneInstance; };
var isiCanadaProvincesApi = function () { return isiCanadaProvincesInstance; };
var updateAxiosInstance = function (env, version) {
    var isOlderVersion = Number((version === null || version === void 0 ? void 0 : version.replace('.', '')) || 0) < 1451; // 14.5.1
    instance.defaults.baseURL = isOlderVersion ? BACKEND_URIS[env] : OLD_BACKEND_URIS[env];
    iAppInstance.defaults.baseURL = IAPP_BACKEND_URIS[env];
    isiZoneInstance.defaults.baseURL = ZONE_BACKEND_URIS[env];
    isiCanadaProvincesInstance.defaults.baseURL =
        CANADA_PROVINCIES_BACKEND_URIS[env];
    if (instance.defaults.auth)
        instance.defaults.auth.password = auth[env];
};
var api = {
    products: products,
    questions: questions,
    termsAndRisks: termsAndRisks,
};

var history = history$1.createBrowserHistory();
var sagaMiddleware = createSagaMiddleware__default["default"]();
function configureStore() {
    var middlewares = [sagaMiddleware, connectedReactRouter.routerMiddleware(history)];
    var store = redux.createStore(rootReducer(history), reduxDevtoolsExtension.composeWithDevTools(redux.applyMiddleware.apply(void 0, middlewares)));
    sagaMiddleware.run(rootSaga);
    return store;
}

var css_248z$v = ".styles-module_listElement__txIW4 {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background: #f4f4f4;\n  margin-bottom: 5px;\n  padding: 4px 10px;\n}\n.styles-module_listElement__txIW4 .styles-module_leftSide__RYW9m {\n  display: flex;\n  flex-direction: row;\n}\n.styles-module_listElement__txIW4 .styles-module_leftSide__RYW9m > div:first-child {\n  margin-right: 10px;\n}\n.styles-module_listElement__txIW4 .styles-module_leftSide__RYW9m > div:nth-child(2) {\n  color: #000000;\n  font-size: 12px;\n  line-height: 23px;\n}\n.styles-module_listElement__txIW4 .styles-module_rightSide__gpywD {\n  font-size: 12px;\n  color: #000000;\n  line-height: 23px;\n}\n.styles-module_listElement__txIW4 .styles-module_boldText__VuUv4 {\n  font-weight: bold;\n}\n.styles-module_listElement__txIW4.styles-module_disabled__V5jwR .styles-module_checkCircleFilled__qhqM8,\n.styles-module_listElement__txIW4.styles-module_disabled__V5jwR .styles-module_normalText__VoFwL {\n  opacity: 0.5;\n  cursor: default;\n}\n.styles-module_listElement__txIW4.styles-module_inactiveList__CC6MZ .styles-module_leftSide__RYW9m > div:nth-child(2) {\n  color: #b5b5b5;\n}\n.styles-module_listElement__txIW4.styles-module_inactiveList__CC6MZ .styles-module_rightSide__gpywD {\n  color: #b5b5b5;\n}\n.styles-module_listElement__txIW4.styles-module_cursorPointer__AdNYv {\n  cursor: pointer;\n}\n.styles-module_listElement__txIW4 .styles-module_loader__pyntM {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}";
var classes$u = {"listElement":"styles-module_listElement__txIW4","leftSide":"styles-module_leftSide__RYW9m","rightSide":"styles-module_rightSide__gpywD","boldText":"styles-module_boldText__VuUv4","disabled":"styles-module_disabled__V5jwR","checkCircleFilled":"styles-module_checkCircleFilled__qhqM8","normalText":"styles-module_normalText__VoFwL","inactiveList":"styles-module_inactiveList__CC6MZ","cursorPointer":"styles-module_cursorPointer__AdNYv","loader":"styles-module_loader__pyntM"};
styleInject(css_248z$v);

var stateSelectorHandle$o = reselect.createSelector(function (state) { return state.user.data; }, function (state) { return state.termsAndRisks.coverage; }, function (state) { return state.termsAndRisks.data.data; }, function (state) { return state.app.useJuvenileProduct; }, function (state) { return state.app.add_everest; }, function (userData, coverageDetails, termsAndRisksProducts, useJuvenileProduct, appAddEverest) {
    return {
        userData: userData,
        coverageDetails: coverageDetails,
        termsAndRisksProducts: termsAndRisksProducts,
        useJuvenileProduct: useJuvenileProduct,
        appAddEverest: appAddEverest,
    };
});
var Risk = function (_a) {
    var _b, _c, _d;
    var risk = _a.risk, index = _a.index, computedRisk = _a.computedRisk, rateValue = _a.rateValue, questionnaireEvaluation = _a.questionnaireEvaluation, selectedTerm = _a.selectedTerm, loading = _a.loading;
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$o, []);
    var _e = reactRedux.useSelector(stateSelector), userData = _e.userData, coverageDetails = _e.coverageDetails, termsAndRisksProducts = _e.termsAndRisksProducts, useJuvenileProduct = _e.useJuvenileProduct, appAddEverest = _e.appAddEverest;
    var coverageValue = coverageDetails.value, minCoverage = coverageDetails.minValue, maxCoverage = coverageDetails.maxValue;
    React.useEffect(function () {
        if (risk && selectedTerm && userData && maxCoverage && minCoverage) {
            // when the application is started if the coverage value is not defined then use minCoverage value in order to get the rates match
            var selectedProductData = getProductVersionAndCodeForCallCenter({
                products: termsAndRisksProducts,
                selectedTerm: selectedTerm,
                risk: risk,
            });
            dispatch(getRatesMatch({
                product_risk: risk,
                product_term: selectedTerm,
                benefit_amount: coverageValue ? coverageValue : minCoverage,
                product_version: selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.version,
                add_everest: appAddEverest !== null && appAddEverest !== void 0 ? appAddEverest : 0,
            }));
        }
    }, [
        dispatch,
        risk,
        computedRisk,
        selectedTerm,
        userData,
        coverageValue,
        minCoverage,
        termsAndRisksProducts,
        maxCoverage,
        appAddEverest,
    ]);
    var _f = reactI18next.useTranslation(), t = _f.t, i18n = _f.i18n;
    return (React__default["default"].createElement("div", { key: "risk_" + index, className: classNames__default["default"](classes$u.listElement, (_b = {},
            _b[classes$u.disabled] = !questionnaireEvaluation.status,
            _b)) }, React__default["default"].createElement(React__default["default"].Fragment, { key: "risk_" + index },
        React__default["default"].createElement("div", { className: classes$u.leftSide },
            React__default["default"].createElement("div", { className: classes$u.checkCircleFilled },
                React__default["default"].createElement(icons.CheckCircleFilled, { style: risk === computedRisk
                        ? { color: "#85de0d" }
                        : { color: "#b5b5b5" } })),
            React__default["default"].createElement("div", { className: classNames__default["default"](classes$u.normalText, (_c = {},
                    _c[classes$u.boldText] = risk === computedRisk,
                    _c)) }, useJuvenileProduct
                ? risk === 1
                    ? t("Standard")
                    : t("Guaranteed Issued")
                : t("Risk") + " " + risk)),
        React__default["default"].createElement("div", { className: classNames__default["default"](classes$u.rightSide, classes$u.normalText, (_d = {},
                _d[classes$u.boldText] = risk === computedRisk,
                _d)) }, loading ? (React__default["default"].createElement(antd.Spin, { className: classes$u.loader, size: "small" })) : rateValue ? (i18n.language === "en" ? ("$ " + rateValue + " / " + "month") : (rateValue + " / " + t("month") + " $")) : ("---")))));
};
var Risk$1 = React.memo(Risk);

var css_248z$u = ".styles-module_listElement__kfXEm {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background: #f4f4f4;\n  margin-bottom: 5px;\n  padding: 4px 10px;\n}\n.styles-module_listElement__kfXEm .styles-module_leftSide__k4Vls {\n  display: flex;\n  flex-direction: row;\n}\n.styles-module_listElement__kfXEm .styles-module_leftSide__k4Vls > div:first-child {\n  margin-right: 10px;\n}\n.styles-module_listElement__kfXEm .styles-module_leftSide__k4Vls > div:nth-child(2) {\n  color: #000000;\n  font-size: 12px;\n  line-height: 23px;\n}\n.styles-module_listElement__kfXEm .styles-module_rightSide__3gHh8 {\n  font-size: 12px;\n  color: #000000;\n  line-height: 23px;\n}\n.styles-module_listElement__kfXEm .styles-module_boldText__BLvyH {\n  font-weight: bold;\n}\n.styles-module_listElement__kfXEm.styles-module_disabled__IWUSn .styles-module_checkCircleFilled__ndY-2,\n.styles-module_listElement__kfXEm.styles-module_disabled__IWUSn .styles-module_normalText__Muqno {\n  opacity: 0.5;\n  cursor: default;\n}\n.styles-module_listElement__kfXEm.styles-module_inactiveList__9kokQ .styles-module_leftSide__k4Vls > div:nth-child(2) {\n  color: #b5b5b5;\n}\n.styles-module_listElement__kfXEm.styles-module_inactiveList__9kokQ .styles-module_rightSide__3gHh8 {\n  color: #b5b5b5;\n}\n.styles-module_listElement__kfXEm.styles-module_cursorPointer__v5GBj {\n  cursor: pointer;\n}";
var classes$t = {"listElement":"styles-module_listElement__kfXEm","leftSide":"styles-module_leftSide__k4Vls","rightSide":"styles-module_rightSide__3gHh8","boldText":"styles-module_boldText__BLvyH","disabled":"styles-module_disabled__IWUSn","checkCircleFilled":"styles-module_checkCircleFilled__ndY-2","normalText":"styles-module_normalText__Muqno","inactiveList":"styles-module_inactiveList__9kokQ","cursorPointer":"styles-module_cursorPointer__v5GBj"};
styleInject(css_248z$u);

var stateSelectorHandle$n = reselect.createSelector(function (state) { return state.termsAndRisks.disabledTermsAccordingToApplicantAge; }, function (state) { return state.app.useJuvenileProduct; }, 
// (state: TStore) => state.termsAndRisks.computedRisk,
function (disabledTermsAccordingToApplicantAge, useJuvenileProduct) {
    return {
        disabledTermsAccordingToApplicantAge: disabledTermsAccordingToApplicantAge,
        useJuvenileProduct: useJuvenileProduct,
    };
});
var Term = function (_a) {
    var _b, _c;
    var item = _a.item, index = _a.index, questionnaireEvaluation = _a.questionnaireEvaluation, handleSelectTerm = _a.handleSelectTerm, selectedTerm = _a.selectedTerm;
    var stateSelector = React.useCallback(stateSelectorHandle$n, []);
    var _d = reactRedux.useSelector(stateSelector), disabledTermsAccordingToApplicantAge = _d.disabledTermsAccordingToApplicantAge, useJuvenileProduct = _d.useJuvenileProduct;
    var t = reactI18next.useTranslation().t;
    var showEvolutionLabelAccordingToAgeAndTerm = useShowEvolutionLabelAccordingToAge(item).showEvolutionLabelAccordingToAgeAndTerm;
    var termLabel = React.useMemo(function () {
        if (useJuvenileProduct) {
            if (item === EProductTerm.JuvenileLife) {
                return "" + t("Evolution Jr. Life");
            }
            else if (item === EProductTerm.JuvenileCI) {
                return "" + t("Evolution Jr. Critical Illness");
            }
            else {
                return "-";
            }
        }
        else {
            return showEvolutionLabelAccordingToAgeAndTerm
                ? t("Evolution") + " T" + item
                : "T" + item;
        }
    }, [item, showEvolutionLabelAccordingToAgeAndTerm, t, useJuvenileProduct]);
    return (React__default["default"].createElement("div", { key: "product_" + index, className: classNames__default["default"](classes$t.listElement, (_b = {},
            _b[classes$t.cursorPointer] = questionnaireEvaluation.status &&
                !(disabledTermsAccordingToApplicantAge === null || disabledTermsAccordingToApplicantAge === void 0 ? void 0 : disabledTermsAccordingToApplicantAge.includes(item)),
            _b[classes$t.disabled] = !questionnaireEvaluation.status || (disabledTermsAccordingToApplicantAge === null || disabledTermsAccordingToApplicantAge === void 0 ? void 0 : disabledTermsAccordingToApplicantAge.includes(item)),
            _b)), onClick: !questionnaireEvaluation.status || (disabledTermsAccordingToApplicantAge === null || disabledTermsAccordingToApplicantAge === void 0 ? void 0 : disabledTermsAccordingToApplicantAge.includes(item))
            ? undefined
            : handleSelectTerm(item) },
        React__default["default"].createElement("div", { className: classes$t.leftSide },
            React__default["default"].createElement("div", { className: classes$t.checkCircleFilled },
                React__default["default"].createElement(icons.CheckCircleFilled, { style: item === selectedTerm
                        ? { color: "#85de0d" }
                        : { color: "#b5b5b5" } })),
            React__default["default"].createElement("div", { className: classNames__default["default"](classes$t.normalText, (_c = {},
                    _c[classes$t.boldText] = item === selectedTerm,
                    _c)) }, termLabel))));
};
var Term$1 = React.memo(Term);

var css_248z$t = ".styles-module_container__cpf-q {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-grow: 1;\n  z-index: 1;\n  margin-top: 75px;\n}\n.styles-module_container__cpf-q .styles-module_text__Xnny3 {\n  font-size: 12px;\n  font-style: italic;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  line-height: 32px;\n  text-align: center;\n  font-size: 18px;\n}\n.styles-module_container__cpf-q .styles-module_actionButton__6b5N- {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 24px;\n}";
var classes$s = {"container":"styles-module_container__cpf-q","text":"styles-module_text__Xnny3","actionButton":"styles-module_actionButton__6b5N-"};
styleInject(css_248z$t);

var stateSelectorHandle$m = reselect.createSelector(function (state) { return state.app.isReaderActive; }, function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter; }, function (isReaderActive, isCallCenter) {
    return {
        isReaderActive: isReaderActive,
        isCallCenter: isCallCenter,
    };
});
var QuestionnaireIntroMessage = function (_a) {
    var getStartedQuestionnaire = _a.getStartedQuestionnaire;
    var dispatch = reactRedux.useDispatch();
    var t = reactI18next.useTranslation().t;
    var _b = useGetMp3QuestionTitle(), stream = _b.stream, pause = _b.pause;
    var stateSelector = React.useCallback(stateSelectorHandle$m, []);
    var _c = reactRedux.useSelector(stateSelector), isReaderActive = _c.isReaderActive, isCallCenter = _c.isCallCenter;
    var onClick = React.useCallback(function (e) {
        if (isReaderActive && isCallCenter === 0) {
            pause();
        }
        getStartedQuestionnaire(e);
    }, [pause, isReaderActive, isCallCenter, getStartedQuestionnaire]);
    React.useEffect(function () {
        if (isReaderActive && stream) {
            stream({ questionsIds: ["IntroMessageUser"] });
            dispatch(setHasUsedVoice(true));
        }
    }, [isReaderActive, pause, dispatch, stream]);
    return (React__default["default"].createElement("div", { className: classes$s.container },
        React__default["default"].createElement("div", { className: classes$s.text },
            React__default["default"].createElement(reactI18next.Trans, { i18nKey: "welcomeUser" },
                "Hello, my name is Jenie",
                React__default["default"].createElement("br", null),
                "I'm here to assist you and the applicant with the underwriting assessment process",
                React__default["default"].createElement("br", null),
                "I will only ask a few questions",
                React__default["default"].createElement("br", null),
                "The process takes 15 minutes on average",
                React__default["default"].createElement("br", null),
                "You or the applicant may choose to stop at any time",
                React__default["default"].createElement("br", null),
                "But by doing so, my assessment may be incomplete and result in only Guaranteed issue option")),
        React__default["default"].createElement("div", { className: classes$s.actionButton },
            React__default["default"].createElement(antd.Button, { type: "primary", onClick: onClick }, t("Let's get started")))));
};

var css_248z$s = ".styles-module_topSection__BLnAM {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  z-index: 1;\n}\n.styles-module_topSection__BLnAM .styles-module_leftTopLogo__ZY3Rn {\n  object-fit: contain;\n  max-width: 150px;\n}\n.styles-module_topSection__BLnAM .styles-module_message__XUIev {\n  position: absolute;\n  text-align: center;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-end;\n  line-height: 20px;\n  font-weight: 500;\n}\n.styles-module_topSection__BLnAM .styles-module_message__XUIev.styles-module_blueText__ulmJ- {\n  width: 380px;\n  left: -115px;\n  color: #3fa9ff;\n}\n.styles-module_topSection__BLnAM .styles-module_message__XUIev.styles-module_blueText__ulmJ-:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.styles-module_topSection__BLnAM .styles-module_message__XUIev.styles-module_redText__DyVPM {\n  width: 400px;\n  left: -125px;\n}\n.styles-module_topSection__BLnAM .styles-module_message__XUIev.styles-module_redText__DyVPM span {\n  color: red;\n}\n.styles-module_topSection__BLnAM .styles-module_jenieLogoFrench__zFkuU {\n  max-height: 45px;\n}\n.styles-module_topSection__BLnAM .styles-module_rightTopLogo__zdOUO {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.styles-module_topSection__BLnAM .styles-module_rightTopLogo__zdOUO img {\n  object-fit: contain;\n  width: 150px;\n  display: flex;\n  align-self: flex-end;\n}\n.styles-module_topSection__BLnAM img {\n  max-width: 150px;\n  max-height: 40px;\n}";
var classes$r = {"topSection":"styles-module_topSection__BLnAM","leftTopLogo":"styles-module_leftTopLogo__ZY3Rn","message":"styles-module_message__XUIev","blueText":"styles-module_blueText__ulmJ-","redText":"styles-module_redText__DyVPM","jenieLogoFrench":"styles-module_jenieLogoFrench__zFkuU","rightTopLogo":"styles-module_rightTopLogo__zdOUO"};
styleInject(css_248z$s);

var SliLogoEn = "https://media.isi.ca/iapplication/SLI-Logo-Horizontal-en.png";
var SliLogoFr = "https://media.isi.ca/iapplication/SLI-Logo-Horizontal-fr.png";
var EvolutionLogoFr = "https://media.isi.ca/iapplication/evolution_logo_fr.svg";
var EvolutionLogoEn = "https://media.isi.ca/iapplication/evolution_logo_en.svg";
var JenieLogoEn = "https://media.isi.ca/iapplication/jenie_black_TM.png";
var JenieLogoFr = "https://media.isi.ca/iapplication/jenie-fr.png";
var stateSelectorHandle$l = reselect.createSelector(function (state) { return state.app.initFinalAssessment; }, getCompletePrequalificationAssessment, getFieldApplicationTheQuestionnaireStarted, function (initFinalAssessment, completePrequalificationAssessment, fieldApplicationTheQuestionnaireStarted) {
    return {
        initFinalAssessment: initFinalAssessment,
        completePrequalificationAssessment: completePrequalificationAssessment,
        fieldApplicationTheQuestionnaireStarted: fieldApplicationTheQuestionnaireStarted,
    };
});
var FieldVersionTopSection = function () {
    var _a, _b;
    var _c = reactI18next.useTranslation(), t = _c.t, i18n = _c.i18n;
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$l, []);
    var _d = reactRedux.useSelector(stateSelector), initFinalAssessment = _d.initFinalAssessment, completePrequalificationAssessment = _d.completePrequalificationAssessment, fieldApplicationTheQuestionnaireStarted = _d.fieldApplicationTheQuestionnaireStarted;
    var prequalificationAssessmentMessage = React.useMemo(function () {
        if (!initFinalAssessment &&
            fieldApplicationTheQuestionnaireStarted &&
            completePrequalificationAssessment.answer) {
            if (!completePrequalificationAssessment.isCompleted) {
                return [t("The medical prequalification assessment is in progress")];
            }
            else {
                return t("Medical prequalification assessment is completed, click on Jenie Assist to check the results").split("___completed___");
            }
        }
        else {
            return null;
        }
    }, [initFinalAssessment, fieldApplicationTheQuestionnaireStarted, completePrequalificationAssessment.answer, completePrequalificationAssessment.isCompleted, t]);
    var showJennieAssistDrawer = React.useCallback(function () {
        if (completePrequalificationAssessment.answer &&
            completePrequalificationAssessment.isCompleted) {
            dispatch(setShowJenieAssistDrawer(true));
        }
        else {
            return;
        }
    }, [
        completePrequalificationAssessment.answer,
        completePrequalificationAssessment.isCompleted,
        dispatch,
    ]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: classes$r.topSection },
            React__default["default"].createElement("div", null,
                React__default["default"].createElement("img", { className: classes$r.leftTopLogo, alt: "SLI-Logo", src: i18n.language === "en" ? SliLogoEn : SliLogoFr })),
            React__default["default"].createElement("div", { style: { position: "relative" } },
                React__default["default"].createElement("img", { className: classNames__default["default"]((_a = {},
                        _a[classes$r.jenieLogoFrench] = i18n.language === "fr",
                        _a)), alt: "Jenie-Logo", src: i18n.language === "en" ? JenieLogoEn : JenieLogoFr }),
                prequalificationAssessmentMessage && (React__default["default"].createElement("div", { onClick: showJennieAssistDrawer, className: classNames__default["default"](classes$r.message, (_b = {},
                        _b[classes$r.redText] = completePrequalificationAssessment.answer &&
                            !completePrequalificationAssessment.isCompleted,
                        _b[classes$r.blueText] = completePrequalificationAssessment.answer &&
                            completePrequalificationAssessment.isCompleted,
                        _b)), style: {
                        bottom: completePrequalificationAssessment.answer &&
                            completePrequalificationAssessment.isCompleted
                            ? -80
                            : -60,
                    }, dangerouslySetInnerHTML: {
                        __html: prequalificationAssessmentMessage.length ===
                            1
                            ? "<div style=\"width: 100%;\"><span>" + prequalificationAssessmentMessage[0] + "</span><span style=\"font-weight: 700\">" + t("___in_progress___").toUpperCase() + "</span></div>"
                            : "<div style=\"width: 100%;\"><div style=\"width: 100%;\"><span>" + prequalificationAssessmentMessage[0] + "</span><span style=\"font-weight: 700\">" + t("___completed___").toUpperCase() + "</span></div><span>" + prequalificationAssessmentMessage[1] + "</span></div>",
                    } }))),
            React__default["default"].createElement("div", { className: classes$r.rightTopLogo },
                React__default["default"].createElement("img", { alt: "Evolution-Logo", src: i18n.language === "en"
                        ? EvolutionLogoEn
                        : EvolutionLogoFr })))));
};
var FieldVersionTopSection$1 = React.memo(FieldVersionTopSection);

var css_248z$r = ".styles-module_bottomSection__EuE0a {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  position: absolute;\n  align-items: center;\n  min-height: 22px;\n  bottom: 16px;\n  width: 100%;\n}\n.styles-module_bottomSection__EuE0a .styles-module_switchButtonContainer__GeSfC {\n  position: absolute;\n  left: 10px;\n  z-index: 2;\n}";
var classes$q = {"bottomSection":"styles-module_bottomSection__EuE0a","switchButtonContainer":"styles-module_switchButtonContainer__GeSfC"};
styleInject(css_248z$r);

var stateSelectorHandle$k = reselect.createSelector(function (state) { return state.app; }, function (app) {
    return { app: app };
});
var FieldVersionBottomSection = function () {
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$k, []);
    var app = reactRedux.useSelector(stateSelector).app;
    var fieldApplication = app.fieldApplication, initFinalAssessment = app.initFinalAssessment;
    var t = reactI18next.useTranslation().t;
    var handleChangeBackground = React.useCallback(function () {
        dispatch(setFieldApplicationBackground(!fieldApplication.honeycombBackground));
    }, [dispatch, fieldApplication.honeycombBackground]);
    return (React__default["default"].createElement("div", { className: classes$q.bottomSection },
        React__default["default"].createElement("div", { className: classes$q.switchButtonContainer },
            React__default["default"].createElement(antd.Switch, { checkedChildren: t("Background"), unCheckedChildren: t("White"), defaultChecked: true, onChange: handleChangeBackground })),
        !initFinalAssessment && React__default["default"].createElement(ReadQuestionButton$1, null)));
};
var FieldVersionBottomSection$1 = React.memo(FieldVersionBottomSection);

var css_248z$q = ".styles-module_readQuestionContainer__hwNn- {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  margin: auto;\n}\n.styles-module_readQuestionContainer__hwNn- .styles-module_readQuestion__CvFHO {\n  z-index: 2;\n}";
var classes$p = {"readQuestionContainer":"styles-module_readQuestionContainer__hwNn-","readQuestion":"styles-module_readQuestion__CvFHO"};
styleInject(css_248z$q);

var stateSelectorHandle$j = reselect.createSelector(function (state) { return state.app; }, function (app) {
    return { app: app };
});
var ReadQuestionButton = function () {
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$j, []);
    var app = reactRedux.useSelector(stateSelector).app;
    var isReaderActive = app.isReaderActive;
    var t = reactI18next.useTranslation().t;
    var pause = useGetMp3QuestionTitle().pause;
    // const isCallCenter = user.data?.isCallCenter;
    // const extension = user?.data?.extension;
    // const togglePlayRequest = useCallback(async () => {
    // 	await fetch("http://dial11-dev.dev.isi.ca:8181/v1/audio-playback", {
    // 		method: "POST",
    // 		headers: {
    // 			"Content-Type": "application/json",
    // 		},
    // 		body: JSON.stringify({
    // 			extension: extension,
    // 			action: "start",
    // 			file: "/gtl/gtl1",
    // 		}),
    // 	});
    // }, [extension, toggleReader]);
    var toggleReader = React.useCallback(function () {
        dispatch(toggleReaderAction());
        if (isReaderActive) {
            pause();
        }
    }, [dispatch, pause, isReaderActive]);
    return (React__default["default"].createElement("div", { className: classes$p.readQuestionContainer },
        React__default["default"].createElement(antd.Button, { type: "primary", className: classes$p.readQuestion, style: {
                background: isReaderActive ? "red" : "green",
                border: "none",
                borderRadius: 4,
            }, onClick: toggleReader },
            !isReaderActive && React__default["default"].createElement(icons.PlayCircleOutlined, { size: 24 }),
            isReaderActive && React__default["default"].createElement(icons.PlayCircleOutlined, { size: 24 }),
            isReaderActive
                ? t("Stop Reading Questions")
                : t("Start Reading Questions"))));
};
var ReadQuestionButton$1 = React.memo(ReadQuestionButton);

var css_248z$p = ".styles-module_topContent__oG74p {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.styles-module_topContent__oG74p .styles-module_title__RxMg2 {\n  text-align: center;\n  color: #42a8dc;\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g {\n  flex: 1;\n  max-width: 400px;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g:first-child {\n  margin-right: 10px;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g:nth-child(2) {\n  margin-left: 10px;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background: #f4f4f4;\n  margin-bottom: 5px;\n  padding: 4px 10px;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA .styles-module_leftSide__FyuTL {\n  display: flex;\n  flex-direction: row;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA .styles-module_leftSide__FyuTL > div:first-child {\n  margin-right: 10px;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA .styles-module_leftSide__FyuTL > div:nth-child(2) {\n  color: #000000;\n  font-size: 12px;\n  line-height: 23px;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA .styles-module_rightSide__q5cNX {\n  font-size: 12px;\n  color: #000000;\n  line-height: 23px;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA .styles-module_boldText__cwAqY {\n  font-weight: bold;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA.styles-module_disabled__JQ4xG .styles-module_checkCircleFilled__Cr-Tu,\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA.styles-module_disabled__JQ4xG .styles-module_normalText__hpOd- {\n  opacity: 0.5;\n  cursor: default;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA.styles-module_inactiveList__qrEf7 .styles-module_leftSide__FyuTL > div:nth-child(2) {\n  color: #b5b5b5;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA.styles-module_inactiveList__qrEf7 .styles-module_rightSide__q5cNX {\n  color: #b5b5b5;\n}\n.styles-module_topContent__oG74p .styles-module_listContent__VAq-g .styles-module_listElement__LxkoA.styles-module_cursorPointer__vNPV2 {\n  cursor: pointer;\n}";
var classes$o = {"topContent":"styles-module_topContent__oG74p","title":"styles-module_title__RxMg2","listContent":"styles-module_listContent__VAq-g","listElement":"styles-module_listElement__LxkoA","leftSide":"styles-module_leftSide__FyuTL","rightSide":"styles-module_rightSide__q5cNX","boldText":"styles-module_boldText__cwAqY","disabled":"styles-module_disabled__JQ4xG","checkCircleFilled":"styles-module_checkCircleFilled__Cr-Tu","normalText":"styles-module_normalText__hpOd-","inactiveList":"styles-module_inactiveList__qrEf7","cursorPointer":"styles-module_cursorPointer__vNPV2"};
styleInject(css_248z$p);

var termsAndRisksDataSelector = reselect.createSelector(function (state) { return state.termsAndRisks.data; }, function (state) { return state.termsAndRisks.selectedTerm; }, function (state) { return state.termsAndRisks.computedRisk; }, function (state) { return state.termsAndRisks.ratesDetails; }, function (state) { return state.termsAndRisks.loading; }, function (state) { return state.app.useJuvenileProduct; }, function (termsAndRisksData, selectedTerm, computedRisk, ratesDetails, termsAndRisksLoading, useJuvenileProduct) {
    return {
        termsAndRisksData: termsAndRisksData,
        selectedTerm: selectedTerm,
        computedRisk: computedRisk,
        ratesDetails: ratesDetails,
        termsAndRisksLoading: termsAndRisksLoading,
        useJuvenileProduct: useJuvenileProduct,
    };
});
var RisksAndTermsSection = function () {
    var stateSelector = React.useCallback(termsAndRisksDataSelector, []);
    var _a = reactRedux.useSelector(stateSelector), termsAndRisksData = _a.termsAndRisksData, selectedTerm = _a.selectedTerm, computedRisk = _a.computedRisk, ratesDetails = _a.ratesDetails, termsAndRisksLoading = _a.termsAndRisksLoading, useJuvenileProduct = _a.useJuvenileProduct;
    var dispatch = reactRedux.useDispatch();
    var t = reactI18next.useTranslation().t;
    var questionnaireEvaluation = useQuestionnaireEvaluation().questionnaireEvaluation;
    var resultedTerms = React.useMemo(function () {
        if (!(termsAndRisksData === null || termsAndRisksData === void 0 ? void 0 : termsAndRisksData.data))
            return null;
        else {
            return termsAndRisksData.data
                .map(function (item) { return item.term; })
                .filter(function (item, index, self) {
                return self.indexOf(item) === index;
            })
                .sort(function (a, b) { return a - b; });
        }
    }, [termsAndRisksData]);
    var resultedRisks = React.useMemo(function () {
        if (!(termsAndRisksData === null || termsAndRisksData === void 0 ? void 0 : termsAndRisksData.data))
            return null;
        else {
            return termsAndRisksData.data
                .filter(function (item) {
                if (useJuvenileProduct) {
                    return (item.term === selectedTerm &&
                        (item.risk ===
                            EMaxAndMinTermAndRisk.minJuvenileProductsRisk ||
                            item.risk ===
                                EMaxAndMinTermAndRisk.maxJuvenileProductsRisk));
                }
                else {
                    return item.term === selectedTerm;
                }
            })
                .map(function (item) { return item.risk; })
                .sort(function (a, b) { return a - b; });
        }
    }, [termsAndRisksData.data, useJuvenileProduct, selectedTerm]);
    var handleSelectTerm = React.useCallback(function (value) { return function () {
        dispatch(setTerm(value));
        dispatch(computeCoverageMinMax({ selectedTerm: value, computedRisk: computedRisk }));
    }; }, [computedRisk, dispatch]);
    return (React__default["default"].createElement("div", { className: classes$o.topContent },
        React__default["default"].createElement("div", { className: classes$o.listContent },
            React__default["default"].createElement("div", { className: classes$o.title }, t("Terms")),
            resultedTerms &&
                resultedTerms.map(function (item, index) {
                    return (React__default["default"].createElement(Term$1, { key: index + "_term", item: item, index: index, questionnaireEvaluation: questionnaireEvaluation, handleSelectTerm: handleSelectTerm, selectedTerm: selectedTerm }));
                })),
        React__default["default"].createElement("div", { className: classes$o.listContent },
            React__default["default"].createElement("div", { className: classes$o.title }, t("Risk")),
            resultedRisks &&
                resultedRisks.map(function (item, index) {
                    var _a;
                    return (React__default["default"].createElement(Risk$1, { key: index + "_key", risk: item, index: index, computedRisk: computedRisk, rateValue: ratesDetails && ((_a = ratesDetails[item]) === null || _a === void 0 ? void 0 : _a.premium), questionnaireEvaluation: questionnaireEvaluation, selectedTerm: selectedTerm, loading: termsAndRisksLoading }));
                }))));
};
var RisksAndTermsSection$1 = React.memo(RisksAndTermsSection);

var FinishAndProceedBtn = function (_a) {
    var unmount = _a.unmount;
    var t = reactI18next.useTranslation().t;
    var handleFinishAndProceed = React.useCallback(function () {
        unmount();
    }, [unmount]);
    return (React__default["default"].createElement(antd.Button, { type: "primary", onClick: handleFinishAndProceed }, t("Finish & Proceed")));
};
var FinishAndProceedBtn$1 = React.memo(FinishAndProceedBtn);

var css_248z$o = ".styles-module_container__n8e-O {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.styles-module_container__n8e-O input {\n  display: flex;\n  justify-content: center;\n}";
var classes$n = {"container":"styles-module_container__n8e-O"};
styleInject(css_248z$o);

// import { FormInstance } from "antd/lib/form";
var stateSelectorHandle$i = reselect.createSelector(function (state) { var _a, _b; return (_b = (_a = state.user) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.language; }, function (userLanguage) {
    return {
        userLanguage: userLanguage,
    };
});
// interface ICountryRegion {
// 	form: FormInstance;
// 	question: IQuestion;
// }
var CountryRegion = function (_a) {
    var question = _a.question, form = _a.form;
    var t = reactI18next.useTranslation().t;
    var _b = React.useState(""), searchCountriesValue = _b[0], setSearchCountriesValue = _b[1];
    var _c = React.useState(""), searchRegionsValue = _c[0], setSearchRegionsValue = _c[1];
    var debouncedSearchCountriesTerm = useDebounce(searchCountriesValue, 300);
    var debouncedSearchRegionsTerm = useDebounce(searchRegionsValue, 300);
    var stateSelector = React.useCallback(stateSelectorHandle$i, []);
    var userLanguage = reactRedux.useSelector(stateSelector).userLanguage;
    var _d = React.useState([]), countriesOptions = _d[0], seCountriestOptions = _d[1];
    var _e = React.useState([]), regionsOptions = _e[0], seRegionstOptions = _e[1];
    var _f = React.useState("countries"), searchingFor = _f[0], setSearchingFor = _f[1];
    var onCountriesSearch = function (searchText) {
        setSearchCountriesValue(searchText);
        setSearchingFor("countries");
    };
    var onRegionsSearch = function (searchText) {
        setSearchRegionsValue(searchText);
    };
    var onCountrySelect = React.useCallback(function (data) {
        if ((userLanguage === "en" &&
            data === unitedStatesEnglishAndFrenchValue.en) ||
            (userLanguage === "fr" &&
                data === unitedStatesEnglishAndFrenchValue.fr)) {
            setSearchingFor("usStates");
        }
        else if (data === "Canada") {
            setSearchingFor("canadaProvincies");
        }
        else {
            setSearchingFor("countries");
        }
        form.setFieldsValue({ region: "" });
    }, [form, userLanguage]);
    var initCountryAndRegionAnswer = React.useCallback(function (data) {
        if ((userLanguage === "en" &&
            data.country === unitedStatesEnglishAndFrenchValue.en) ||
            (userLanguage === "fr" &&
                data.country === unitedStatesEnglishAndFrenchValue.fr)) {
            setSearchingFor("usStates");
        }
        else if (data.country === "Canada") {
            setSearchingFor("canadaProvincies");
        }
        else {
            setSearchingFor("countries");
        }
        form.setFieldsValue({ country: data.country });
        form.setFieldsValue({ region: data.region });
    }, [form, userLanguage]);
    React.useEffect(function () {
        if (debouncedSearchCountriesTerm || debouncedSearchRegionsTerm) {
            var apiRequest = isiZoneApi;
            var url = null;
            if (searchingFor === "countries") {
                url = "/countries";
            }
            else if (searchingFor === "usStates") {
                url = "/states";
            }
            else if (searchingFor === "canadaProvincies") {
                url = "/provinces";
                apiRequest = isiCanadaProvincesApi;
            }
            if (!url)
                return;
            var query = "";
            var headers = null;
            if (searchingFor === "countries" || searchingFor === "usStates") {
                query = "name" + (userLanguage === "fr" ? "_fr" : "") + ":CONTAINS:" + (searchingFor === "countries"
                    ? debouncedSearchCountriesTerm
                    : debouncedSearchRegionsTerm);
                headers = {
                    Accept: "application/prs.api.v1+json",
                    Authorization: "Bearer a4a7f33481f5b03c38cd612c87d7d33c",
                };
            }
            else if (searchingFor === "canadaProvincies") {
                query = "province" + (userLanguage === "fr" ? "_fr" : "") + ":CONTAINS:" + debouncedSearchRegionsTerm;
                headers = {
                    "api-token": "6a27c3373d118d4eb81cd1d4b83f7ffe",
                    Accept: "application/prs.api.v1+json",
                    Authorization: "Bearer a4a7f33481f5b03c38cd612c87d7d33c",
                };
            }
            apiRequest()
                .get(url, {
                params: {
                    where: query,
                    limit: 100,
                },
                headers: headers,
            })
                .then(function (results) {
                var _a, _b, _c;
                if (searchingFor === "countries") {
                    var listOfCountries = (_a = results === null || results === void 0 ? void 0 : results.data) === null || _a === void 0 ? void 0 : _a.data.map(function (item) {
                        if (userLanguage === "en") {
                            return { value: item.name };
                        }
                        else {
                            return { value: item.name_fr };
                        }
                    });
                    seCountriestOptions(listOfCountries);
                }
                else if (searchingFor === "usStates") {
                    var listOfProvincies = (_b = results === null || results === void 0 ? void 0 : results.data) === null || _b === void 0 ? void 0 : _b.data.map(function (item) {
                        if (userLanguage === "en") {
                            return { value: item.name };
                        }
                        else {
                            return { value: item.name_fr };
                        }
                    });
                    seRegionstOptions(listOfProvincies);
                }
                else {
                    var listOfProvincies = (_c = results === null || results === void 0 ? void 0 : results.data) === null || _c === void 0 ? void 0 : _c.data.map(function (item) {
                        if (userLanguage === "en") {
                            return { value: item.province };
                        }
                        else {
                            return { value: item.province_fr };
                        }
                    });
                    seRegionstOptions(listOfProvincies);
                }
            })
                .catch(function (err) {
                console.log({ err: err });
            });
        }
    }, [
        debouncedSearchCountriesTerm,
        debouncedSearchRegionsTerm,
        searchingFor,
        userLanguage,
    ]);
    React.useEffect(function () {
        var country = "";
        var region = "";
        if (question.answer) {
            if (question.answer.indexOf(",") !== -1) {
                country = question.answer.split(",")[1];
                region = question.answer.split(",")[0];
            }
            else {
                country = question.answer;
            }
            initCountryAndRegionAnswer({
                country: country.trim(),
                region: region.trim(),
            });
        }
    }, [question, onCountrySelect, form, initCountryAndRegionAnswer]);
    return (React__default["default"].createElement("div", { className: classes$n.container },
        React__default["default"].createElement(antd.Form.Item, { name: "country", className: classes$n.input, rules: [
                {
                    required: question.constraints.required,
                    message: t("Required"),
                },
            ] },
            React__default["default"].createElement(antd.AutoComplete, { options: countriesOptions, style: { width: 300 }, onSelect: onCountrySelect, onSearch: onCountriesSearch },
                React__default["default"].createElement(antd.Input, { placeholder: t("type here and select") }))),
        searchingFor !== "countries" && (React__default["default"].createElement(antd.Form.Item, { name: "region", className: classes$n.input, rules: [
                {
                    required: question.constraints.required,
                    message: t("Required"),
                },
            ] },
            React__default["default"].createElement(antd.AutoComplete, { options: regionsOptions, style: { width: 300 }, 
                // onSelect={onSelect}
                onSearch: onRegionsSearch },
                React__default["default"].createElement(antd.Input, { placeholder: t("type here and select") }))))));
};
var CountryRegion$1 = React.memo(CountryRegion);

var css_248z$n = ".styles-module_buttons__C5odJ {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 40px;\n}\n.styles-module_buttons__C5odJ > :first-child {\n  margin-right: 8px;\n}\n.styles-module_buttons__C5odJ > :nth-child(2) {\n  margin-left: 8px;\n}";
var classes$m = {"buttons":"styles-module_buttons__C5odJ"};
styleInject(css_248z$n);

var stateSelectorHandle$h = reselect.createSelector(function (state) { return state.questions; }, function (state) { return state.question; }, function (state) { return state.user; }, function (questions, question, user) {
    return {
        questions: questions,
        question: question,
        user: user,
    };
});
var ActionsButtons = function (_a) {
    var _b, _c;
    var showProceedToTheApplicationBtn = _a.showProceedToTheApplicationBtn; _a.unmount;
    var t = reactI18next.useTranslation().t;
    var _d = React.useState(false), showModal = _d[0], setShowModal = _d[1];
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$h, []);
    var _e = reactRedux.useSelector(stateSelector), _f = _e.questions, computed = _f.computed, questionnaireCompleted = _f.questionnaireCompleted, finalQuestionId = _f.finalQuestionId, question = _e.question, user = _e.user;
    var isCallCenter = (_b = user.data) === null || _b === void 0 ? void 0 : _b.isCallCenter;
    var isLastQuestion = (question &&
        ((_c = computed[computed.length - 1]) === null || _c === void 0 ? void 0 : _c.id) === question.current.id) ||
        false;
    var isLastQuestionAnswered = isLastQuestion && question.current.state !== "missing";
    var handleCancel = function () {
        setShowModal(!showModal);
    };
    var proceedToFinalAssessmentPage = React.useCallback(function () {
        setShowModal(!showModal);
        dispatch(initFinalAssessmentAction(true));
        dispatch(setApplicationApproved(true));
    }, [dispatch, showModal]);
    var handleShowModal = React.useCallback(function () {
        setShowModal(!showModal);
    }, [showModal]);
    var handlePrevQuestion = React.useCallback(function () {
        var currentIndex = computed.findIndex(function (item) { return item.id === question.current.id; });
        if (currentIndex > 0) {
            dispatch(setPrevQuestion());
        }
    }, [dispatch, computed, question]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: classes$m.buttons },
            React__default["default"].createElement(SecondaryButton$1, { label: t("Previous question"), greyBackground: true, onClick: handlePrevQuestion, disabled: !!(finalQuestionId &&
                    isCallCenter !== 1 &&
                    isLastQuestion) }),
            !!questionnaireCompleted &&
                isCallCenter !== 1 &&
                isLastQuestion &&
                showProceedToTheApplicationBtn &&
                isLastQuestionAnswered ? (React__default["default"].createElement(SecondaryButton$1, { label: t("Proceed to the application"), onClick: handleShowModal })) : (React__default["default"].createElement(SecondaryButton$1, { label: t("Next question"), type: "submit" }))),
        isCallCenter !== 1 && (React__default["default"].createElement(ConfirmModal$1, { visible: showModal, handleOk: proceedToFinalAssessmentPage, handleCancel: handleCancel, title: t("Proceed to the application"), subTitle: t("Please review your answers before proceeding!"), okText: t("Proceed"), cancelText: t("Review") }))));
};
var ActionsButtons$1 = React.memo(ActionsButtons);

var css_248z$m = ".styles-module_button__PqN1N {\n  position: fixed;\n  bottom: 10px;\n  right: 20px;\n}";
var classes$l = {"button":"styles-module_button__PqN1N"};
styleInject(css_248z$m);

var stateSelectorHandle$g = reselect.createSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.isCallCenter; }, function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.language; }, function (isCallCenter, language) {
    return {
        isCallCenter: isCallCenter,
        language: language,
    };
});
var StopAssessment = function () {
    var stateSelector = React.useCallback(stateSelectorHandle$g, []);
    var _a = reactRedux.useSelector(stateSelector), isCallCenter = _a.isCallCenter, language = _a.language;
    var _b = React.useState(false), showModal = _b[0], setShowModal = _b[1];
    var t = reactI18next.useTranslation().t;
    var dispatch = reactRedux.useDispatch();
    // const { updateReflex } = useUpdateReflex();
    var subTitle = React.useMemo(function () {
        if (language === "en") {
            if (isCallCenter === 0) {
                return (React__default["default"].createElement("div", null,
                    "Assessment is incomplete! By finishing it now, the applicant would not be able to return to the assessment and most likely can",
                    " ",
                    React__default["default"].createElement("strong", null, "only qualify for Evolution Essence Term 100."),
                    " ",
                    "Please confirm."));
            }
            else if (isCallCenter === 2) {
                return (React__default["default"].createElement("div", null,
                    "Assessment is incomplete! By finishing it now, the applicant would not be able to return to the assessment and most likely can",
                    " ",
                    React__default["default"].createElement("strong", null, "only qualify for Sure Term 100 Bronze."),
                    " ",
                    "Please confirm."));
            }
            else {
                return null;
            }
        }
        else if (language === "fr") {
            if (isCallCenter === 0) {
                return (React__default["default"].createElement("div", null,
                    "L'\u00E9valuation est incompl\u00E8te ! En arr\u00EAtant maintenant, le candidat ne pourra pas revenir \u00E0 l'\u00E9valuation",
                    " ",
                    React__default["default"].createElement("strong", null, "et il se qualifiera pour notre produit \u00C9volution Essentielle T-100."),
                    " ",
                    "Veuillez confirmer."));
            }
            else if (isCallCenter === 2) {
                return (React__default["default"].createElement("div", null,
                    "L'\u00E9valuation est incompl\u00E8te ! En arr\u00EAtant maintenant, le candidat ne pourra pas revenir \u00E0 l'\u00E9valuation",
                    " ",
                    React__default["default"].createElement("strong", null, "et il se qualifiera pour notre produit Sure Term 100 Bronze."),
                    " ",
                    "Veuillez confirmer."));
            }
            else {
                return null;
            }
        }
        else
            return null;
    }, [isCallCenter, language]);
    var handleCancel = function () {
        setShowModal(!showModal);
    };
    var handleOk = React.useCallback(function () {
        setShowModal(!showModal);
        dispatch(initFinalAssessmentAction(true));
        dispatch(setApplicationApproved(false));
        dispatch(setApplicationForceGI(true));
        dispatch(setTermAndComputedRisk({
            computedRisk: EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk,
            term: EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsTerm,
        }));
        dispatch(computeCoverageMinMax({
            selectedTerm: EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsTerm,
            computedRisk: EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk,
        }));
        exports.updateReflex({
            approved: false,
            force_GI: true,
            risk: EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk,
            term: EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsTerm,
        });
    }, [dispatch, showModal]);
    var onClick = React.useCallback(function () {
        setShowModal(!showModal);
    }, [showModal]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: classes$l.button },
            React__default["default"].createElement(antd.Button, { type: "primary", onClick: onClick, danger: true }, t("Stop the assessment process"))),
        React__default["default"].createElement(ConfirmModal$1, { visible: showModal, handleOk: handleOk, handleCancel: handleCancel, subTitle: subTitle, title: t("Stop the assessment process"), okText: t("Yes, finish the assessment"), cancelText: t("No, I would like to continue") })));
};
var StopAssessment$1 = React.memo(StopAssessment);

var css_248z$l = ".styles-module_container__v5GHr {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  z-index: 1;\n  /* position: relative; */\n  justify-content: center;\n  align-items: center;\n  color: red;\n  font-size: 16px;\n  font-weight: 700;\n}\n.styles-module_container__v5GHr .styles-module_exitButton__vUeCi {\n  background-color: red;\n  border-color: red;\n  font-size: 14px;\n  padding: 4px 35px;\n  /* margin: auto; */\n  margin-top: 10px;\n  font-weight: 600;\n}";
var classes$k = {"container":"styles-module_container__v5GHr","exitButton":"styles-module_exitButton__vUeCi"};
styleInject(css_248z$l);

var TheApplicantAgeIsTooLowMessages = function (_a) {
    var messages = _a.messages, unmount = _a.unmount;
    return (React__default["default"].createElement("div", { className: classes$k.container },
        messages.map(function (item) {
            return (React__default["default"].createElement("div", { key: item.message, className: classes$k.message }, item.message));
        }),
        React__default["default"].createElement(antd.Button, { className: classes$k.exitButton, type: "primary", onClick: unmount }, "Exit")));
};
var TheApplicantAgeIsTooLowMessages$1 = React.memo(TheApplicantAgeIsTooLowMessages);

var css_248z$k = ".styles-module_container__PSXPr {\n  z-index: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 1;\n}\n.styles-module_container__PSXPr .styles-module_error__YEAAk {\n  border: 1px solid rgba(255, 0, 0, 0.3);\n  background-color: rgba(255, 0, 0, 0.025);\n}\n.styles-module_container__PSXPr .styles-module_title__DnVoG {\n  text-align: center;\n  font-size: 30px;\n  font-weight: bold;\n  color: #42a8dc;\n}\n.styles-module_container__PSXPr .styles-module_subtitle__QuR8p {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 500;\n  color: #000000;\n}\n.styles-module_container__PSXPr .styles-module_subText__qyQ2F {\n  padding-bottom: 10px;\n  font-weight: 300;\n  font-style: italic;\n  color: #808080b8;\n  font-size: 12px;\n}\n.styles-module_container__PSXPr .styles-module_content__lxIBl {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 10px;\n  font-weight: 700;\n  font-size: 18px;\n}\n.styles-module_container__PSXPr .styles-module_content__lxIBl .styles-module_smallCenteredText__Uqml- {\n  font-size: 14;\n  margin-right: 6;\n  color: grey;\n  display: flex;\n  justify-content: center;\n}";
var classes$j = {"container":"styles-module_container__PSXPr","error":"styles-module_error__YEAAk","title":"styles-module_title__DnVoG","subtitle":"styles-module_subtitle__QuR8p","subText":"styles-module_subText__qyQ2F","content":"styles-module_content__lxIBl","smallCenteredText":"styles-module_smallCenteredText__Uqml-"};
styleInject(css_248z$k);

var Title = function (_a) {
    var questionIndex = _a.questionIndex, subText = _a.subText, caption = _a.caption, groupCaption = _a.groupCaption, _b = _a.isGroupedQuestion, isGroupedQuestion = _b === void 0 ? false : _b;
    return (React__default["default"].createElement("div", { className: classes$j.container },
        !isGroupedQuestion && questionIndex && (React__default["default"].createElement("div", { className: classes$j.title }, "Question " + questionIndex)),
        groupCaption && (React__default["default"].createElement("div", { className: classes$j.subtitle }, groupCaption)),
        caption && (React__default["default"].createElement("div", { className: classes$j.content, style: subText ? { paddingBottom: 0 } : undefined },
            questionIndex && isGroupedQuestion && (React__default["default"].createElement("div", { className: classes$j.smallCenteredText }, "(" + questionIndex + ")")),
            caption)),
        subText && React__default["default"].createElement("div", { className: classes$j.subText }, subText)));
};
var Title$1 = React.memo(Title);

var questionsSelector = reselect.createSelector(function (state) { return state.questions.finalQuestionId; }, function (finalQuestionId) {
    return {
        finalQuestionId: finalQuestionId,
    };
});
var stateSelectorHandle$f = reselect.createSelector(function (state) { return state.app; }, function (state) { return state.user; }, questionsSelector, function (state) { return state.app.fieldApplication.theQuestionnaireStarted; }, function (state) { return state.termsAndRisks; }, function (state) { return state.questions.data; }, function (state) { return state.questions.computed; }, function (state) { return state.questions.assessmentLoadingValue; }, function (app, user, questions, theQuestionnaireStarted, termsAndRisks, rasPayload, computed, assessmentLoadingValue) {
    return {
        app: app,
        user: user,
        questions: questions,
        theQuestionnaireStarted: theQuestionnaireStarted,
        termsAndRisks: termsAndRisks,
        rasPayload: rasPayload,
        computed: computed,
        assessmentLoadingValue: assessmentLoadingValue,
    };
});
var RightSide = function (_a) {
    var _b, _c;
    _a.appRef;
    useGetEligibleProducts();
    useCheckForPrequalificationAssessment();
    var t = reactI18next.useTranslation().t;
    var helperRef = React.useRef();
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$f, []);
    var _d = reactRedux.useSelector(stateSelector), app = _d.app, questions = _d.questions, user = _d.user, theQuestionnaireStarted = _d.theQuestionnaireStarted, termsAndRisks = _d.termsAndRisks, rasPayload = _d.rasPayload, computed = _d.computed, assessmentLoadingValue = _d.assessmentLoadingValue;
    var finalQuestionId = questions.finalQuestionId;
    var isLastQuestion = useIsLastQuestion().isLastQuestion;
    var initFinalAssessment = app.initFinalAssessment, theApplicantAgeIsTooLow = app.theApplicantAgeIsTooLow, applicationForceGI = app.applicationForceGI, applicationApproved = app.applicationApproved, hasUsedVoice = app.hasUsedVoice;
    var products = useGetFinalAssessmentProducts().products;
    var isCallCenter = (user.data || {}).isCallCenter;
    var selectedTerm = termsAndRisks.selectedTerm, computedRisk = termsAndRisks.computedRisk, termsAndRisksProducts = termsAndRisks.data, coverage = termsAndRisks.coverage;
    var unmount = React.useCallback(function (_a) {
        var _b, _c, _d, _e, _f;
        (_a === void 0 ? {} : _a).unmountApplicationApproved;
        if (rasPayload && (user === null || user === void 0 ? void 0 : user.data)) {
            var selectedProductData = void 0;
            if (isCallCenter === 1 && (termsAndRisksProducts === null || termsAndRisksProducts === void 0 ? void 0 : termsAndRisksProducts.data) &&
                selectedTerm) {
                selectedProductData = getProductVersionAndCodeForCallCenter({
                    products: termsAndRisksProducts.data,
                    selectedTerm: selectedTerm,
                    risk: computedRisk,
                });
            }
            var decisionStatus = (_e = (_d = (_c = (_b = rasPayload.results) === null || _b === void 0 ? void 0 : _b.products[0]) === null || _c === void 0 ? void 0 : _c.aggregatedRating) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.toLowerCase();
            var exitReflexPayload = {
                decision: { status: decisionStatus, reason: "" },
                application_id: user.data.application_id,
                term: selectedTerm,
                risk: computedRisk,
                smoker: user.data.smoker,
                smokerFE: user.data.smokerFE,
                coverage: coverage.value,
                questions: formatQuestions(computed, []),
                serverPayload: rasPayload,
                maxCoverage: coverage.forcedMax &&
                    coverage.forcedMax < coverage.maxValue
                    ? coverage.forcedMax
                    : coverage.maxValue,
                forcedStop: (assessmentLoadingValue &&
                    assessmentLoadingValue >= 201) ||
                    decisionStatus === "Decline".toLowerCase(),
                force_GI: applicationForceGI,
                approved: applicationApproved,
                products: products,
                product_code: selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.code,
                product_version: selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.version,
                hasUsedVoice: hasUsedVoice,
            };
            if (typeof exports.exitReflex !== "undefined") {
                exports.exitReflex(exitReflexPayload);
            }
        }
        else {
            if (typeof exports.exitReflex !== "undefined") {
                exports.exitReflex();
            }
        }
        if (ReactDOM__default["default"].findDOMNode(helperRef.current.parentNode.parentNode.parentNode
            .parentNode)) {
            helperRef.current.parentNode.parentNode.parentNode.parentNode.style.display =
                "none";
            ReactDOM__default["default"].unmountComponentAtNode((_f = helperRef.current) === null || _f === void 0 ? void 0 : _f.parentNode.parentNode.parentNode.parentNode);
        }
    }, [
        applicationApproved,
        applicationForceGI,
        assessmentLoadingValue,
        computed,
        computedRisk,
        coverage.forcedMax,
        coverage.maxValue,
        coverage.value,
        hasUsedVoice,
        isCallCenter,
        products,
        rasPayload,
        selectedTerm,
        termsAndRisksProducts.data,
        user.data,
    ]);
    var toggleSider = React.useCallback(function () {
        dispatch(toggleSiderAction());
    }, [dispatch]);
    var getStartedQuestionnaire = React.useCallback(function (event) {
        dispatch(setTheQuestionnaireStarted(true));
    }, [dispatch]);
    var handleSaveAndClose = function () {
        unmount({ unmountApplicationApproved: false });
    };
    reactBeforeunload.useBeforeunload(function (event) {
        // Cancel the event as stated by the standard.
        event.preventDefault();
        // Chrome requires returnValue to be set.
        event.returnValue = "";
    });
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        !theApplicantAgeIsTooLow &&
            !initFinalAssessment &&
            isCallCenter !== 1 &&
            theQuestionnaireStarted ? (React__default["default"].createElement(DrawerQuote$1, null)) : null,
        React__default["default"].createElement("div", { className: classes$v.container, ref: helperRef },
            React__default["default"].createElement("div", null,
                React__default["default"].createElement(icons.MenuUnfoldOutlined, { className: classNames__default["default"](classes$v.menuIcon, (_b = {},
                        _b[classes$v.callCenterTopPosition] = isCallCenter === 1,
                        _b[classes$v.blackMenuIcon] = !app.fieldApplication.honeycombBackground,
                        _b[classes$v.rippleEffect] = isCallCenter !== 1 &&
                            finalQuestionId &&
                            isLastQuestion,
                        _b)), onClick: toggleSider }),
                React__default["default"].createElement("span", { className: classNames__default["default"](classes$v.closeIcon, (_c = {},
                        _c[classes$v.callCenterTopPosition] = isCallCenter === 1,
                        _c)), onClick: handleSaveAndClose }, t("Save & Close"))),
            (theApplicantAgeIsTooLow === null || theApplicantAgeIsTooLow === void 0 ? void 0 : theApplicantAgeIsTooLow.messages) ? (React__default["default"].createElement(TheApplicantAgeIsTooLowMessages$1, { messages: theApplicantAgeIsTooLow.messages, unmount: unmount })) : (React__default["default"].createElement(React__default["default"].Fragment, null,
                isCallCenter !== 1 ? (React__default["default"].createElement(React__default["default"].Fragment, null,
                    app.fieldApplication.honeycombBackground && (React__default["default"].createElement("video", { autoPlay: true, muted: true, loop: true, id: "reflexiveVideo", className: classes$v.video },
                        React__default["default"].createElement("source", { src: "https://media.isi.ca/iapplication/reflexive_video_2.mp4", type: "video/mp4" }))),
                    React__default["default"].createElement(FieldVersionTopSection$1, null))) : (React__default["default"].createElement(React__default["default"].Fragment, null,
                    React__default["default"].createElement(Slider$1, null),
                    React__default["default"].createElement(RisksAndTermsSection$1, null))),
                initFinalAssessment && isCallCenter !== 1 ? (React__default["default"].createElement(FinalAssessment$1, { unmount: unmount })) : !theQuestionnaireStarted && isCallCenter !== 1 ? (React__default["default"].createElement(QuestionnaireIntroMessage, { getStartedQuestionnaire: getStartedQuestionnaire })) : (React__default["default"].createElement(CurrentQuestion$1, { unmount: unmount }))))),
        !theApplicantAgeIsTooLow && isCallCenter !== 1 && (React__default["default"].createElement(FieldVersionBottomSection$1, null))));
};
var RightSide$1 = React.memo(RightSide);

var css_248z$j = ".styles-module_button__kSacP {\n  background: #ffffff !important;\n  color: #42a8dc !important;\n  font-weight: bold !important;\n  border: none !important;\n}";
var classes$i = {"button":"styles-module_button__kSacP"};
styleInject(css_248z$j);

var PrimaryButton = function (_a) {
    var label = _a.label;
    return (React__default["default"].createElement(antd.Button, { type: "primary", className: classes$i.button }, label));
};
React.memo(PrimaryButton);

var css_248z$i = ".styles-module_button__bC1dQ {\n  background-color: #42a8dc;\n  color: #ffffff !important;\n  font-weight: bold !important;\n  border: none !important;\n}\n.styles-module_button__bC1dQ.styles-module_greyBackground__H4HR2 {\n  background-color: #848484;\n}";
var classes$h = {"button":"styles-module_button__bC1dQ","greyBackground":"styles-module_greyBackground__H4HR2"};
styleInject(css_248z$i);

var SecondaryButton = function (_a) {
    var _b;
    var label = _a.label, _c = _a.greyBackground, greyBackground = _c === void 0 ? false : _c, onClick = _a.onClick, type = _a.type, disabled = _a.disabled;
    return (React__default["default"].createElement(antd.Button, { type: "primary", htmlType: type, onClick: onClick, className: classNames__default["default"](classes$h.button, (_b = {},
            _b[classes$h.greyBackground] = greyBackground && !disabled,
            _b)), disabled: disabled }, label));
};
var SecondaryButton$1 = React.memo(SecondaryButton);

var css_248z$h = ".styles-module_container__W69Vh::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.styles-module_container__W69Vh {\n  flex-grow: 1;\n  min-height: 0;\n}\n.styles-module_container__W69Vh .styles-module_title__wBIf8 {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1.ant-list {\n  padding-bottom: 16px;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1 ul .ant-list-item {\n  padding: 0px;\n  margin-top: 5px;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1 li {\n  overflow: hidden;\n  border-bottom: none !important;\n  cursor: pointer;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1 li .ant-list-item-meta {\n  align-items: flex-start;\n  max-width: 100%;\n  overflow: hidden;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1 li .ant-list-item-meta-avatar {\n  margin-right: 0;\n  line-height: 16px;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1 li .ant-list-item-meta-content {\n  width: auto;\n  flex-grow: 1;\n  flex-shrink: 1;\n  max-width: 100%;\n  min-width: 0;\n  margin-left: 5px;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1 li .ant-list-item-meta-title {\n  color: #ffff !important;\n  font-size: 11px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  margin: 0;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1 li .ant-avatar.ant-avatar-icon > .anticon {\n  margin: 0px;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1 .ant-avatar {\n  background: #ffff;\n  font-size: 12px;\n  line-height: 11px;\n  color: #85de0d;\n  width: auto;\n  height: auto;\n}\n.styles-module_container__W69Vh .styles-module_list__RT7-1 .styles-module_currentItem__1U3Nt {\n  text-decoration: underline;\n  color: #ffffff;\n}\n\n.styles-module_loading__oXbTV {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1;\n  font-size: 35px;\n}";
var classes$g = {"container":"styles-module_container__W69Vh","title":"styles-module_title__wBIf8","list":"styles-module_list__RT7-1","currentItem":"styles-module_currentItem__1U3Nt","loading":"styles-module_loading__oXbTV"};
styleInject(css_248z$h);

var css_248z$g = ".styles-module_field__KVQxH {\n  display: flex;\n  display: flex;\n}";
var classes$f = {"field":"styles-module_field__KVQxH"};
styleInject(css_248z$g);

var Search = antd.Input.Search;
var SearchField = function () {
    var dispatch = reactRedux.useDispatch();
    var t = reactI18next.useTranslation().t;
    var handleSearchInput = React.useCallback(function (value) {
        // TODO: add a debounce here
        dispatch(setQuery(value.target.value));
    }, [dispatch]);
    return (React__default["default"].createElement(Search, { className: classes$f.field, placeholder: t("input search text"), onChange: handleSearchInput }));
};
var SearchField$1 = React.memo(SearchField);

var stateSelectorHandle$e = reselect.createSelector(function (state) { return state.questions.formattedQuestions; }, function (state) { return state.question; }, function (state) { return state.questions.computed; }, function (state) { return state.questions.query; }, function (state) { return state.questions.loading; }, function (formattedQuestions, currentQuestion, computedQuestions, query, questionsLoading) {
    return {
        formattedQuestions: formattedQuestions,
        currentQuestion: currentQuestion,
        computedQuestions: computedQuestions,
        query: query,
        questionsLoading: questionsLoading,
    };
});
var QuestionsList = function (_a) {
    _a.label;
    var t = reactI18next.useTranslation().t;
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$e, []);
    var _b = reactRedux.useSelector(stateSelector), formattedQuestions = _b.formattedQuestions, currentQuestion = _b.currentQuestion, computedQuestions = _b.computedQuestions, query = _b.query, questionsLoading = _b.questionsLoading;
    var handleSelectedQuestion = React.useCallback(function (questionIndex) { return function () {
        var index = computedQuestions.findIndex(function (item) {
            return item.index === questionIndex;
        });
        if (index !== -1) {
            dispatch(setQuestion(computedQuestions[index]));
        }
    }; }, [computedQuestions, dispatch]);
    //@ts-ignore
    var answeredQuestions = React.useMemo(function () {
        if (!formattedQuestions || formattedQuestions.length === 0) {
            return undefined;
        }
        var result = [];
        var entries = Object.entries(formattedQuestions);
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var element = entries_1[_i];
            var questionIndex = element[0], questionData = element[1];
            var answer = void 0;
            if (typeof questionData.answer === "object" &&
                !Array.isArray(questionData.answer)) {
                // if the answer has IAnswerMultiSelectQuestion structure.
                // I've added the @ts-ignore because the formattedQuestions, which is an array, has key-property values
                // and typescript's inferences, although being correct, doesn't get along with Object.entries.
                // the formattedQuestions should be an object instead.
                // @ts-ignore
                answer = Object.values(questionData.answer)
                    .filter(
                //@ts-ignore
                function (item) { return item.isSelected; })
                    // @ts-ignore
                    .map(function (item) { return item.optionTxt; })
                    .join("; ");
            }
            else if (Array.isArray(questionData.answer)) {
                answer = questionData.answer.join(", ");
            }
            else {
                answer = questionData.answer;
            }
            result.push({
                index: questionIndex,
                question: questionData.question,
                answer: answer,
            });
        }
        return result;
    }, [formattedQuestions]);
    return questionsLoading ? (React__default["default"].createElement("div", { className: classes$g.loading },
        React__default["default"].createElement(icons.RedoOutlined, { spin: true }))) : (React__default["default"].createElement(React__default["default"].Fragment, null,
        answeredQuestions && answeredQuestions.length > 0 && (React__default["default"].createElement(SearchField$1, null)),
        React__default["default"].createElement("div", { className: classes$g.container },
            !answeredQuestions && (React__default["default"].createElement("div", { className: classes$g.title }, "Questions")),
            React__default["default"].createElement(antd.List, { className: classes$g.list, itemLayout: "horizontal", locale: { emptyText: t("No Data") }, dataSource: answeredQuestions &&
                    answeredQuestions.filter(function (item) {
                        return (query.length === 0 ||
                            item.question
                                .toLowerCase()
                                .indexOf(query.toLowerCase()) !== -1);
                    }), renderItem: function (item) {
                    var _a;
                    return (React__default["default"].createElement(antd.List.Item, { className: classNames__default["default"]((_a = {},
                            _a[classes$g.currentItem] = item.index ===
                                currentQuestion.current.index,
                            _a)), onClick: handleSelectedQuestion(item.index) },
                        React__default["default"].createElement(antd.List.Item.Meta, { avatar: React__default["default"].createElement(antd.Avatar, { icon: React__default["default"].createElement(icons.CheckCircleFilled, null), style: { marginRight: 0 } }), title: item.index + ". " + item.question + ": " + item.answer })));
                } }))));
};
var QuestionsList$1 = React.memo(QuestionsList);

var css_248z$f = ".styles-module_container__zlWW6 {\n  z-index: 1;\n}\n.styles-module_container__zlWW6 .styles-module_error__BHBde {\n  border: 1px solid rgba(255, 0, 0, 0.3);\n  background-color: rgba(255, 0, 0, 0.025);\n}\n.styles-module_container__zlWW6 .styles-module_form__DrdK3 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.styles-module_container__zlWW6 .styles-module_radioGroup__67eZP {\n  text-align: center;\n}\n.styles-module_container__zlWW6 .styles-module_radioGroup__67eZP .ant-radio-checked .ant-radio-inner {\n  border-color: #000000;\n}\n.styles-module_container__zlWW6 .styles-module_radioGroup__67eZP .ant-radio-inner::after {\n  background-color: #000000;\n}\n.styles-module_container__zlWW6 .styles-module_radioGroup__67eZP .ant-radio :hover {\n  border-color: #000000;\n}\n.styles-module_container__zlWW6 .styles-module_datepicker__zgfNw {\n  width: 100%;\n  max-width: 250px;\n  margin: 0 auto;\n  display: flex;\n}\n.styles-module_container__zlWW6 .styles-module_buttons__-B8f- {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 40px;\n}\n.styles-module_container__zlWW6 .styles-module_buttons__-B8f- > :first-child {\n  margin-right: 8px;\n}\n.styles-module_container__zlWW6 .styles-module_buttons__-B8f- > :nth-child(2) {\n  margin-left: 8px;\n}\n.styles-module_container__zlWW6 .styles-module_residentialInfo__Fo0Sk {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.styles-module_container__zlWW6 .styles-module_residentialInfo__Fo0Sk > input:first-child {\n  flex-grow: 1;\n  margin-bottom: 4px;\n}\n.styles-module_container__zlWW6 .styles-module_residentialInfo__Fo0Sk > input:not(:first-child) {\n  flex: 1;\n}\n.styles-module_container__zlWW6 .styles-module_residentialInfo__Fo0Sk > input:nth-child(3),\n.styles-module_container__zlWW6 .styles-module_residentialInfo__Fo0Sk > input:nth-child(4) {\n  margin-left: 4px;\n}\n.styles-module_container__zlWW6 input {\n  display: flex;\n  justify-content: center;\n}\n.styles-module_container__zlWW6 .styles-module_twoInputsOnLine__kXsKF {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.styles-module_container__zlWW6 .styles-module_twoInputsOnLine__kXsKF > div:first-child {\n  padding-right: 10px;\n}\n.styles-module_container__zlWW6 .styles-module_twoInputsOnLine__kXsKF > div:nth-child(2) {\n  padding-left: 10px;\n}\n.styles-module_container__zlWW6 .ant-form-item {\n  margin-bottom: 0px;\n  width: 100%;\n}\n\n.styles-module_loader__W-eX- {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n}";
var classes$e = {"container":"styles-module_container__zlWW6","error":"styles-module_error__BHBde","form":"styles-module_form__DrdK3","radioGroup":"styles-module_radioGroup__67eZP","datepicker":"styles-module_datepicker__zgfNw","buttons":"styles-module_buttons__-B8f-","residentialInfo":"styles-module_residentialInfo__Fo0Sk","twoInputsOnLine":"styles-module_twoInputsOnLine__kXsKF","loader":"styles-module_loader__W-eX-"};
styleInject(css_248z$f);

var stateSelectorHandle$d = reselect.createSelector(function (state) { return state.app.canTheAssessmentBeStopped; }, function (state) { return state.questions; }, function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter; }, function (canTheAssessmentBeStopped, questions, isCallCenter) {
    return {
        canTheAssessmentBeStopped: canTheAssessmentBeStopped,
        questions: questions,
        isCallCenter: isCallCenter,
    };
});
var Option$1 = antd.Select.Option;
var Question = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var unmount = _a.unmount, question = _a.currentQuestion, _j = _a.isAGroupedQuestion, isAGroupedQuestion = _j === void 0 ? false : _j;
    var inchesInputRef = React.useRef(null);
    var feetInputRef = React.useRef(null);
    var t = reactI18next.useTranslation().t;
    var dispatch = reactRedux.useDispatch();
    var _k = React.useState(), assessmentFactors = _k[0], setAssessmentFactors = _k[1];
    var _l = React.useState([]), selectedAssessmentFactorsValues = _l[0], setSelectedAssessmentFactorsValues = _l[1];
    var form = antd.Form.useForm()[0];
    var _m = React.useState([]), errors = _m[0], setErrors = _m[1];
    var _o = React.useState(false), theAnswerWasUpdated = _o[0], setTheAnswerWasUpdated = _o[1];
    var _p = React.useState(false), showProceedToTheApplicationBtn = _p[0], setShowProceedToTheApplicationBtn = _p[1];
    var stateSelector = React.useCallback(stateSelectorHandle$d, []);
    var _q = reactRedux.useSelector(stateSelector), _r = _q.questions, computed = _r.computed, questionsLoading = _r.loading, canTheAssessmentBeStopped = _q.canTheAssessmentBeStopped; _q.isCallCenter;
    var pause = useGetMp3QuestionTitle().pause;
    var isLastQuestion = (question && ((_b = computed[computed.length - 1]) === null || _b === void 0 ? void 0 : _b.id) === question.id) ||
        false;
    var handleNextQuestion = React.useCallback(function (values) {
        pause();
        switch (question.type) {
            case "singleselection": {
                dispatch(answerQuestion({
                    answer: question.options.find(function (item) { return item.id === values.answer; }),
                    question: isAGroupedQuestion ? question : undefined,
                    isGroupedQuestion: isAGroupedQuestion,
                }));
                break;
            }
            case "date":
                dispatch(answerQuestion({
                    answer: values.date.format("yyyy-MM-DD"),
                }));
                break;
            case "struct":
                dispatch(answerQuestion({
                    answer: {
                        elements: values,
                    },
                }));
                break;
            case "number":
            case "text": {
                if (question.id === heightAndWeightQuestionsIds.HeightUS ||
                    question.id ===
                        heightAndWeightQuestionsIds.JuvenilesHeightUS) {
                    var _a = values || {}, feet = _a.feet, inches = _a.inches;
                    var feetToInches = parseInt(feet) * 12;
                    var validInches = !inches
                        ? 0
                        : parseInt(inches);
                    var totalInches = feetToInches + validInches;
                    dispatch(answerQuestion({
                        answer: totalInches,
                        question: isAGroupedQuestion
                            ? question
                            : undefined,
                        isGroupedQuestion: isAGroupedQuestion,
                    }));
                }
                else if (question.id === "InsuredPerson.PlaceOfBirth") {
                    var _b = values || {}, country = _b.country, region = _b.region;
                    var answer = region ? region + ", " + country : country;
                    dispatch(answerQuestion({ answer: answer }));
                }
                else {
                    dispatch(answerQuestion({
                        answer: values.answer,
                        question: isAGroupedQuestion
                            ? question
                            : undefined,
                        isGroupedQuestion: isAGroupedQuestion,
                    }));
                }
                break;
            }
            case "multiselection": {
                // parse selected values in order to fit on backend
                var parsedValues = values.answer.map(function (item) {
                    return {
                        id: item.value,
                        label: item.label,
                    };
                });
                dispatch(answerQuestion({ answer: parsedValues }));
                break;
            }
            case "assessment-factor-search":
                dispatch(answerQuestion({
                    answer: selectedAssessmentFactorsValues,
                }));
                break;
        }
        setTheAnswerWasUpdated(false);
        setAssessmentFactors([]);
        setSelectedAssessmentFactorsValues([]);
        form.resetFields();
    }, [
        pause,
        question,
        form,
        dispatch,
        selectedAssessmentFactorsValues,
        isAGroupedQuestion,
    ]);
    var onFinishFailed = React.useCallback(function (_a) {
        _a.values; var errorFields = _a.errorFields; _a.outOfDate;
        setErrors(errorFields);
    }, []);
    var populateFields = React.useCallback(function () {
        var _a, _b, _c;
        if (!question)
            return undefined;
        switch (question.type) {
            case "singleselection":
                form.setFieldsValue({
                    answer: ((_a = question === null || question === void 0 ? void 0 : question.answer) === null || _a === void 0 ? void 0 : _a.id) || null,
                });
                break;
            case "date":
                form.setFieldsValue({
                    date: question.answer ? moment__default["default"](question.answer) : moment__default["default"](),
                });
                break;
            case "number":
            case "text":
                if (question.id === heightAndWeightQuestionsIds.HeightUS ||
                    question.id ===
                        heightAndWeightQuestionsIds.JuvenilesHeightUS) {
                    var feet = typeof question.answer === "undefined"
                        ? ""
                        : Math.trunc(question.answer / 12);
                    var inches = typeof question.answer === "undefined"
                        ? ""
                        : question.answer % 12 === 0
                            ? 0
                            : question.answer % 12;
                    form.setFieldsValue({
                        feet: feet,
                        inches: inches,
                    });
                }
                else if (question.id === "InsuredPerson.PlaceOfBirth") {
                    var answerObj = { country: null, region: null };
                    if (question.answer) {
                        var region = question.answer.indexOf(",") !== -1
                            ? question.answer.split(",")[0].trim()
                            : null;
                        var country = question.answer.indexOf(",") !== -1
                            ? question.answer.split(",")[1].trim()
                            : question.answer
                                ? question.answer
                                : null;
                        answerObj = region
                            ? { country: country, region: region }
                            : { country: country, region: null };
                    }
                    form.setFieldsValue(answerObj);
                }
                else {
                    form.setFieldsValue({
                        answer: question.answer !== "" ? question.answer : null,
                    });
                }
                break;
            case "assessment-factor-search":
                var parsedValues = (_b = question === null || question === void 0 ? void 0 : question.answer) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                    return __assign(__assign({}, item), { value: item.id });
                });
                form.setFieldsValue({
                    answer: (question === null || question === void 0 ? void 0 : question.answer) ? parsedValues : [],
                });
                setSelectedAssessmentFactorsValues((question === null || question === void 0 ? void 0 : question.answer) ? parsedValues : []);
                break;
            case "multiselection": {
                var parsedValues_1 = (_c = question === null || question === void 0 ? void 0 : question.answer) === null || _c === void 0 ? void 0 : _c.map(function (item) {
                    return __assign(__assign({}, item), { value: item.id });
                });
                form.setFieldsValue({
                    answer: (question === null || question === void 0 ? void 0 : question.answer) ? parsedValues_1 : [],
                });
                setSelectedAssessmentFactorsValues((question === null || question === void 0 ? void 0 : question.answer) ? parsedValues_1 : []);
                break;
            }
            default:
                form.setFieldsValue({
                    answer: null,
                });
                break;
        }
    }, [question, form]);
    var handleAssessmentFactorSearch = React.useCallback(function (q) { return __awaiter(void 0, void 0, void 0, function () {
        var endpoint, endpointParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(question.type === "assessment-factor-search")) return [3 /*break*/, 3];
                    endpoint = question.links[0].href;
                    endpointParams = {
                        questionId: question.links[0].params.questionId,
                        language: question.links[0].params.language,
                        q: q,
                    };
                    if (!!q) return [3 /*break*/, 1];
                    setAssessmentFactors([]);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, api.questions
                        .fetchAssessmentFactorSearch(endpoint, endpointParams)
                        .then(function (data) {
                        setAssessmentFactors(data);
                    })
                        .catch(function (err) {
                        setAssessmentFactors([]);
                        console.error(err);
                    })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [question]);
    var handleAssessmentFactorChange = React.useCallback(function (value, option) {
        var answerParsed = option
            .filter(function (item) { return item.key; })
            .map(function (item) {
            return {
                id: item.id,
                label: item.children,
                category: item.category,
            };
        });
        setSelectedAssessmentFactorsValues(function (selectedAssessmentFactorsValues) { return __spreadArrays(selectedAssessmentFactorsValues.concat(answerParsed)); });
    }, []);
    var handleAssessmentFactorDeselect = React.useCallback(function (value) {
        setSelectedAssessmentFactorsValues(function (data) { return __spreadArrays(data).filter(function (d) {
            return (d === null || d === void 0 ? void 0 : d.value) !== (value === null || value === void 0 ? void 0 : value.value);
        }); });
    }, [setSelectedAssessmentFactorsValues]);
    var onValuesChanged = React.useCallback(function (changedValues, allValues) {
        setShowProceedToTheApplicationBtn(false);
        setTheAnswerWasUpdated(true);
    }, []);
    var questionInvalidMsg = React.useMemo(function () {
        if (question.answerState !== "invalid" &&
            (!(question === null || question === void 0 ? void 0 : question.messages) || (question === null || question === void 0 ? void 0 : question.messages.length) === 0)) {
            return null;
        }
        else {
            var result = question.messages.find(function (item) {
                return item.type === "error";
            });
            return result.message;
        }
    }, [question]);
    var handleFeetAndInchesAnswer = function (event) {
        var _a;
        if (event) {
            var inchesVal = (_a = inchesInputRef.current) === null || _a === void 0 ? void 0 : _a.input.value;
            var feetVal = feetInputRef.current.input.value;
            if (inchesVal !== "" && feetVal !== "") {
                form.submit();
            }
        }
    };
    React.useEffect(function () {
        if (!questionsLoading) {
            populateFields();
        }
    }, [populateFields, questionsLoading]);
    React.useEffect(function () {
        if ((question === null || question === void 0 ? void 0 : question.id) === "InsuredPerson.HeightUnits" &&
            !canTheAssessmentBeStopped) {
            dispatch(setCanTheAssessmentBeStopped(true));
        }
    }, [canTheAssessmentBeStopped, dispatch, question]);
    React.useEffect(function () {
        return function () {
            setAssessmentFactors([]);
            setSelectedAssessmentFactorsValues([]);
            form.resetFields();
        };
    }, [form]);
    React.useEffect(function () {
        if (isLastQuestion &&
            question.answerState !== "missing" &&
            showProceedToTheApplicationBtn === false &&
            theAnswerWasUpdated === false) {
            setShowProceedToTheApplicationBtn(true);
        }
    }, [
        isLastQuestion,
        question.answerState,
        showProceedToTheApplicationBtn,
        theAnswerWasUpdated,
    ]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement("div", { className: classes$e.container },
        React__default["default"].createElement(antd.Form, { form: form, name: "question_" + question.id, onFinish: handleNextQuestion, onFinishFailed: onFinishFailed, onValuesChange: onValuesChanged, className: classes$e.form },
            (question === null || question === void 0 ? void 0 : question.type) === "singleselection" && (React__default["default"].createElement("div", { className: classes$e.radioGroup },
                React__default["default"].createElement(antd.Form.Item, { name: "answer", rules: [
                        {
                            required: question === null || question === void 0 ? void 0 : question.constraints.required,
                            message: t("Required"),
                        },
                    ] },
                    React__default["default"].createElement(antd.Radio.Group, { size: "large", onChange: isAGroupedQuestion
                            ? function () { return form.submit(); }
                            : function () { return null; } }, question === null || question === void 0 ? void 0 : question.options.map(function (item, index) { return (React__default["default"].createElement(antd.Radio, { key: "radio_" + index, value: item.id, style: { fontSize: 18 } }, item.label)); }))))),
            (question === null || question === void 0 ? void 0 : question.type) === "date" && (React__default["default"].createElement(antd.Form.Item, { name: "date", rules: [
                    {
                        required: question === null || question === void 0 ? void 0 : question.constraints.required,
                        message: t("Required"),
                    },
                ] },
                React__default["default"].createElement(antd.DatePicker
                // disabled={questionAnswered}
                , { 
                    // disabled={questionAnswered}
                    className: classes$e.datepicker }))),
            question.type === "struct" &&
                question.id ===
                    "InsuredPerson.ResidentialAddress" && (React__default["default"].createElement("div", { className: classes$e.residentialInfo }, (_c = question === null || question === void 0 ? void 0 : question.elements) === null || _c === void 0 ? void 0 : _c.map(function (item) { return (React__default["default"].createElement(antd.Form.Item, { key: item.id, name: item.id, rules: [
                    {
                        required: item.constraints
                            .required,
                        message: t("Required"),
                    },
                ], noStyle: true },
                React__default["default"].createElement(antd.Input
                // disabled={questionAnswered}
                , { 
                    // disabled={questionAnswered}
                    key: item.id, placeholder: item.caption, className: errors
                        ? errors.reduce(function (acc, cur) {
                            if (cur.name.indexOf(item.id) !== -1)
                                acc +=
                                    classes$e.error;
                            return acc;
                        }, "")
                        : "" }))); }))),
            question.type === "number" &&
                (question.id ===
                    heightAndWeightQuestionsIds.HeightUS ||
                    question.id ===
                        heightAndWeightQuestionsIds.JuvenilesHeightUS ? (React__default["default"].createElement("div", { className: classes$e.twoInputsOnLine },
                    React__default["default"].createElement(antd.Form.Item, { name: "feet", className: classes$e.input, rules: [
                            function () { return ({
                                validator: function (_, value) {
                                    var _a, _b, _c, _d, _e, _f;
                                    // the constraints are coming in inch, so I will transform inches into feet
                                    var minValue = ((_a = question.constraints) === null || _a === void 0 ? void 0 : _a.minValue) / 12;
                                    var maxValue = ((_b = question.constraints) === null || _b === void 0 ? void 0 : _b.maxValue) / 12;
                                    var step = (_c = question.constraints) === null || _c === void 0 ? void 0 : _c.step;
                                    if ((value === "" ||
                                        value === 0) && ((_d = question.constraints) === null || _d === void 0 ? void 0 : _d.required)) {
                                        return Promise.reject(t("Required"));
                                    }
                                    else if (isNaN(value)) {
                                        return Promise.reject(t("Please, add a number"));
                                    }
                                    else if (!isNaN(maxValue) &&
                                        value > maxValue) {
                                        return Promise.reject((_e = question.constraints) === null || _e === void 0 ? void 0 : _e.maxValueViolationMessage);
                                    }
                                    else if (!isNaN(minValue) &&
                                        value < minValue) {
                                        return Promise.reject((_f = question.constraints) === null || _f === void 0 ? void 0 : _f.minValueViolationMessage);
                                    }
                                    else if (step &&
                                        parseInt(step) === 1 &&
                                        value % 1 !== 0) {
                                        return Promise.reject(t("Decimals are not allowed."));
                                    }
                                    else if (value < 0) {
                                        return Promise.reject(t("Negative values are not allowed."));
                                    }
                                    else {
                                        return Promise.resolve();
                                    }
                                },
                            }); },
                        ] },
                        React__default["default"].createElement(antd.Input, { ref: feetInputRef, type: "number", step: (_d = question.constraints) === null || _d === void 0 ? void 0 : _d.step, addonAfter: t("ft"), placeholder: t("type here"), onBlur: handleFeetAndInchesAnswer })),
                    React__default["default"].createElement(antd.Form.Item, { name: "inches", className: classes$e.input, rules: [
                            function () { return ({
                                validator: function (_, value) {
                                    var _a;
                                    // an foot = 12 inches
                                    var minValue = 0; //question.constraints?.minValue;
                                    var maxValue = 11; //question.constraints?.maxValue;
                                    if (!isNaN(maxValue) &&
                                        value > maxValue) {
                                        return Promise.reject((_a = question.constraints) === null || _a === void 0 ? void 0 : _a.maxValueViolationMessage);
                                    }
                                    else if (!isNaN(minValue) &&
                                        value < minValue) {
                                        return Promise.reject(t("Negative values are not allowed."));
                                    }
                                    else {
                                        return Promise.resolve();
                                    }
                                },
                            }); },
                        ] },
                        React__default["default"].createElement(antd.Input, { ref: inchesInputRef, type: "number", step: 1, addonAfter: t("ins"), placeholder: t("type here"), onBlur: handleFeetAndInchesAnswer })))) : (React__default["default"].createElement(antd.Form.Item, { name: "answer", className: classes$e.input, rules: [
                        function () { return ({
                            validator: function (_, value) {
                                var _a, _b, _c, _d, _e, _f;
                                var minValue = (_a = question.constraints) === null || _a === void 0 ? void 0 : _a.minValue;
                                var maxValue = (_b = question.constraints) === null || _b === void 0 ? void 0 : _b.maxValue;
                                var step = (_c = question.constraints) === null || _c === void 0 ? void 0 : _c.step;
                                if (value === "" && ((_d = question.constraints) === null || _d === void 0 ? void 0 : _d.required)) {
                                    return Promise.reject(t("Required"));
                                }
                                else if (isNaN(value)) {
                                    return Promise.reject(t("Please, add a number"));
                                }
                                else if (!isNaN(maxValue) &&
                                    value > maxValue) {
                                    return Promise.reject((_e = question.constraints) === null || _e === void 0 ? void 0 : _e.maxValueViolationMessage);
                                }
                                else if (!isNaN(minValue) &&
                                    value < minValue) {
                                    return Promise.reject((_f = question.constraints) === null || _f === void 0 ? void 0 : _f.minValueViolationMessage);
                                }
                                else if (step &&
                                    parseInt(step) === 1 &&
                                    value % 1 !== 0) {
                                    return Promise.reject(t("Decimals are not allowed."));
                                }
                                else if (value < 0) {
                                    return Promise.reject(t("Negative values are not allowed."));
                                }
                                else {
                                    return Promise.resolve();
                                }
                            },
                        }); },
                    ] },
                    React__default["default"].createElement(antd.InputNumber
                    // disabled={questionAnswered}
                    , { 
                        // disabled={questionAnswered}
                        step: (_e = question.constraints) === null || _e === void 0 ? void 0 : _e.step, placeholder: t("type here"), onBlur: isAGroupedQuestion
                            ? function () { return form.submit(); }
                            : function () { return null; } })))),
            question.type === "text" &&
                (question.id === "InsuredPerson.PlaceOfBirth" ? (React__default["default"].createElement(CountryRegion$1, { question: question, form: form })) : (React__default["default"].createElement(antd.Form.Item, { name: "answer", className: classes$e.input, rules: [
                        {
                            required: question.constraints.required,
                            message: t("Required"),
                        },
                    ] },
                    React__default["default"].createElement(antd.Input, { onBlur: isAGroupedQuestion
                            ? function () { return form.submit(); }
                            : function () { return null; }, placeholder: t("type here") })))),
            question.type === "multiselection" && (React__default["default"].createElement(antd.Form.Item, { name: "answer", rules: [
                    {
                        required: question.constraints.required,
                        message: t("Required"),
                    },
                ] },
                React__default["default"].createElement(antd.Select, { mode: "multiple", placeholder: t("type here and select"), labelInValue: true, dropdownMatchSelectWidth: false }, (_f = question === null || question === void 0 ? void 0 : question.options) === null || _f === void 0 ? void 0 : _f.map(function (item) {
                    return (React__default["default"].createElement(Option$1, { key: "multiselect_" + item.id, value: item.id }, item.label));
                })))),
            question.type === "assessment-factor-search" && (React__default["default"].createElement(antd.Form.Item, { name: "answer", rules: [
                    {
                        required: question.constraints.required,
                        message: t("Required"),
                    },
                ] },
                React__default["default"].createElement(antd.Select, { mode: "multiple", placeholder: question.id ===
                        "InsuredPerson.CurrentOccupation"
                        ? t("type here")
                        : t("type here and select"), onSearch: handleAssessmentFactorSearch, onChange: handleAssessmentFactorChange, onDeselect: handleAssessmentFactorDeselect, labelInValue: true, dropdownMatchSelectWidth: false }, (_h = (_g = assessmentFactors === null || assessmentFactors === void 0 ? void 0 : assessmentFactors.data) === null || _g === void 0 ? void 0 : _g.results) === null || _h === void 0 ? void 0 : _h.map(function (item) {
                    return (React__default["default"].createElement(Option$1, { key: "assessment_factor_" + item.label, category: item.category, id: item.id, value: item.label }, item.label));
                })))),
            questionInvalidMsg && (React__default["default"].createElement("div", { style: { color: "#ff4d4f" } }, questionInvalidMsg)),
            !isAGroupedQuestion && (React__default["default"].createElement(ActionsButtons$1, { unmount: unmount, showProceedToTheApplicationBtn: showProceedToTheApplicationBtn }))))));
};
var Question$1 = React.memo(Question);

var css_248z$e = ".styles-module_container__XEJln .styles-module_coverage__VQ-hR {\n  display: flex;\n  flex-direction: column;\n}\n.styles-module_container__XEJln .styles-module_coverage__VQ-hR .styles-module_inputContainer__Jc0Rg {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  position: relative;\n  top: -35px;\n}\n.styles-module_container__XEJln .styles-module_coverage__VQ-hR .styles-module_inputContainer__Jc0Rg .styles-module_input__eahbW {\n  right: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.styles-module_container__XEJln .styles-module_coverage__VQ-hR .styles-module_inputContainer__Jc0Rg .styles-module_input__eahbW .styles-module_inputNumber__NTgmw {\n  width: 140px;\n}\n.styles-module_container__XEJln .styles-module_coverage__VQ-hR .styles-module_inputContainer__Jc0Rg .styles-module_radioButton__x3sbm {\n  align-self: center;\n}\n.styles-module_container__XEJln .styles-module_coverage__VQ-hR .styles-module_inputContainer__Jc0Rg .styles-module_radioButton__x3sbm > span:first-child {\n  vertical-align: middle;\n}\n.styles-module_container__XEJln .styles-module_coverage__VQ-hR .styles-module_inputContainer__Jc0Rg .styles-module_radioButton__x3sbm > span:nth-child(2) {\n  font-weight: bold;\n  font-size: 18px;\n  vertical-align: middle;\n}\n.styles-module_container__XEJln .styles-module_coverage__VQ-hR .styles-module_slider__rknw1 {\n  margin-top: 10px;\n}\n.styles-module_container__XEJln .styles-module_coverage__VQ-hR .styles-module_slider__rknw1 .styles-module_tooltips__ix2Xe {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.styles-module_container__XEJln .styles-module_coverage__VQ-hR .styles-module_slider__rknw1 .styles-module_tooltips__ix2Xe > div {\n  padding: 0px 4px;\n  font-size: 10px;\n  border-radius: 4px;\n  background-color: #e0e3e8;\n  max-height: 16px;\n  line-height: 16px;\n  color: #9d9d9d;\n}\n.styles-module_container__XEJln .ant-slider-rail {\n  height: 16px !important;\n  border-radius: 6px;\n}\n.styles-module_container__XEJln .ant-slider {\n  height: 16px !important;\n}\n.styles-module_container__XEJln .ant-slider-mark-text-active {\n  color: rgba(0, 0, 0, 0.45) !important;\n}\n.styles-module_container__XEJln .ant-slider-with-marks {\n  padding: 0px 0px;\n}\n.styles-module_container__XEJln .ant-slider-track {\n  height: 16px;\n  background-color: #f55b6c;\n  border-radius: 6px 0px 0px 6px;\n}\n.styles-module_container__XEJln .ant-slider-dot {\n  top: 18px;\n  border-radius: unset;\n  margin-left: 0px !important;\n  border: unset;\n  border-right: 1px solid #f0f0f0;\n  width: unset;\n  cursor: pointer;\n}\n.styles-module_container__XEJln .ant-slider-dot-active {\n  border-color: #a0a0a0a1;\n}\n.styles-module_container__XEJln .ant-slider-mark-text {\n  font-size: 10px;\n  top: 10px;\n}\n.styles-module_container__XEJln .ant-slider-step {\n  height: 16px;\n}\n.styles-module_container__XEJln .ant-slider-handle {\n  margin-top: 0px;\n  width: 2px;\n  height: 24px;\n  top: -4px;\n  border-radius: 0% !important;\n  border: none !important;\n  background-color: #f55b6c;\n}\n.styles-module_container__XEJln .ant-slider:hover .ant-slider-track {\n  background-color: #f55b6c;\n}\n.styles-module_container__XEJln .ant-slider-mark > :first-child {\n  left: 0 !important;\n  transform: none !important;\n}\n.styles-module_container__XEJln .ant-slider-mark > :last-child {\n  transform: translateX(-100%) !important;\n  white-space: nowrap;\n}\n\n.ant-tooltip-inner {\n  background-color: #f55b6c !important;\n  padding: 0px 5px !important;\n  border-radius: 5px !important;\n  min-height: 16px !important;\n  font-size: 10px;\n}\n\n.ant-tooltip-arrow-content {\n  background-color: #f55b6c !important;\n}\n\n.ant-tooltip-content {\n  pointer-events: none;\n}\n\n.ant-slider-tooltip {\n  pointer-events: all;\n  cursor: pointer;\n}";
var classes$d = {"container":"styles-module_container__XEJln","coverage":"styles-module_coverage__VQ-hR","inputContainer":"styles-module_inputContainer__Jc0Rg","input":"styles-module_input__eahbW","inputNumber":"styles-module_inputNumber__NTgmw","radioButton":"styles-module_radioButton__x3sbm","slider":"styles-module_slider__rknw1","tooltips":"styles-module_tooltips__ix2Xe"};
styleInject(css_248z$e);

var stateSelectorHandle$c = reselect.createSelector(function (state) { return state.termsAndRisks.coverage; }, function (state) { return state.user; }, function (state) { return state.app.useJuvenileProduct; }, function (coverage, user, useJuvenileProduct) {
    return {
        coverage: coverage,
        user: user,
        useJuvenileProduct: useJuvenileProduct,
    };
});
var SliderView$1 = function () {
    var _a, _b, _c;
    var t = reactI18next.useTranslation().t;
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$c, []);
    var _d = reactRedux.useSelector(stateSelector), coverage = _d.coverage, user = _d.user, useJuvenileProduct = _d.useJuvenileProduct;
    var _e = React.useState(coverage.value), coverageLocal = _e[0], setCoverageLocal = _e[1];
    var questionnaireEvaluation = useQuestionnaireEvaluation().questionnaireEvaluation;
    var isQuestionnaireAccepted = questionnaireEvaluation.status;
    var sliderStep = useJuvenileProduct
        ? sliderJuvenileApplicantIncrementStep
        : sliderAdultApplicantIncrementStep;
    var coverageMinValue = coverage.minValue;
    var coverageMaxValue = coverage.forcedMax && coverage.forcedMax < coverage.maxValue
        ? coverage.forcedMax
        : coverage.maxValue;
    var marks = React.useMemo(function () {
        var _a, _b;
        var _c;
        var noOfMarks = 5;
        var sliderMarksStep = coverageMaxValue / noOfMarks;
        var result = {};
        for (var i = 0; i <= noOfMarks; i++) {
            var numberObjectKey = void 0;
            if (i === 0) {
                numberObjectKey = sliderStep;
            }
            else {
                numberObjectKey = sliderMarksStep * i;
            }
            if (i < noOfMarks && numberObjectKey % sliderStep !== 0)
                continue;
            ((_c = user.data) === null || _c === void 0 ? void 0 : _c.language) === "en"
                ? Object.assign(result, (_a = {},
                    _a[numberObjectKey] = "$ " + numberWithCommas(numberObjectKey),
                    _a))
                : Object.assign(result, (_b = {},
                    _b[numberObjectKey] = numberWithCommas(numberObjectKey) + " $",
                    _b));
        }
        return result;
    }, [coverageMaxValue, sliderStep, (_a = user.data) === null || _a === void 0 ? void 0 : _a.language]);
    var tooltipFormatter = React.useCallback(function (value) {
        var _a;
        if (value) {
            return ((_a = user.data) === null || _a === void 0 ? void 0 : _a.language) === "en" ? (React__default["default"].createElement("div", { className: classes$d.tooltipFormatter }, "$ " + numberWithCommas(value))) : (React__default["default"].createElement("div", { className: classes$d.tooltipFormatter }, numberWithCommas(value) + " $"));
        }
    }, [user]);
    var roundUpCoverage = React.useCallback(function (element) {
        if (user.data) {
            var value = parseInt(element.currentTarget.value);
            var returnedValue = 0;
            if (value < coverageMinValue) {
                returnedValue = coverageMinValue;
            }
            else if (value > coverageMaxValue) {
                returnedValue = coverageMaxValue;
            }
            else if (coverageMinValue <= value &&
                value <= coverageMaxValue) {
                returnedValue = Math.round(value / sliderStep) * sliderStep;
            }
            else {
                returnedValue = coverageMinValue;
            }
            setCoverageLocal(returnedValue);
            dispatch(setCoverage({
                currentStatusInCanada: user.data.currentStatusInCanada,
                bankruptcyStatus: user.data.bankruptcyStatus,
                value: returnedValue,
            }));
        }
    }, [user.data, coverageMinValue, coverageMaxValue, dispatch, sliderStep]);
    var onChangeLocal = React.useCallback(function (value) {
        if (value < coverageMinValue ||
            value > coverageMaxValue ||
            isNaN(value)) {
            return;
        }
        setCoverageLocal(value);
    }, [coverageMaxValue, coverageMinValue]);
    var onChange = React.useCallback(function () {
        if (user.data) {
            dispatch(setCoverage({
                currentStatusInCanada: user.data.currentStatusInCanada,
                bankruptcyStatus: user.data.bankruptcyStatus,
                value: coverageLocal,
            }));
        }
    }, [coverageLocal, user.data, dispatch]);
    React.useEffect(function () {
        if (coverageLocal !== coverage.value) {
            setCoverageLocal(coverage.value);
        }
        // eslint-disable-next-line
    }, [coverage]);
    return (React__default["default"].createElement("div", { className: classes$d.container },
        React__default["default"].createElement(antd.Row, null,
            React__default["default"].createElement(antd.Col, { span: 24 },
                React__default["default"].createElement("div", { className: classes$d.coverage },
                    React__default["default"].createElement("div", { className: classes$d.inputContainer },
                        React__default["default"].createElement("div", { className: classes$d.input },
                            React__default["default"].createElement("span", { className: classes$d.label },
                                t("Coverage"),
                                ":"),
                            React__default["default"].createElement(antd.InputNumber, { min: 0, max: coverageMaxValue, style: { margin: "1px 5px 0px 5px" }, value: coverageLocal, onChange: onChangeLocal, step: sliderStep, className: classes$d.inputNumber, onBlur: roundUpCoverage }),
                            React__default["default"].createElement("span", null, "CAD"),
                            React__default["default"].createElement("span", { style: { marginLeft: 2 } }, "$")),
                        React__default["default"].createElement(antd.Radio, { value: "sureTerm", checked: true, className: classes$d.radioButton, disabled: !isQuestionnaireAccepted }, "SureTerm")),
                    React__default["default"].createElement("div", { id: "call-center-slider-container", className: classes$d.slider },
                        React__default["default"].createElement("div", { className: classes$d.tooltips },
                            React__default["default"].createElement("div", { className: classes$d.start }, ((_b = user.data) === null || _b === void 0 ? void 0 : _b.language) === "en"
                                ? "$ " + numberWithCommas(coverageMinValue)
                                : numberWithCommas(coverageMinValue) + " $"),
                            React__default["default"].createElement("div", { className: classes$d.end }, ((_c = user.data) === null || _c === void 0 ? void 0 : _c.language) === "en"
                                ? "$ " + numberWithCommas(coverageMaxValue)
                                : numberWithCommas(coverageMaxValue) + " $")),
                        React__default["default"].createElement(antd.Slider, { min: 0, max: coverageMaxValue, value: coverageLocal, marks: marks, step: sliderStep, tooltipVisible: true, tipFormatter: tooltipFormatter, onChange: onChangeLocal, onAfterChange: onChange, getTooltipPopupContainer: function () {
                                return document.getElementById("call-center-slider-container");
                            } })))))));
};
var Slider$1 = React.memo(SliderView$1);

var css_248z$d = ".styles-module_container__Lb-1Q {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n}\n.styles-module_container__Lb-1Q > div {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  position: relative;\n  align-items: center;\n}\n.styles-module_container__Lb-1Q > div > div:first-child {\n  font-size: 20px;\n  font-weight: bold;\n}\n.styles-module_container__Lb-1Q > div > div:nth-child(2) {\n  font-size: 20px;\n  font-weight: 500;\n  margin-left: 12px;\n  color: red;\n}\n.styles-module_container__Lb-1Q > div > div:nth-child(2).styles-module_completed__vDIRD {\n  color: green;\n}\n.styles-module_container__Lb-1Q > div:nth-child(2) {\n  max-width: 70%;\n  margin: auto;\n  text-align: center;\n  font-size: 14px;\n  text-transform: uppercase;\n}\n.styles-module_container__Lb-1Q .styles-module_resolution__nT75Y .styles-module_accepted__m-x1k {\n  color: green;\n}\n.styles-module_container__Lb-1Q .styles-module_resolution__nT75Y .styles-module_declined__da112 {\n  color: red;\n}\n.styles-module_container__Lb-1Q .styles-module_completed__vDIRD {\n  color: green;\n}";
var classes$c = {"container":"styles-module_container__Lb-1Q","completed":"styles-module_completed__vDIRD","resolution":"styles-module_resolution__nT75Y","accepted":"styles-module_accepted__m-x1k","declined":"styles-module_declined__da112"};
styleInject(css_248z$d);

var stateSelectorHandle$b = reselect.createSelector(function (state) { return state.questions.questionnaireResolution; }, function (questionnaireResolution) {
    return {
        questionnaireResolution: questionnaireResolution,
    };
});
var QuestionnaireStatus = function (_a) {
    var _b, _c;
    var completed = _a.completed;
    var stateSelector = React.useCallback(stateSelectorHandle$b, []);
    var questionnaireResolution = reactRedux.useSelector(stateSelector).questionnaireResolution;
    var t = reactI18next.useTranslation().t;
    return !questionnaireResolution ? null : (React__default["default"].createElement("div", { className: classes$c.container },
        React__default["default"].createElement("div", null,
            React__default["default"].createElement("div", null,
                t("Completed"),
                ":"),
            React__default["default"].createElement("div", { className: classNames__default["default"]((_b = {},
                    _b[classes$c.completed] = completed,
                    _b)) }, completed ? t("True") : t("False"))),
        !completed && (React__default["default"].createElement("div", null, t("Results are temporary and they can change based on the answers on the rest of the questions"))),
        React__default["default"].createElement("div", { className: classes$c.resolution },
            React__default["default"].createElement("div", null,
                t("Resolution"),
                ":"),
            React__default["default"].createElement("div", { className: classNames__default["default"]((_c = {},
                    _c[classes$c.accepted] = questionnaireResolution.id === "Accept",
                    _c[classes$c.decline] = questionnaireResolution.id === "Decline",
                    _c)) }, t("" + (questionnaireResolution === null || questionnaireResolution === void 0 ? void 0 : questionnaireResolution.caption)))),
        React__default["default"].createElement("div", null)));
};
var QuestionnaireStatus$1 = React.memo(QuestionnaireStatus);

var css_248z$c = ".styles-module_container__4Ls8F {\n  width: 100%;\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}";
var classes$b = {"container":"styles-module_container__4Ls8F"};
styleInject(css_248z$c);

var Option = antd.Select.Option;
var SelectQuestionnaire = function () {
    var _a = React.useState("LiveQuestionnaire"), optionValue = _a[0], setOptionValue = _a[1];
    var dispatch = reactRedux.useDispatch();
    var handleChange = React.useCallback(function (value) {
        if (window.confirm("The entire progress will be lost, are you sure you want to continue?")) {
            setOptionValue(value);
            dispatch(setNewRasPayload(value));
        }
    }, [dispatch]);
    var jsonFiles = [
        "Allergy_accept.json",
        "BicuspidAorticValve_Aneurism_offer50.json",
        "Cancer_Once_specQuestionnaire.json",
        "CancerRecurrent_decline.json",
        "CriminalOnProbation_decline.json",
        "CriminalOtherCrimes_decline.json",
        "CriminalPendingCharges_decline.json",
        "CriminalSimpleAssault_offer201.json",
        "CriminalTwoCrimes_decline.json",
        "DiabetesType1_01_offer175.json",
        "DiabetesType1_01_offer201.json",
        "happy path - clean case.json",
        "TranspositionOfVessels_offer100.json",
    ];
    return (React__default["default"].createElement("div", { className: classes$b.container },
        React__default["default"].createElement(antd.Select, { style: { width: 290 }, value: optionValue, onChange: handleChange },
            React__default["default"].createElement(Option, { value: "LiveQuestionnaire" }, "Live Questionnaire"),
            jsonFiles.map(function (item) {
                return (React__default["default"].createElement(Option, { key: item, value: item }, item.split(".")[0]));
            }))));
};
React.memo(SelectQuestionnaire);

var css_248z$b = ".styles-module_container__0YnFM {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 500px;\n  max-width: 900px;\n  width: 100%;\n  padding: 0px;\n  flex: 1;\n  align-self: center;\n}\n@media only screen and (max-width: 990px) {\n  .styles-module_container__0YnFM {\n    justify-content: center;\n    height: 100%;\n  }\n}\n.styles-module_container__0YnFM .styles-module_rateContainer__6i-wU {\n  display: flex;\n  flex-direction: row;\n  margin: 18px 0px;\n}\n.styles-module_container__0YnFM .styles-module_rateContainer__6i-wU .styles-module_sliderContainer__GSJSP {\n  display: flex;\n  flex-direction: row;\n  flex: 4;\n  padding: 10px;\n}\n.styles-module_container__0YnFM .styles-module_termLabelContainer__3xOjC {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  z-index: 1;\n}\n.styles-module_container__0YnFM .styles-module_inputRateContainer__gxU38 {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.ant-tooltip {\n  z-index: 1;\n}\n\n.styles-module_loader__Nu1A2 {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n}\n\n.styles-module_overlay__nTA-D {\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  position: absolute;\n  background: white;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.85) 25%, rgba(255, 255, 255, 0.85) 75%, rgba(255, 255, 255, 0.7) 100%);\n}\n.styles-module_overlay__nTA-D .styles-module_video__TsbPf {\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  height: 100%;\n}\n\n.styles-module_loader__Nu1A2 {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: center;\n  font-size: 42px;\n}";
var classes$a = {"container":"styles-module_container__0YnFM","rateContainer":"styles-module_rateContainer__6i-wU","sliderContainer":"styles-module_sliderContainer__GSJSP","termLabelContainer":"styles-module_termLabelContainer__3xOjC","inputRateContainer":"styles-module_inputRateContainer__gxU38","loader":"styles-module_loader__Nu1A2","overlay":"styles-module_overlay__nTA-D","video":"styles-module_video__TsbPf"};
styleInject(css_248z$b);

var css_248z$a = ".styles-module_inputNumberContainer__Dc265 {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.styles-module_inputNumberContainer__Dc265 .styles-module_inputNumber__1cZNm {\n  display: flex;\n}\n.styles-module_inputNumberContainer__Dc265 .styles-module_inputNumber__1cZNm .ant-input-number-input {\n  padding: 0px 0px 0px 11px;\n  width: 100px;\n}";
var classes$9 = {"inputNumberContainer":"styles-module_inputNumberContainer__Dc265","inputNumber":"styles-module_inputNumber__1cZNm"};
styleInject(css_248z$a);

var stateSelectorHandle$a = reselect.createSelector(function (state) { return state.termsAndRisks.computedRisk; }, function (state) { return state.user; }, function (state) { return state.termsAndRisks; }, function (state) { return state.app.useJuvenileProduct; }, function (computedRisk, user, termsAndRisks, useJuvenileProduct) {
    return {
        computedRisk: computedRisk,
        user: user,
        termsAndRisks: termsAndRisks,
        useJuvenileProduct: useJuvenileProduct,
    };
});
var InputAndRate = function (_a) {
    var value = _a.value, termLabel = _a.termLabel, inputMaxValue = _a.inputMaxValue, handleTermRate = _a.handleTermRate, termKey = _a.termKey, addEverest = _a.addEverest, updateAddEverestValueProgramatically = _a.updateAddEverestValueProgramatically;
    var _b = React.useState(value), localValue = _b[0], setLocalValue = _b[1];
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$a, []);
    var _c = reactRedux.useSelector(stateSelector), computedRisk = _c.computedRisk, termsAndRisks = _c.termsAndRisks, useJuvenileProduct = _c.useJuvenileProduct;
    var coverageDetails = termsAndRisks.coverage, ciCoverage = termsAndRisks.ciCoverage;
    var newInputValueRef = React.useRef(false);
    var roundUpCoverage = React.useCallback(function (event) {
        var sliderStep = useJuvenileProduct
            ? sliderJuvenileApplicantIncrementStep
            : sliderAdultApplicantIncrementStep;
        var inputValue = parseInt(event.target.value);
        var lowerLimit = 0;
        var returnedValue;
        if (termLabel === EProductTerm.chubb) {
            lowerLimit = ciCoverage.minValue;
        }
        else {
            lowerLimit = coverageDetails.minValue;
        }
        if (isNaN(inputValue) || inputValue < lowerLimit) {
            setLocalValue(0);
            returnedValue = 0;
            handleTermRate(termKey, 0, termLabel);
        }
        else {
            if (inputValue > inputMaxValue) {
                returnedValue = inputMaxValue;
            }
            else if (lowerLimit <= inputValue &&
                inputValue <= inputMaxValue) {
                returnedValue =
                    Math.round(inputValue / sliderStep) * sliderStep;
            }
            else {
                returnedValue = 0;
            }
            setLocalValue(returnedValue);
            handleTermRate(termKey, returnedValue, termLabel);
        }
        newInputValueRef.current = true;
    }, [
        ciCoverage.minValue,
        coverageDetails.minValue,
        handleTermRate,
        inputMaxValue,
        termKey,
        termLabel,
        useJuvenileProduct,
    ]);
    React.useEffect(function () {
        setLocalValue(value);
    }, [value]);
    // request for rates details based on eligible products
    React.useEffect(function () {
        if (computedRisk && termLabel !== EProductTerm.chubb) {
            dispatch(getFinalAssessmentRatesMatch({
                product_risk: computedRisk,
                product_term: termLabel,
                benefit_amount: value,
                add_everest: addEverest ? 1 : 0,
            }));
        }
    }, [dispatch, computedRisk, value, termLabel, addEverest]);
    React.useEffect(function () {
        if (computedRisk ===
            EMaxAndMinTermAndRisk.maxSureAndEvolutionProductsRisk) {
            if (termLabel === EProductTerm.chubb) {
                dispatch(getFinalAssessmentRatesMatch({
                    benefit_amount: value,
                    product_id: chubbFinalExpenseProductId,
                    product_term: EProductTerm.chubb,
                    add_everest: addEverest ? 1 : 0,
                }));
            }
        }
    }, [computedRisk, dispatch, termLabel, value, addEverest]);
    React.useEffect(function () {
        if (newInputValueRef.current) {
            // this useEffect should execute any time a new product value is added
            if (value === 0 && addEverest) {
                dispatch(setFinalAssessmentTermEverest({
                    addEverest: false,
                    termOrder: termKey,
                }));
            }
            else if (updateAddEverestValueProgramatically &&
                value > 0 &&
                !addEverest) {
                dispatch(setFinalAssessmentTermEverest({
                    setDefaultAddEverestValue: true,
                    termOrder: termKey,
                }));
            }
            newInputValueRef.current = false;
        }
    }, [
        value,
        dispatch,
        termKey,
        addEverest,
        updateAddEverestValueProgramatically,
    ]);
    return (React__default["default"].createElement("div", { className: classes$9.inputNumberContainer },
        React__default["default"].createElement(antd.InputNumber, { id: "input_" + termKey, min: 0, max: inputMaxValue, style: { margin: "1px 5px 0px 5px" }, value: localValue, onChange: function (value) { return setLocalValue(value); }, type: "number", step: useJuvenileProduct
                ? sliderJuvenileApplicantIncrementStep
                : sliderAdultApplicantIncrementStep, className: classes$9.inputNumber, onBlur: roundUpCoverage })));
};
var Input = React.memo(InputAndRate);

var css_248z$9 = ".styles-module_container__RqpYa {\n  flex: 1;\n  position: relative;\n}\n.styles-module_container__RqpYa .ant-slider-rail {\n  height: 16px !important;\n  border-radius: 6px;\n}\n.styles-module_container__RqpYa .ant-slider {\n  height: 16px !important;\n}\n.styles-module_container__RqpYa .ant-slider-mark-text-active {\n  color: rgba(0, 0, 0, 0.45) !important;\n}\n.styles-module_container__RqpYa .ant-slider-with-marks {\n  padding: 0px 0px;\n}\n.styles-module_container__RqpYa .ant-slider-track {\n  height: 16px;\n  background-color: #f55b6c;\n  border-radius: 6px 0px 0px 6px;\n}\n.styles-module_container__RqpYa .ant-slider-dot {\n  top: 18px;\n  border-radius: unset;\n  margin-left: 0px !important;\n  border: unset;\n  border-right: 1px solid #f0f0f0;\n  width: unset;\n  cursor: pointer;\n}\n.styles-module_container__RqpYa .ant-slider-dot-active {\n  border-color: #a0a0a0a1;\n}\n.styles-module_container__RqpYa .ant-slider-mark-text {\n  font-size: 10px;\n  top: 10px;\n}\n.styles-module_container__RqpYa .ant-slider-step {\n  height: 16px;\n}\n.styles-module_container__RqpYa .ant-slider-handle {\n  margin-top: 0px;\n  width: 2px;\n  height: 24px;\n  top: -4px;\n  border-radius: 0% !important;\n  border: none !important;\n  background-color: #f55b6c;\n}\n.styles-module_container__RqpYa .ant-slider:hover .ant-slider-track {\n  background-color: #f55b6c;\n}\n.styles-module_container__RqpYa .ant-slider-mark > :first-child {\n  left: 0 !important;\n  transform: none !important;\n}\n.styles-module_container__RqpYa .ant-slider-mark > :last-child {\n  transform: translateX(-100%) !important;\n  white-space: nowrap;\n}\n\n.ant-tooltip-inner {\n  background-color: #f55b6c !important;\n  padding: 0px 5px !important;\n  border-radius: 5px !important;\n  min-height: 16px !important;\n  font-size: 10px;\n}\n\n.ant-tooltip-arrow-content {\n  background-color: #f55b6c !important;\n}\n\n.ant-tooltip-content {\n  pointer-events: none;\n}\n\n.ant-slider-tooltip {\n  pointer-events: all;\n  cursor: pointer;\n}";
var classes$8 = {"container":"styles-module_container__RqpYa"};
styleInject(css_248z$9);

var stateSelectorHandle$9 = reselect.createSelector(function (state) { return state.user; }, function (state) { return state.app.initFinalAssessment; }, function (state) { return state.termsAndRisks.computedRisk; }, function (state) { return state.termsAndRisks.coverage; }, function (state) { return state.termsAndRisks.ciCoverage; }, function (state) { return state.app.useJuvenileProduct; }, function (user, initFinalAssessment, computedRisk, coverageDetails, ciCoverage, useJuvenileProduct) {
    return {
        user: user,
        initFinalAssessment: initFinalAssessment,
        computedRisk: computedRisk,
        coverageDetails: coverageDetails,
        ciCoverage: ciCoverage,
        useJuvenileProduct: useJuvenileProduct,
    };
});
var SliderView = function (_a) {
    var _b;
    var 
    //   isQuestionnaireAccepted,
    value = _a.value, maxValue = _a.maxValue, minValue = _a.minValue, handleTermRate = _a.handleTermRate, termKey = _a.termKey, termLabel = _a.termLabel, addEverest = _a.addEverest, updateAddEverestValueProgramatically = _a.updateAddEverestValueProgramatically;
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$9, []);
    var _c = reactRedux.useSelector(stateSelector), user = _c.user, initFinalAssessment = _c.initFinalAssessment, coverageDetails = _c.coverageDetails, ciCoverage = _c.ciCoverage, useJuvenileProduct = _c.useJuvenileProduct;
    var _d = React.useState(maxValue), sliderLocal = _d[0], setSliderLocal = _d[1];
    var newSliderValueRef = React.useRef(false);
    var marks = React.useMemo(function () {
        var _a, _b;
        var _c;
        var noOfMarks = 5;
        // in order to represent the slider's steps in accordance with the minimum and maximum coverage for the CI product
        // I had to decrease the loop with one index
        var sliderStep = useJuvenileProduct
            ? sliderJuvenileApplicantIncrementStep
            : sliderAdultApplicantIncrementStep;
        var sliderMarksStep = maxValue / noOfMarks;
        var result = {};
        for (var i = 0; i <= noOfMarks; i++) {
            var numberObjectKey = void 0;
            if (i === 0) {
                numberObjectKey = minValue;
            }
            else {
                numberObjectKey = sliderMarksStep * i;
            }
            if (i < noOfMarks && numberObjectKey % sliderStep !== 0)
                continue;
            ((_c = user.data) === null || _c === void 0 ? void 0 : _c.language) === "en"
                ? Object.assign(result, (_a = {},
                    _a[numberObjectKey] = "$ " + numberWithCommas(numberObjectKey),
                    _a))
                : Object.assign(result, (_b = {},
                    _b[numberObjectKey] = numberWithCommas(numberObjectKey) + " $",
                    _b));
        }
        return result;
    }, [maxValue, minValue, useJuvenileProduct, (_b = user.data) === null || _b === void 0 ? void 0 : _b.language]);
    var tooltipFormatter = React.useCallback(function (value) {
        var _a;
        if (value) {
            return ((_a = user.data) === null || _a === void 0 ? void 0 : _a.language) === "en" ? (React__default["default"].createElement("div", { className: classes$8.tooltipFormatter }, "$ " + numberWithCommas(value))) : (React__default["default"].createElement("div", { className: classes$8.tooltipFormatter }, numberWithCommas(value) + " $"));
        }
    }, [user]);
    var onChangeLocal = React.useCallback(function (value) {
        setSliderLocal(value);
    }, []);
    var onChange = React.useCallback(function (value) {
        var parsedValue = value;
        if (termLabel === EProductTerm.chubb) {
            if (value < ciCoverage.minValue / 2) {
                parsedValue = 0;
            }
            else if (value >= ciCoverage.minValue / 2 &&
                value < ciCoverage.minValue) {
                parsedValue = ciCoverage.minValue;
            }
        }
        else {
            if (value < coverageDetails.minValue / 2) {
                parsedValue = 0;
            }
            else if (value >= coverageDetails.minValue / 2 &&
                value < coverageDetails.minValue) {
                parsedValue = coverageDetails.minValue;
            }
        }
        setSliderLocal(parsedValue);
        handleTermRate(termKey, parsedValue, termLabel);
        newSliderValueRef.current = true;
    }, [
        termLabel,
        handleTermRate,
        termKey,
        ciCoverage.minValue,
        coverageDetails.minValue,
    ]);
    var getTooltipPopupContainer = function () {
        return initFinalAssessment
            ? document.getElementById(termKey + "-final-assessment-slider-container")
            : document.getElementById(termKey + "-quote-drawer-slider-container");
    };
    React.useEffect(function () {
        if (sliderLocal !== value) {
            setSliderLocal(value);
        }
        // eslint-disable-next-line
    }, [value]);
    React.useEffect(function () {
        if (newSliderValueRef.current) {
            if (value === 0 && addEverest) {
                dispatch(setFinalAssessmentTermEverest({
                    addEverest: false,
                    termOrder: termKey,
                }));
            }
            else if (updateAddEverestValueProgramatically &&
                value > 0 &&
                !addEverest) {
                dispatch(setFinalAssessmentTermEverest({
                    setDefaultAddEverestValue: true,
                    termOrder: termKey,
                }));
            }
            newSliderValueRef.current = false;
        }
    }, [
        value,
        dispatch,
        termKey,
        addEverest,
        updateAddEverestValueProgramatically,
    ]);
    return (React__default["default"].createElement("div", { className: classes$8.container },
        React__default["default"].createElement("div", { className: classes$8.slider, id: initFinalAssessment
                ? termKey + "-final-assessment-slider-container"
                : termKey + "-quote-drawer-slider-container" },
            React__default["default"].createElement(antd.Slider, { min: minValue, max: maxValue, value: sliderLocal, marks: marks, step: useJuvenileProduct
                    ? sliderJuvenileApplicantIncrementStep
                    : sliderAdultApplicantIncrementStep, tooltipVisible: true, tipFormatter: tooltipFormatter, onChange: onChangeLocal, onAfterChange: onChange, getTooltipPopupContainer: getTooltipPopupContainer }))));
};
var Slider = React.memo(SliderView);

var css_248z$8 = ".styles-module_listElement__QhnMC {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 4px 10px;\n}\n.styles-module_listElement__QhnMC .styles-module_leftSide__Eg0V8 {\n  display: flex;\n  flex-direction: row;\n}\n.styles-module_listElement__QhnMC .styles-module_leftSide__Eg0V8.styles-module_flexColumnDirection__BOlgn {\n  flex-direction: column;\n}\n.styles-module_listElement__QhnMC .styles-module_rightSide__7Ah6Z {\n  font-size: 12px;\n  color: #000000;\n  line-height: 23px;\n}\n.styles-module_listElement__QhnMC .styles-module_boldText__026a5 {\n  font-weight: bold;\n}\n.styles-module_listElement__QhnMC.styles-module_disabled__3UsyM .styles-module_checkCircleFilled__nr5q-,\n.styles-module_listElement__QhnMC.styles-module_disabled__3UsyM .styles-module_normalText__yKJDr {\n  opacity: 0.5;\n  cursor: default;\n}\n.styles-module_listElement__QhnMC.styles-module_inactiveList__ZI11- .styles-module_leftSide__Eg0V8 > div:nth-child(2) {\n  color: #b5b5b5;\n}\n.styles-module_listElement__QhnMC.styles-module_inactiveList__ZI11- .styles-module_rightSide__7Ah6Z {\n  color: #b5b5b5;\n}\n.styles-module_listElement__QhnMC.styles-module_cursorPointer__67lnu {\n  cursor: pointer;\n}";
var classes$7 = {"listElement":"styles-module_listElement__QhnMC","leftSide":"styles-module_leftSide__Eg0V8","flexColumnDirection":"styles-module_flexColumnDirection__BOlgn","rightSide":"styles-module_rightSide__7Ah6Z","boldText":"styles-module_boldText__026a5","disabled":"styles-module_disabled__3UsyM","checkCircleFilled":"styles-module_checkCircleFilled__nr5q-","normalText":"styles-module_normalText__yKJDr","inactiveList":"styles-module_inactiveList__ZI11-","cursorPointer":"styles-module_cursorPointer__67lnu"};
styleInject(css_248z$8);

var stateSelectorHandle$8 = reselect.createSelector(function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter; }, function (state) { return state.app.useJuvenileProduct; }, function (state) { return state.app.add_everest; }, function (isCallCenter, useJuvenileProduct, appAddEverest) {
    return {
        isCallCenter: isCallCenter,
        useJuvenileProduct: useJuvenileProduct,
        appAddEverest: appAddEverest,
    };
});
var TermLabel = function (_a) {
    var _b, _c;
    var item = _a.item, index = _a.index, questionnaireEvaluation = _a.questionnaireEvaluation, disabledTermsAccordingToApplicantAge = _a.disabledTermsAccordingToApplicantAge, handleSelectTerm = _a.handleSelectTerm, selectedTerm = _a.selectedTerm, termKey = _a.termKey, addEverest = _a.addEverest;
    var stateSelector = React.useCallback(stateSelectorHandle$8, []);
    var _d = reactRedux.useSelector(stateSelector), isCallCenter = _d.isCallCenter, useJuvenileProduct = _d.useJuvenileProduct, appAddEverest = _d.appAddEverest;
    var t = reactI18next.useTranslation().t;
    var dispatch = reactRedux.useDispatch();
    var showEvolutionLabelAccordingToAgeAndTerm = useShowEvolutionLabelAccordingToAge(item.label).showEvolutionLabelAccordingToAgeAndTerm;
    var productLabel = React.useMemo(function () {
        if (isCallCenter === 0) {
            if (item.label === EProductTerm.chubb) {
                return "" + t("Final Expense");
            }
            else if (item.label === EProductTerm.FiveToT100) {
                return t("Evolution") + " " + item.label;
            }
            else if (item.label === EProductTerm.JuvenileLife) {
                return "" + t("Evolution Jr. Life");
            }
            else if (item.label === EProductTerm.JuvenileCI) {
                return "" + t("Evolution Jr. Critical Illness");
            }
            else {
                return t("Evolution") + " T" + item.label;
            }
        }
        else if (isCallCenter === 2) {
            if (useJuvenileProduct) {
                if (item.label === EProductTerm.JuvenileLife) {
                    return "" + t("Evolution Jr. Life");
                }
                else if (item.label === EProductTerm.JuvenileCI) {
                    return "" + t("Evolution Jr. Critical Illness");
                }
                else {
                    return "-";
                }
            }
            else {
                return showEvolutionLabelAccordingToAgeAndTerm
                    ? t("Evolution") + " T" + item.label
                    : "T" + item.label;
            }
        }
        else {
            return "";
        }
    }, [
        isCallCenter,
        item,
        t,
        useJuvenileProduct,
        showEvolutionLabelAccordingToAgeAndTerm,
    ]);
    var handleEverest = React.useCallback(function (e) {
        dispatch(setFinalAssessmentTermEverest({
            addEverest: e.target.checked,
            termOrder: termKey,
            resetAllEverestCheckboxes: true,
        }));
    }, [dispatch, termKey]);
    return (React__default["default"].createElement("div", { key: "product_" + index, className: classes$7.listElement, onClick: !(questionnaireEvaluation === null || questionnaireEvaluation === void 0 ? void 0 : questionnaireEvaluation.status) || (disabledTermsAccordingToApplicantAge === null || disabledTermsAccordingToApplicantAge === void 0 ? void 0 : disabledTermsAccordingToApplicantAge.includes(item))
            ? undefined
            : handleSelectTerm(item) },
        React__default["default"].createElement("div", { className: classNames__default["default"](classes$7.leftSide, (_b = {},
                _b[classes$7.flexColumnDirection] = isCallCenter === 2,
                _b)) },
            React__default["default"].createElement("div", { className: classNames__default["default"](classes$7.normalText, (_c = {},
                    _c[classes$7.boldText] = item === selectedTerm,
                    _c)) }, productLabel),
            isCallCenter === 2 && typeof appAddEverest !== "undefined" && (React__default["default"].createElement("div", null,
                React__default["default"].createElement(antd.Checkbox, { style: {
                        color: "grey",
                        top: "3px",
                    }, onChange: handleEverest, checked: addEverest ? true : false, disabled: item.rate === 0 || !item.rate }, "Everest"))))));
};
var TermLabel$1 = React.memo(TermLabel);

var css_248z$7 = ".styles-module_listElement__xnwKi {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #f4f4f4;\n  margin-bottom: 5px;\n  padding: 4px 10px;\n  z-index: 1;\n}\n.styles-module_listElement__xnwKi .styles-module_leftSide__FZW-- {\n  display: flex;\n  flex-direction: row;\n}\n.styles-module_listElement__xnwKi .styles-module_leftSide__FZW-- > div:first-child {\n  margin-right: 10px;\n}\n.styles-module_listElement__xnwKi .styles-module_leftSide__FZW-- > div:nth-child(2) {\n  color: #000000;\n  font-size: 12px;\n  line-height: 23px;\n}\n.styles-module_listElement__xnwKi .styles-module_rightSide__Vdzln {\n  font-size: 12px;\n  color: #000000;\n  line-height: 23px;\n}\n.styles-module_listElement__xnwKi .styles-module_boldText__vpDXH {\n  font-weight: bold;\n}\n.styles-module_listElement__xnwKi.styles-module_disabled__FiBVs .styles-module_checkCircleFilled__ZUNI7,\n.styles-module_listElement__xnwKi.styles-module_disabled__FiBVs .styles-module_normalText__aNWFa {\n  opacity: 0.5;\n  cursor: default;\n}\n.styles-module_listElement__xnwKi.styles-module_inactiveList__LVZRR .styles-module_leftSide__FZW-- > div:nth-child(2) {\n  color: #b5b5b5;\n}\n.styles-module_listElement__xnwKi.styles-module_inactiveList__LVZRR .styles-module_rightSide__Vdzln {\n  color: #b5b5b5;\n}\n.styles-module_listElement__xnwKi.styles-module_cursorPointer__o-MSb {\n  cursor: pointer;\n}\n.styles-module_listElement__xnwKi .styles-module_loader__oyIWx {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.styles-module_subTitle__xACFp {\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  font-size: 12px;\n  color: grey;\n  text-align: center;\n}";
var classes$6 = {"listElement":"styles-module_listElement__xnwKi","leftSide":"styles-module_leftSide__FZW--","rightSide":"styles-module_rightSide__Vdzln","boldText":"styles-module_boldText__vpDXH","disabled":"styles-module_disabled__FiBVs","checkCircleFilled":"styles-module_checkCircleFilled__ZUNI7","normalText":"styles-module_normalText__aNWFa","inactiveList":"styles-module_inactiveList__LVZRR","cursorPointer":"styles-module_cursorPointer__o-MSb","loader":"styles-module_loader__oyIWx","subTitle":"styles-module_subTitle__xACFp"};
styleInject(css_248z$7);

var stateSelectorHandle$7 = reselect.createSelector(function (state) { var _a; return (_a = state.termsAndRisks) === null || _a === void 0 ? void 0 : _a.finalAssessmentRatesDetails; }, function (state) { return state.user.data; }, function (finalAssessmentRatesDetails, userData) {
    return {
        finalAssessmentRatesDetails: finalAssessmentRatesDetails,
        userData: userData,
    };
});
var Rate = function (_a) {
    var _b;
    var term = _a.term;
    var stateSelector = React.useCallback(stateSelectorHandle$7, []);
    var _c = reactI18next.useTranslation(), t = _c.t, i18n = _c.i18n;
    var _d = reactRedux.useSelector(stateSelector), finalAssessmentRatesDetails = _d.finalAssessmentRatesDetails, userData = _d.userData;
    var _e = userData || {}, nearestAge = _e.nearestAge, realAge = _e.realAge, province = _e.province;
    var rateValue = (_b = finalAssessmentRatesDetails === null || finalAssessmentRatesDetails === void 0 ? void 0 : finalAssessmentRatesDetails[term]) === null || _b === void 0 ? void 0 : _b.premium;
    var termSubtitle = React.useMemo(function () {
        var text = null;
        if (term === EProductTerm.chubb &&
            !chubbExcludedProvincies.includes(province ? province : "") &&
            realAge != null &&
            realAge >= 18 &&
            realAge <= 74) {
            text = t("quinquennial premiums");
        }
        else if (term &&
            term !== EProductTerm.chubb &&
            nearestAge != null &&
            nearestAge >= 18 &&
            nearestAge <= 80) {
            text = t("level premiums");
        }
        return text;
    }, [term, nearestAge, province, realAge, t]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: classNames__default["default"](classes$6.listElement) },
            React__default["default"].createElement("div", { className: classNames__default["default"](classes$6.rightSide, classes$6.normalText) }, rateValue ? (i18n.language === "en" ? ("$ " + rateValue + " / " + "month") : (rateValue + " / " + t("month") + " $")) : ("---"))),
        termSubtitle && (React__default["default"].createElement("div", { className: classes$6.subTitle }, termSubtitle))));
};
var Rate$1 = React.memo(Rate);

var css_248z$6 = ".styles-module_description__2kUqP {\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  margin-bottom: 18px;\n  justify-content: center;\n  font-size: 20px;\n  text-align: center;\n  color: #333333;\n}\n@media only screen and (max-width: 990px) {\n  .styles-module_description__2kUqP {\n    margin-top: 10px;\n  }\n  .styles-module_description__2kUqP p {\n    margin: 0px;\n  }\n}\n.styles-module_description__2kUqP.styles-module_blackDescription__Rvh8R {\n  color: #000000;\n}\n.styles-module_description__2kUqP .styles-module_productLabel__OlyTL {\n  text-decoration: underline;\n  font-weight: bold;\n  font-size: 22px;\n}\n.styles-module_description__2kUqP .styles-module_maximCoverage__YSa-f {\n  display: block;\n  text-decoration: underline;\n  font-weight: bold;\n  font-size: 22px;\n}\n.styles-module_description__2kUqP .styles-module_absoluteTextCentered__fl3yh {\n  color: #f55b6c;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin: 5px 0px;\n  font-size: 14px;\n  font-weight: bolder;\n}";
var classes$5 = {"description":"styles-module_description__2kUqP","blackDescription":"styles-module_blackDescription__Rvh8R","productLabel":"styles-module_productLabel__OlyTL","maximCoverage":"styles-module_maximCoverage__YSa-f","absoluteTextCentered":"styles-module_absoluteTextCentered__fl3yh"};
styleInject(css_248z$6);

var stateSelectorHandle$6 = reselect.createSelector(function (state) { return state.app.fieldApplication; }, function (state) { return state.termsAndRisks.computedRisk; }, function (state) {
    return state.termsAndRisks.coverage.forcedMax &&
        state.termsAndRisks.coverage.forcedMax <
            state.termsAndRisks.coverage.maxValue
        ? state.termsAndRisks.coverage.forcedMax
        : state.termsAndRisks.coverage.maxValue;
}, function (state) { return state.termsAndRisks.eligibleProducts; }, function (state) { return state.app.useJuvenileProduct; }, function (state) { var _a; return (_a = state.user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter; }, function (fieldApplicationData, computedRisk, maxCoverage, termsAndRisksEligibleProducts, useJuvenileProduct, userIsCallCenter) {
    return {
        fieldApplicationData: fieldApplicationData,
        computedRisk: computedRisk,
        maxCoverage: maxCoverage,
        termsAndRisksEligibleProducts: termsAndRisksEligibleProducts,
        useJuvenileProduct: useJuvenileProduct,
        userIsCallCenter: userIsCallCenter,
    };
});
var TopSection = function () {
    var _a;
    var stateSelector = React.useCallback(stateSelectorHandle$6, []);
    var _b = reactRedux.useSelector(stateSelector), fieldApplicationData = _b.fieldApplicationData, computedRisk = _b.computedRisk, maxCoverage = _b.maxCoverage, termsAndRisksEligibleProducts = _b.termsAndRisksEligibleProducts, useJuvenileProduct = _b.useJuvenileProduct, userIsCallCenter = _b.userIsCallCenter;
    var t = reactI18next.useTranslation().t;
    var productLabel = React.useMemo(function () {
        if (userIsCallCenter === 0) {
            return !useJuvenileProduct
                ? t("Evolution") + " " + risksLabelsForCallCenter0[i18n__default["default"].language][computedRisk]
                : juvenileRisksLabels[i18n__default["default"].language][computedRisk]; /*`${selectedProduct.name}` */ // hardcoded for now for consistency might turn it back to dynamic in the future
        }
        else if (userIsCallCenter === 2) {
            return !useJuvenileProduct
                ? "" + risksLabelsForCallCenter2[i18n__default["default"].language][computedRisk]
                : juvenileRisksLabels[i18n__default["default"].language][computedRisk];
        }
        else {
            return null;
        }
    }, [computedRisk, t, useJuvenileProduct, userIsCallCenter]);
    return (React__default["default"].createElement("div", { className: classNames__default["default"](classes$5.description, (_a = {},
            _a[classes$5.blackDescription] = !fieldApplicationData.honeycombBackground,
            _a)) },
        React__default["default"].createElement("div", null, t("My initial assessment suggests that the applicant may qualify for")),
        productLabel && (React__default["default"].createElement("div", { className: classes$5.productLabel }, productLabel)),
        !useJuvenileProduct && (React__default["default"].createElement("div", null,
            t("Please select your terms of choice, with combined maximum face amount up to"),
            React__default["default"].createElement("span", { className: classes$5.maximCoverage },
                i18n__default["default"].language === "en" && React__default["default"].createElement("span", null, "$ "),
                new Intl.NumberFormat().format(maxCoverage),
                i18n__default["default"].language === "en" && ".",
                i18n__default["default"].language === "fr" && React__default["default"].createElement("span", null, " $.")))),
        !useJuvenileProduct && (termsAndRisksEligibleProducts === null || termsAndRisksEligibleProducts === void 0 ? void 0 : termsAndRisksEligibleProducts[EProductTerm.chubb]) && (React__default["default"].createElement("div", { className: classes$5.absoluteTextCentered }, userIsCallCenter === 0
            ? t("Please select Evolution Essence or one of the following options.")
            : t("Please select one of the following options.")))));
};
var TopSection$1 = React.memo(TopSection);

var css_248z$5 = ".styles-module_bottomArea__V-iod {\n  display: flex;\n  z-index: 1;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.styles-module_bottomArea__V-iod .styles-module_totalAmount__gwePc {\n  display: flex;\n  flex-direction: row;\n  font-weight: bold;\n  font-size: 16px;\n}\n.styles-module_bottomArea__V-iod .styles-module_totalAmount__gwePc div:first-child {\n  margin-right: 10px;\n}\n.styles-module_bottomArea__V-iod .styles-module_completeApplication__nXCL- {\n  margin: 10px;\n}";
var classes$4 = {"bottomArea":"styles-module_bottomArea__V-iod","totalAmount":"styles-module_totalAmount__gwePc","completeApplication":"styles-module_completeApplication__nXCL-"};
styleInject(css_248z$5);

var stateSelectorHandle$5 = reselect.createSelector(function (state) { return state.termsAndRisks; }, function (state) { return state.app; }, function (termsAndRisks, app) {
    var finalAssessmentRatesDetails = (termsAndRisks === null || termsAndRisks === void 0 ? void 0 : termsAndRisks.finalAssessmentRatesDetails) || {};
    return {
        termsAndRisks: termsAndRisks,
        totalPremium: Object.keys(finalAssessmentRatesDetails).reduce(function (acc, cur) {
            var _a;
            var current = (_a = finalAssessmentRatesDetails[cur]) === null || _a === void 0 ? void 0 : _a.premium;
            if (!current)
                current = 0;
            return acc + parseFloat(current);
        }, 0),
        app: app,
    };
});
var BottomSection = function (_a) {
    var unmount = _a.unmount;
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$5, []);
    var _b = React.useState(false), showModal = _b[0], setShowModal = _b[1];
    var _c = reactRedux.useSelector(stateSelector), termsAndRisks = _c.termsAndRisks, totalPremium = _c.totalPremium, app = _c.app;
    var finalAssessment = app.finalAssessment, initFinalAssessment = app.initFinalAssessment;
    var _d = reactI18next.useTranslation(), t = _d.t, i18n = _d.i18n;
    var coverageDetails = termsAndRisks.coverage;
    var finalAssessmentCustomOrderedTerms = finalAssessment === null || finalAssessment === void 0 ? void 0 : finalAssessment.customOrderedTerms;
    var slidersTotalAmount = React.useMemo(function () {
        if (!finalAssessmentCustomOrderedTerms) {
            return 0;
        }
        else {
            var totalAmount_1 = 0;
            Object.values(finalAssessmentCustomOrderedTerms).map(function (item) { return (totalAmount_1 += item.rate); });
            return totalAmount_1;
        }
    }, [finalAssessmentCustomOrderedTerms]);
    var handleShowModal = React.useCallback(function () {
        setShowModal(!showModal);
    }, [showModal]);
    var handleCancel = function () {
        setShowModal(!showModal);
    };
    var handleFinishAndProceed = React.useCallback(function () {
        // the global store is updated after the moment unmount is called but for consistency's sake I updated the global store
        dispatch(setApplicationApproved(true));
        unmount === null || unmount === void 0 ? void 0 : unmount({ unmountApplicationApproved: true });
    }, [dispatch, unmount]);
    var handleOk = React.useCallback(function () {
        setShowModal(!showModal);
        handleFinishAndProceed();
    }, [showModal, handleFinishAndProceed]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: classes$4.bottomArea },
            React__default["default"].createElement("div", { className: classes$4.totalAmount },
                React__default["default"].createElement("div", null,
                    t("Monthly Total Premium"),
                    ":"),
                React__default["default"].createElement("div", null, typeof totalPremium === "number" &&
                    !Number.isNaN(totalPremium)
                    ? new Intl.NumberFormat(i18n.language === "en" ? "en-US" : "fr-FR", {
                        style: "currency",
                        currency: "CAD",
                    }).format(totalPremium)
                    : "-")),
            React__default["default"].createElement("div", { className: classes$4.totalAmount },
                React__default["default"].createElement("div", null,
                    t("Total Amount"),
                    ":"),
                React__default["default"].createElement("div", null, typeof slidersTotalAmount === "number" &&
                    !Number.isNaN(slidersTotalAmount)
                    ? new Intl.NumberFormat(i18n.language === "en" ? "en-US" : "fr-FR", {
                        style: "currency",
                        currency: "CAD",
                    }).format(slidersTotalAmount)
                    : "-")),
            initFinalAssessment && (React__default["default"].createElement("div", { className: classes$4.completeApplication },
                React__default["default"].createElement(antd.Button, { type: "primary", onClick: handleShowModal, disabled: slidersTotalAmount < coverageDetails.minValue }, t("Please click here to complete the application"))))),
        React__default["default"].createElement(ConfirmModal$1, { visible: showModal, handleOk: handleOk, handleCancel: handleCancel, title: t("Complete the application"), subTitle: t("Please review your options before proceeding!"), okText: t("Complete"), cancelText: t("Review") })));
};
var BottomSection$1 = React.memo(BottomSection);

var stateSelectorHandle$4 = reselect.createSelector(function (state) { return state.termsAndRisks; }, function (state) { return state.app; }, function (state) { return state.user; }, function (state) { return state.app.finalAssessment.customOrderedTerms; }, function (state) { return state.app.add_everest; }, function (termsAndRisks, app, user, customOrderedTerms, appAddEverest) {
    var disabledTermsAccordingToApplicantAge = (termsAndRisks &&
        termsAndRisks.disabledTermsAccordingToApplicantAge) ||
        {};
    return {
        termsAndRisks: termsAndRisks,
        app: app,
        user: user,
        disabledTermsAccordingToApplicantAge: disabledTermsAccordingToApplicantAge,
        customOrderedTerms: customOrderedTerms,
        appAddEverest: appAddEverest,
    };
});
var FinalAssessment = function (_a) {
    var _b, _c, _d;
    var unmount = _a.unmount;
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$4, []);
    var _e = reactRedux.useSelector(stateSelector), termsAndRisks = _e.termsAndRisks, app = _e.app, user = _e.user, customOrderedTerms = _e.customOrderedTerms, appAddEverest = _e.appAddEverest;
    var _f = React.useState(false), updateAddEverestValueProgramatically = _f[0], setUpdateAddEverestValueProgramatically = _f[1];
    var finalAssessment = app.finalAssessment, useJuvenileProduct = app.useJuvenileProduct;
    var coverageDetails = termsAndRisks.coverage, computedRisk = termsAndRisks.computedRisk, eligibleProducts = termsAndRisks.eligibleProducts;
    var checkAllEligibleProducts = React.useMemo(function () {
        if (eligibleProducts) {
            if (useJuvenileProduct) {
                return (Object.keys(eligibleProducts).length ===
                    totalNoOfJuvenileProducts);
            }
            else {
                return (Object.keys(eligibleProducts).length ===
                    totalNoOfEssenceProducts);
            }
        }
        else {
            return false;
        }
    }, [eligibleProducts, useJuvenileProduct]);
    var coverageForcedMax = coverageDetails.forcedMax, coverageMaxValue = coverageDetails.maxValue;
    var maxCoverage = coverageForcedMax && coverageForcedMax < coverageMaxValue
        ? coverageForcedMax
        : coverageMaxValue;
    var handleTermRate = React.useCallback(function (termKey, inputValue, termLabel) {
        var _a;
        dispatch(setFinalAssessmentRateTerms({
            term: termKey,
            maxCoverageValue: maxCoverage,
            inputValue: inputValue,
            computedRisk: computedRisk,
            isCallCenter: (_a = user === null || user === void 0 ? void 0 : user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter,
            ciMinMaxCoverage: {
                minValue: termsAndRisks.ciCoverage.minValue,
                maxValue: termsAndRisks.ciCoverage.maxValue,
            },
            termLabel: termLabel,
            useJuvenileProduct: useJuvenileProduct,
        }));
    }, [
        dispatch,
        maxCoverage,
        computedRisk,
        user,
        termsAndRisks.ciCoverage.minValue,
        termsAndRisks.ciCoverage.maxValue,
        useJuvenileProduct,
    ]);
    React.useEffect(function () {
        // update the prices whenever smoker/smokerFE is updated
        if ((finalAssessment === null || finalAssessment === void 0 ? void 0 : finalAssessment.customOrderedTerms) && (user === null || user === void 0 ? void 0 : user.data) &&
            chubbFinalExpenseProductId &&
            computedRisk) {
            for (var property in finalAssessment.customOrderedTerms) {
                var currentProduct = finalAssessment.customOrderedTerms[property];
                dispatch(getFinalAssessmentRatesMatch({
                    product_risk: computedRisk,
                    product_term: currentProduct.label,
                    benefit_amount: currentProduct.rate,
                    product_id: currentProduct.label === EProductTerm.chubb
                        ? chubbFinalExpenseProductId
                        : undefined,
                    add_everest: currentProduct.addEverest ? 1 : 0,
                }));
            }
        }
        // IMPORTANT!!! this function should execute only if smoker/smokerFE is updated
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(_b = user === null || user === void 0 ? void 0 : user.data) === null || _b === void 0 ? void 0 : _b.smoker, (_c = user === null || user === void 0 ? void 0 : user.data) === null || _c === void 0 ? void 0 : _c.smokerFE]);
    React.useEffect(function () {
        var _a;
        if (((_a = user === null || user === void 0 ? void 0 : user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter) === 2 &&
            typeof appAddEverest !== "undefined") {
            var noOfTermsWithNonZeroValue = 0;
            for (var key in customOrderedTerms) {
                // @ts-ignore
                if (customOrderedTerms[key].rate > 0) {
                    noOfTermsWithNonZeroValue++;
                }
                if (noOfTermsWithNonZeroValue > 1) {
                    break;
                }
            }
            if (noOfTermsWithNonZeroValue === 0) {
                setUpdateAddEverestValueProgramatically(true);
            }
            else {
                setUpdateAddEverestValueProgramatically(false);
            }
        }
    }, [customOrderedTerms, (_d = user === null || user === void 0 ? void 0 : user.data) === null || _d === void 0 ? void 0 : _d.isCallCenter, appAddEverest]);
    return !checkAllEligibleProducts ? (React__default["default"].createElement("div", { className: classes$a.loader },
        React__default["default"].createElement(icons.RedoOutlined, { spin: true }))) : (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { className: classes$a.container },
            React__default["default"].createElement(TopSection$1, null),
            !termsAndRisks.eligibleProducts && (React__default["default"].createElement("div", { style: {
                    minHeight: 200,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                } },
                React__default["default"].createElement(icons.RedoOutlined, { spin: true }))),
            finalAssessment.customOrderedTerms &&
                Object.values(finalAssessment.customOrderedTerms)
                    .filter(function (item) { return item.label; })
                    .map(function (item, index) {
                    return (React__default["default"].createElement("div", { key: item.label, className: classes$a.rateContainer, style: {
                            display: termsAndRisks.finalAssessmentRatesDetails
                                ? undefined
                                : "none",
                        } },
                        React__default["default"].createElement("div", { className: classes$a.termLabelContainer },
                            React__default["default"].createElement(TermLabel$1, { addEverest: item === null || item === void 0 ? void 0 : item.addEverest, item: item, termKey: Object.keys(finalAssessment.customOrderedTerms)[index] })),
                        React__default["default"].createElement("div", { className: classes$a.sliderContainer },
                            React__default["default"].createElement(Slider, { value: item.rate, termLabel: item.label, maxValue: item.label ===
                                    EProductTerm.chubb ||
                                    item.label ===
                                        EProductTerm.JuvenileCI
                                    ? termsAndRisks.ciCoverage
                                        .maxValue
                                    : maxCoverage, minValue: 0, handleTermRate: handleTermRate, termKey: Object.keys(finalAssessment.customOrderedTerms)[index], addEverest: item.addEverest, updateAddEverestValueProgramatically: updateAddEverestValueProgramatically })),
                        React__default["default"].createElement("div", { className: classes$a.inputRateContainer },
                            React__default["default"].createElement(Input, { termKey: Object.keys(finalAssessment.customOrderedTerms)[index], termLabel: item.label, value: item.rate, inputMinValue: 0, inputMaxValue: item.label ===
                                    EProductTerm.chubb
                                    ? termsAndRisks.ciCoverage
                                        .maxValue
                                    : maxCoverage, addEverest: item.addEverest, handleTermRate: handleTermRate, updateAddEverestValueProgramatically: updateAddEverestValueProgramatically }),
                            React__default["default"].createElement(Rate$1, { key: index + "_rate", term: item.label }))));
                }),
            React__default["default"].createElement(BottomSection$1, { unmount: unmount }))));
};
var FinalAssessment$1 = React.memo(FinalAssessment);

var ConfirmModal = function (_a) {
    var visible = _a.visible, handleOk = _a.handleOk, handleCancel = _a.handleCancel, title = _a.title, subTitle = _a.subTitle, cancelText = _a.cancelText, okText = _a.okText;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(antd.Modal, { title: title, visible: visible, onOk: handleOk, onCancel: handleCancel, okText: okText, cancelText: cancelText }, subTitle)));
};
var ConfirmModal$1 = React.memo(ConfirmModal);

var css_248z$4 = ".styles-module_drawerContainer__LrRbV {\n  z-index: 10;\n}\n\n.styles-module_drawerMainContent__-5VQc {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.styles-module_drawerMainContent__-5VQc .styles-module_logoContainer__sUZ3X {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.styles-module_drawerMainContent__-5VQc .styles-module_logoContainer__sUZ3X img {\n  min-height: 30px;\n  position: relative;\n  z-index: 2;\n}\n.styles-module_drawerMainContent__-5VQc .styles-module_overlay__GJa-S {\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  position: absolute;\n  background: white;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.85) 25%, rgba(255, 255, 255, 0.85) 75%, rgba(255, 255, 255, 0.7) 100%);\n  pointer-events: none;\n}\n.styles-module_drawerMainContent__-5VQc .styles-module_overlay__GJa-S .styles-module_video__a7cX1 {\n  left: 0;\n  top: 0;\n  min-width: 100%;\n  min-height: 100%;\n  width: 100%;\n  object-fit: cover;\n  height: 100%;\n  pointer-events: none;\n}\n\n.styles-module_partialOpenAndClose__71TCY .ant-drawer-content-wrapper {\n  right: -80% !important;\n}\n\n.styles-module_quoteButton__w5XzA {\n  position: fixed;\n  top: 50%;\n  transform: rotate(90deg);\n  min-height: 40px;\n  z-index: 2;\n}\n.styles-module_quoteButton__w5XzA img {\n  max-width: 80px;\n  min-height: 30px;\n}\n.styles-module_quoteButton__w5XzA span {\n  margin-left: 8px;\n}";
var classes$3 = {"drawerContainer":"styles-module_drawerContainer__LrRbV","drawerMainContent":"styles-module_drawerMainContent__-5VQc","logoContainer":"styles-module_logoContainer__sUZ3X","overlay":"styles-module_overlay__GJa-S","video":"styles-module_video__a7cX1","partialOpenAndClose":"styles-module_partialOpenAndClose__71TCY","quoteButton":"styles-module_quoteButton__w5XzA"};
styleInject(css_248z$4);

var stateSelectorHandle$3 = reselect.createSelector(function (state) { return state.app.fieldApplication; }, selectApplicationShowJennieAssistDrawer, getCurrentQuestion, getCompletePrequalificationAssessment, function (appFieldApplication, showJennieAssistDrawer, currentQuestion, completePrequalificationAssessment) {
    return {
        appFieldApplication: appFieldApplication,
        showJennieAssistDrawer: showJennieAssistDrawer,
        currentQuestion: currentQuestion,
        completePrequalificationAssessment: completePrequalificationAssessment,
    };
});
var DrawerQuote = function () {
    var _a;
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle$3, []);
    var _b = reactRedux.useSelector(stateSelector), appFieldApplication = _b.appFieldApplication, showJennieAssistDrawer = _b.showJennieAssistDrawer, currentQuestion = _b.currentQuestion, completePrequalificationAssessment = _b.completePrequalificationAssessment;
    // check if the drawer has been shown
    var _c = React.useState(false), showDrawerProgramatically = _c[0], setShowDrawerProgramatically = _c[1];
    var _d = reactI18next.useTranslation(), t = _d.t, i18n = _d.i18n;
    var changeDrawerPosition = React.useMemo(function () {
        if (completePrequalificationAssessment.answer &&
            completePrequalificationAssessment.isCompleted &&
            currentQuestion.id ===
                "InsuredPerson.HaveYouDeclaredBankruptcyLast3Years" &&
            currentQuestion.answerState === "missing") {
            return true;
        }
        else {
            return false;
        }
    }, [
        completePrequalificationAssessment.answer,
        completePrequalificationAssessment.isCompleted,
        currentQuestion.id,
        currentQuestion.answerState,
    ]);
    var showDrawer = React.useCallback(function () {
        // setVisible(true);
        dispatch(setShowJenieAssistDrawer(true));
    }, [dispatch]);
    var onClose = React.useCallback(function () {
        // setVisible(false);
        dispatch(setShowJenieAssistDrawer(false));
    }, [dispatch]);
    React.useEffect(function () {
        var closeTheDrawerTimeout;
        var showTheDrawerTimeout;
        var setTheDrawerProgramaticallyTimeout;
        if (completePrequalificationAssessment.isCompleted &&
            completePrequalificationAssessment.answer &&
            currentQuestion.id ===
                "InsuredPerson.HaveYouDeclaredBankruptcyLast3Years" &&
            currentQuestion.answerState === "missing") {
            showTheDrawerTimeout = setTimeout(function () {
                showDrawer();
            }, 400);
            closeTheDrawerTimeout = setTimeout(function () {
                onClose();
            }, 1800);
            setTheDrawerProgramaticallyTimeout = setTimeout(function () { return setShowDrawerProgramatically(true); }, 2200);
        }
        else {
            setShowDrawerProgramatically(false);
        }
        return function () {
            closeTheDrawerTimeout && clearTimeout(closeTheDrawerTimeout);
            showTheDrawerTimeout && clearTimeout(showTheDrawerTimeout);
            setTheDrawerProgramaticallyTimeout &&
                clearTimeout(setTheDrawerProgramaticallyTimeout);
        };
    }, [
        completePrequalificationAssessment.answer,
        completePrequalificationAssessment.isCompleted,
        currentQuestion,
        onClose,
        showDrawer,
    ]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", { id: "quote-menu", className: classes$3.container },
            React__default["default"].createElement(antd.Button, { className: classNames__default["default"](classes$3.quoteButton), type: "primary", onClick: showDrawer, style: i18n.language === "en" ? { right: -53 } : { right: -69 } },
                React__default["default"].createElement("img", { src: "https://media.isi.ca/iapplication/Jenie_assist_" + i18n.language + "_white.png", alt: "" }),
                t("Live")),
            React__default["default"].createElement(antd.Drawer, { className: classNames__default["default"]("drawer", (_a = {},
                    _a[classes$3.partialOpenAndClose] = !showDrawerProgramatically && changeDrawerPosition,
                    _a)), title: React__default["default"].createElement("div", null,
                    React__default["default"].createElement("img", { src: "https://media.isi.ca/iapplication/Jenie_assist_" + i18n.language + ".png", style: {
                            maxWidth: 80,
                            minHeight: 30,
                            marginRight: 8,
                        }, alt: "" }),
                    t("Live")), placement: "right", closable: true, onClose: onClose, visible: showJennieAssistDrawer, width: "90%", style: { zIndex: 9999, top: 46 }, bodyStyle: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    marginBottom: 46,
                }, headerStyle: { zIndex: 1 }, forceRender: true },
                React__default["default"].createElement("div", { className: classes$3.drawerMainContent, id: "quote-drawer-container" },
                    React__default["default"].createElement("div", { className: classes$3.logoContainer },
                        React__default["default"].createElement("img", { src: "https://media.isi.ca/iapplication/Jenie_assist_" + i18n.language + ".png", alt: "logo-jenie-assist" })),
                    React__default["default"].createElement("div", { id: "final-assessment-container", className: classes$3.overlay }, appFieldApplication.honeycombBackground && (React__default["default"].createElement("video", { autoPlay: true, muted: true, loop: true, id: "reflexiveVideo", className: classes$3.video },
                        React__default["default"].createElement("source", { src: "https://media.isi.ca/iapplication/reflexive_video_2.mp4", type: "video/mp4" })))),
                    React__default["default"].createElement(FinalAssessment$1, null))))));
};
var DrawerQuote$1 = React.memo(DrawerQuote);

var css_248z$3 = ".styles-module_container__xRjhN {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n}\n.styles-module_container__xRjhN .styles-module_questionContainer__mjaLG {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 20px;\n}\n\n.styles-module_loader__CEV0B {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n}";
var classes$2 = {"container":"styles-module_container__xRjhN","questionContainer":"styles-module_questionContainer__mjaLG","loader":"styles-module_loader__CEV0B"};
styleInject(css_248z$3);

var css_248z$2 = ".styles-module_buttons__rZAbi {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 40px;\n}\n.styles-module_buttons__rZAbi > :first-child {\n  margin-right: 8px;\n}\n.styles-module_buttons__rZAbi > :nth-child(2) {\n  margin-left: 8px;\n}";
var classes$1 = {"buttons":"styles-module_buttons__rZAbi"};
styleInject(css_248z$2);

var GroupedQuestionsActionsButtons = function (_a) {
    var isCallCenter = _a.isCallCenter, isLastQuestion = _a.isLastQuestion, finalQuestionId = _a.finalQuestionId, allTheQuestionsHaveBeenAnswered = _a.allTheQuestionsHaveBeenAnswered, groupedQuestionCategory = _a.groupedQuestionCategory;
    var dispatch = reactRedux.useDispatch();
    var handlePrevQuestion = React.useCallback(function () {
        dispatch(setPrevQuestion({ groupedQuestionCategory: groupedQuestionCategory }));
    }, [dispatch, groupedQuestionCategory]);
    var form = antd.Form.useForm()[0];
    var t = reactI18next.useTranslation().t;
    return (React__default["default"].createElement(antd.Form, { form: form, name: "groupedQuestion" },
        React__default["default"].createElement("div", { className: classes$1.buttons },
            React__default["default"].createElement(SecondaryButton$1, { label: t("Previous question"), greyBackground: true, onClick: handlePrevQuestion, disabled: !!(finalQuestionId &&
                    isCallCenter !== 1 &&
                    isLastQuestion) }),
            React__default["default"].createElement(SecondaryButton$1, { label: t("Next question"), type: "submit", disabled: !allTheQuestionsHaveBeenAnswered }))));
};
var GroupedQuestionsActionsButtons$1 = React.memo(GroupedQuestionsActionsButtons);

var stateSelectorHandle$2 = reselect.createSelector(function (state) { return state.questions.questionnaireResolution; }, function (questionnaireResolution) {
    return {
        questionnaireResolution: questionnaireResolution,
    };
});
var DeclinedInfoModal = function (_a) {
    var unmount = _a.unmount;
    var stateSelector = React.useCallback(stateSelectorHandle$2, []);
    var questionnaireResolution = reactRedux.useSelector(stateSelector).questionnaireResolution;
    var t = reactI18next.useTranslation().t;
    var _b = React.useState(false), isModalVisible = _b[0], setIsModalVisible = _b[1];
    var proceedToTheApplication = React.useCallback(function () {
        unmount();
    }, [unmount]);
    var handleCancel = function () {
        setIsModalVisible(false);
    };
    React.useEffect(function () {
        if ((questionnaireResolution === null || questionnaireResolution === void 0 ? void 0 : questionnaireResolution.id.toLowerCase()) === "decline") {
            setIsModalVisible(true);
        }
    }, [questionnaireResolution === null || questionnaireResolution === void 0 ? void 0 : questionnaireResolution.id]);
    return (React__default["default"].createElement(ConfirmModal$1, { title: t("Proceed to the application"), subTitle: t("Unfortunately, Evolution Life insurance application cannot be considered at this time!"), visible: isModalVisible, handleOk: proceedToTheApplication, handleCancel: handleCancel, okText: t("Proceed"), cancelText: t("Review") }));
};
var DeclinedInfoModal$1 = React.memo(DeclinedInfoModal);

var css_248z$1 = ".styles-module_questionContainer__cuEdJ {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 20px;\n}";
var classes = {"questionContainer":"styles-module_questionContainer__cuEdJ"};
styleInject(css_248z$1);

var QuestionContent = function (_a) {
    var _b = _a.isGroupedQuestion, isGroupedQuestion = _b === void 0 ? false : _b, question = _a.question, unmount = _a.unmount;
    var caption = question.caption, subText = question.subText, index = question.index;
    return (React__default["default"].createElement("div", { className: classes.questionContainer },
        React__default["default"].createElement(Title$1, { caption: caption, subText: subText, questionIndex: index, isGroupedQuestion: isGroupedQuestion }),
        React__default["default"].createElement(Question$1, { currentQuestion: question, unmount: unmount, isAGroupedQuestion: isGroupedQuestion })));
};
var QuestionContent$1 = React.memo(QuestionContent);

var stateSelectorHandle$1 = reselect.createSelector(function (state) { return state.question; }, function (state) { return state.questions.computed; }, function (state) { return state.user; }, function (state) { return state.app.canTheAssessmentBeStopped; }, function (state) { return state.questions; }, function (state) { return state.app.isReaderActive; }, function (state) { return state.app.useJuvenileProduct; }, function (question, computedQuestions, user, canTheAssessmentBeStopped, questions, isReaderActive, useJuvenileProduct) {
    return {
        question: question,
        computedQuestions: computedQuestions,
        user: user,
        canTheAssessmentBeStopped: canTheAssessmentBeStopped,
        questions: questions,
        isReaderActive: isReaderActive,
        useJuvenileProduct: useJuvenileProduct,
    };
});
var useCurrentQuestionLocalLogic = function () {
    var _a, _b, _c, _d;
    var dispatch = reactRedux.useDispatch();
    var t = reactI18next.useTranslation().t;
    var stream = useGetMp3QuestionTitle().stream;
    var stateSelector = React.useCallback(stateSelectorHandle$1, []);
    var _e = reactRedux.useSelector(stateSelector), question = _e.question, computedQuestions = _e.computedQuestions, user = _e.user, canTheAssessmentBeStopped = _e.canTheAssessmentBeStopped, _f = _e.questions, questionsLoading = _f.loading, questionnaireCompleted = _f.questionnaireCompleted, isReaderActive = _e.isReaderActive, useJuvenileProduct = _e.useJuvenileProduct;
    var isCallCenter = (_a = user.data) === null || _a === void 0 ? void 0 : _a.isCallCenter;
    // check if the current question is a part of a grouped questions
    var currentQuestion = React.useMemo(function () {
        if (question && computedQuestions) {
            var groupedQuestionKey_1 = undefined;
            var groupedQuestionKeys = Object.keys(groupedQuestionsCategories);
            var groupedQuestionKeysLength = groupedQuestionKeys.length;
            for (var i = 0; i < groupedQuestionKeysLength; i++) {
                if (
                //@ts-ignore
                groupedQuestionsCategories[groupedQuestionKeys[i]].ids.includes(question.current.id)) {
                    groupedQuestionKey_1 = groupedQuestionKeys[i];
                    break;
                }
            }
            if ((isCallCenter === 0 || isCallCenter === 1) &&
                groupedQuestionKey_1) {
                // return all the question that fall into this category
                var groupedQuestions = computedQuestions.filter(function (item, index) {
                    return (
                    // @ts-ignore
                    groupedQuestionsCategories[groupedQuestionKey_1].ids.includes(item.id));
                });
                var allTheQuestionsHaveBeenAnswered = true;
                var groupedQuestionsLength = groupedQuestions.length;
                var groupedQuestionsSpeechTitle = t(groupedQuestionKey_1) + ". \n";
                var groupedQuestionsSpeechIds = [
                    //@ts-ignore
                    groupedQuestionsCategories[groupedQuestionKey_1]
                        .groupQuestionId,
                ];
                for (var i = 0; i < groupedQuestionsLength; i++) {
                    if (groupedQuestions[i].answerState === "missing") {
                        allTheQuestionsHaveBeenAnswered = false;
                    }
                    if (groupedQuestions[i].answerState === "missing") {
                        groupedQuestionsSpeechTitle += groupedQuestions[i].caption + ". \n";
                        groupedQuestionsSpeechIds.push(groupedQuestions[i].id);
                    }
                }
                return {
                    grouped: {
                        questions: groupedQuestions,
                        allTheQuestionsHaveBeenAnswered: allTheQuestionsHaveBeenAnswered,
                        groupedQuestionKey: groupedQuestionKey_1,
                    },
                    questionTitleInfo: {
                        caption: groupedQuestionKey_1,
                        groupCaption: groupedQuestionKey_1,
                        questionIndex: groupedQuestionKey_1,
                        subText: groupedQuestionKey_1,
                        index: groupedQuestionKey_1,
                        groupedQuestionsSpeechTitle: groupedQuestionsSpeechTitle,
                        groupedQuestionsSpeechIds: groupedQuestionsSpeechIds,
                    },
                };
            }
            else {
                var _a = question.current, subText = _a.subText, caption = _a.caption, groupCaption = _a.groupCaption, index = _a.index;
                var questionIndexSplitted = index ? index.split(".") : "";
                var questionIndex = questionIndexSplitted.length > 2
                    ? questionIndexSplitted[0] + "." + questionIndexSplitted[1] + "..."
                    : index
                        ? index
                        : "";
                return {
                    simple: question.current,
                    questionTitleInfo: {
                        caption: caption,
                        subText: subText,
                        groupCaption: groupCaption,
                        questionIndex: questionIndex,
                        index: questionIndex,
                    },
                };
            }
        }
    }, [computedQuestions, t, isCallCenter, question]);
    React.useEffect(function () {
        var _a, _b, _c;
        var questionsIds = (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.simple) ? [currentQuestion.simple.id]
            : (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.grouped) ? (_a = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.questionTitleInfo) === null || _a === void 0 ? void 0 : _a.groupedQuestionsSpeechIds : undefined;
        if (isReaderActive && ((_b = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.questionTitleInfo) === null || _b === void 0 ? void 0 : _b.caption) &&
            stream && ((_c = user === null || user === void 0 ? void 0 : user.data) === null || _c === void 0 ? void 0 : _c.language) &&
            questionsIds) {
            stream({ questionsIds: questionsIds });
            dispatch(setHasUsedVoice(true));
        }
    }, [
        currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.grouped,
        (_b = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.questionTitleInfo) === null || _b === void 0 ? void 0 : _b.caption,
        (_c = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.questionTitleInfo) === null || _c === void 0 ? void 0 : _c.groupedQuestionsSpeechIds,
        currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.simple,
        dispatch,
        isReaderActive,
        stream,
        (_d = user === null || user === void 0 ? void 0 : user.data) === null || _d === void 0 ? void 0 : _d.language,
    ]);
    return {
        isCallCenter: isCallCenter,
        currentQuestion: currentQuestion,
        questionTitleInfo: currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.questionTitleInfo,
        questionnaireCompleted: questionnaireCompleted,
        canTheAssessmentBeStopped: canTheAssessmentBeStopped,
        questionsLoading: questionsLoading,
        question: question,
        useJuvenileProduct: useJuvenileProduct,
    };
};

var CurrentQuestion = function (_a) {
    var _b, _c;
    var unmount = _a.unmount;
    var _d = useCurrentQuestionLocalLogic(), isCallCenter = _d.isCallCenter, currentQuestion = _d.currentQuestion, questionTitleInfo = _d.questionTitleInfo, questionnaireCompleted = _d.questionnaireCompleted, canTheAssessmentBeStopped = _d.canTheAssessmentBeStopped, question = _d.question, questionsLoading = _d.questionsLoading, useJuvenileProduct = _d.useJuvenileProduct;
    var t = reactI18next.useTranslation().t;
    var dispatch = reactRedux.useDispatch();
    var pause = useGetMp3QuestionTitle().pause;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        questionsLoading || !question ? (React__default["default"].createElement("div", { className: classes$2.loader },
            React__default["default"].createElement(icons.RedoOutlined, { spin: true }))) : (((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.simple) || (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.grouped)) &&
            questionTitleInfo && (React__default["default"].createElement("div", { className: classes$2.container },
            isCallCenter === 1 && (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(QuestionnaireStatus$1, { completed: !!questionnaireCompleted }),
                questionnaireCompleted && (React__default["default"].createElement("div", { style: { margin: "auto" } },
                    React__default["default"].createElement(FinishAndProceedBtn$1, { unmount: unmount }))))),
            ((_b = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.grouped) === null || _b === void 0 ? void 0 : _b.questions) ? (React__default["default"].createElement(antd.Form.Provider, { onFormFinish: function (name, _a) {
                    var _b, _c;
                    _a.values; _a.forms;
                    var lastQuestionFromTheGroup = (_b = currentQuestion.grouped) === null || _b === void 0 ? void 0 : _b.questions[((_c = currentQuestion.grouped) === null || _c === void 0 ? void 0 : _c.questions.length) - 1];
                    if (name === "groupedQuestion") {
                        if (isCallCenter === 0) {
                            pause();
                        }
                        dispatch(answerQuestion({
                            answer: lastQuestionFromTheGroup === null || lastQuestionFromTheGroup === void 0 ? void 0 : lastQuestionFromTheGroup.answer,
                            question: lastQuestionFromTheGroup,
                            groupedQuestionsAnswer: true,
                        }));
                    }
                } },
                React__default["default"].createElement(Title$1, { questionIndex: t(questionTitleInfo.index) }),
                currentQuestion.grouped.groupedQuestionKey ===
                    "Height and Weight" ? (React__default["default"].createElement(React__default["default"].Fragment, null,
                    React__default["default"].createElement("div", { style: { display: "flex" } }, currentQuestion.grouped.questions
                        .filter(function (item) {
                        return heightAndWeightQuestionsIds.HeightUnits ===
                            item.id ||
                            heightAndWeightQuestionsIds.HeightSI ===
                                item.id ||
                            heightAndWeightQuestionsIds.HeightUS ===
                                item.id ||
                            heightAndWeightQuestionsIds.JuvenilesHeightSI ===
                                item.id ||
                            heightAndWeightQuestionsIds.JuvenilesHeightUS ===
                                item.id;
                    })
                        .map(function (item) {
                        return (React__default["default"].createElement(QuestionContent$1, { key: item.id, question: item, isGroupedQuestion: true, unmount: unmount }));
                    })),
                    React__default["default"].createElement("div", { style: { display: "flex" } }, currentQuestion.grouped.questions
                        .filter(function (item) {
                        return heightAndWeightQuestionsIds.WeightUnits ===
                            item.id ||
                            heightAndWeightQuestionsIds.WeightSI ===
                                item.id ||
                            heightAndWeightQuestionsIds.WeightUS ===
                                item.id ||
                            heightAndWeightQuestionsIds.JuvenilesWeightSI ===
                                item.id ||
                            heightAndWeightQuestionsIds.JuvenilesWeightUS ===
                                item.id;
                    })
                        .map(function (item) {
                        return (React__default["default"].createElement(QuestionContent$1, { key: item.id, question: item, isGroupedQuestion: true, unmount: unmount }));
                    })))) : (currentQuestion.grouped.questions.map(function (item) {
                    return (React__default["default"].createElement(QuestionContent$1, { key: item.id, question: item, isGroupedQuestion: true, unmount: unmount }));
                })),
                React__default["default"].createElement(GroupedQuestionsActionsButtons$1, { groupedQuestionCategory: currentQuestion.grouped
                        .groupedQuestionKey, allTheQuestionsHaveBeenAnswered: currentQuestion.grouped
                        .allTheQuestionsHaveBeenAnswered }))) : (React__default["default"].createElement("div", { className: classes$2.questionContainer },
                React__default["default"].createElement(Title$1, { subText: questionTitleInfo.subText, caption: questionTitleInfo.caption, groupCaption: questionTitleInfo.groupCaption, questionIndex: questionTitleInfo.index }),
                React__default["default"].createElement(Question$1, { key: (_c = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.simple) === null || _c === void 0 ? void 0 : _c.id, currentQuestion: currentQuestion.simple, unmount: unmount }))),
            !useJuvenileProduct &&
                isCallCenter !== 1 &&
                canTheAssessmentBeStopped && React__default["default"].createElement(StopAssessment$1, null)))),
        React__default["default"].createElement(DeclinedInfoModal$1, { unmount: unmount })));
};
var CurrentQuestion$1 = React.memo(CurrentQuestion);

var css_248z = "#index-module_reflex-root__AHwY1 {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  position: fixed;\n  top: 46px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n@media only screen and (max-width: 990px) {\n  .index-module_drawer__2y-q2 .index-module_ant-drawer-body__cdM74 {\n    padding: 0px;\n  }\n}\n\n.index-module_ant-drawer-body__cdM74 {\n  padding-right: 10px;\n}\n\n.index-module_ant-picker-date-panel__MmKZL table.index-module_ant-picker-content__aN7H4 thead {\n  display: none !important;\n}";
styleInject(css_248z);

var stateSelectorHandle = reselect.createSelector(function (state) { return state.app.isSiderOpen; }, function (state) { return state.user; }, function (state) { return state.questions.data; }, function (isSiderOpen, user, rasPayload) {
    return {
        isSiderOpen: isSiderOpen,
        user: user,
        rasPayload: rasPayload
    };
});
var Content = antd.Layout.Content;
var store = configureStore();
var App = React.memo(function (_a) {
    var _b, _c;
    var initialData = _a.initialData;
    var i18n = reactI18next.useTranslation().i18n;
    var dispatch = reactRedux.useDispatch();
    var stateSelector = React.useCallback(stateSelectorHandle, []);
    var _d = reactRedux.useSelector(stateSelector), isSiderOpen = _d.isSiderOpen, user = _d.user, rasPayload = _d.rasPayload;
    var _e = React.useState(localeEN__default["default"]), antdLocale = _e[0], setLocale = _e[1];
    var toggleSider = React.useCallback(function () {
        dispatch(toggleSiderAction());
    }, [dispatch]);
    React.useEffect(function () {
        var _a, _b, _c, _d, _e;
        var current = new Date().getFullYear();
        var birth = new Date(initialData.dob).getFullYear();
        if (current - birth < 80) {
            dispatch(setTheApplicatntAgeIsTooLow({ messages: undefined }));
        }
        if (initialData.serverPayload) {
            initialData.serverPayload.language = initialData.language || "en";
        }
        if (initialData.env &&
            ["development", "production"].indexOf(initialData.env) !== -1) {
            updateAxiosInstance(initialData.env, ((_c = (_b = (_a = initialData === null || initialData === void 0 ? void 0 : initialData.serverPayload) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.ras) === null || _c === void 0 ? void 0 : _c.version) || ((_e = (_d = rasPayload === null || rasPayload === void 0 ? void 0 : rasPayload.meta) === null || _d === void 0 ? void 0 : _d.ras) === null || _e === void 0 ? void 0 : _e.version));
        }
        dispatch(getProducts(initialData));
        i18n.changeLanguage(initialData.language);
    }, [dispatch, initialData, i18n, (_c = (_b = rasPayload === null || rasPayload === void 0 ? void 0 : rasPayload.meta) === null || _b === void 0 ? void 0 : _b.ras) === null || _c === void 0 ? void 0 : _c.version]);
    React.useEffect(function () {
        var _a, _b;
        if (!((_a = user.data) === null || _a === void 0 ? void 0 : _a.language))
            return undefined;
        if (((_b = user.data) === null || _b === void 0 ? void 0 : _b.language) === "fr") {
            moment__default["default"].locale("fr", {
                months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
                monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
                monthsParseExact: true,
                weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
                weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
                weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
                weekdaysParseExact: true,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[Aujourd’hui à] LT",
                    nextDay: "[Demain à] LT",
                    nextWeek: "dddd [à] LT",
                    lastDay: "[Hier à] LT",
                    lastWeek: "dddd [dernier à] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "dans %s",
                    past: "il y a %s",
                    s: "quelques secondes",
                    m: "une minute",
                    mm: "%d minutes",
                    h: "une heure",
                    hh: "%d heures",
                    d: "un jour",
                    dd: "%d jours",
                    M: "un mois",
                    MM: "%d mois",
                    y: "un an",
                    yy: "%d ans",
                },
                dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
                ordinal: function (number) {
                    return number + (number === 1 ? "er" : "e");
                },
                meridiemParse: /PD|MD/,
                isPM: function (input) {
                    return input.charAt(0) === "M";
                },
                // In case the meridiem units are not separated around 12, then implement
                // this function (look at locale/id.js for an example).
                // meridiemHour : function (hour, meridiem) {
                //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
                // },
                meridiem: function (hours) {
                    return hours < 12 ? "PD" : "MD";
                },
                week: {
                    dow: 1,
                    doy: 4,
                },
            });
            setLocale(localeFR__default["default"]);
        }
        else {
            moment__default["default"].locale("en");
            setLocale(localeEN__default["default"]);
        }
    }, [user.data]);
    // TODO: add a loader instead of null
    return !user.data ? null : (React__default["default"].createElement(antd.ConfigProvider, { locale: antdLocale },
        React__default["default"].createElement(antd.Layout, { style: { display: "flex", flex: "1" } },
            React__default["default"].createElement("div", { id: "drawer-parent", className: "site-drawer-render-in-current-wrapper", style: { zIndex: 999, top: 46 } },
                React__default["default"].createElement(antd.Drawer, { className: "drawer", width: "50%", placement: "left", closable: true, onClose: toggleSider, visible: isSiderOpen, drawerStyle: { backgroundColor: "#42a8dc" }, style: { position: "absolute" }, getContainer: false },
                    React__default["default"].createElement(LeftSide$1, { initialData: user.data }))),
            React__default["default"].createElement(antd.Layout, { style: { display: "flex", flex: "1" } },
                React__default["default"].createElement(Content, { style: { display: "flex", flex: "1" } },
                    React__default["default"].createElement(RightSide$1, null))))));
});
var App$1 = React.memo(function (_a) {
    var initialData = _a.initialData;
    return (React__default["default"].createElement(reactRedux.Provider, { store: store },
        React__default["default"].createElement(connectedReactRouter.ConnectedRouter, { history: history },
            React__default["default"].createElement(App, { initialData: initialData }))));
});

exports.updateReflex = function (payload) { };
exports.exitReflex = function (payload) { };
exports.callAudioApi = function (_a) {
    _a.action; _a.file;
};
var Reflex = {
    init: function (payload) {
        exports.updateReflex = payload.updateReflex;
        exports.exitReflex = payload.exitReflex;
        exports.callAudioApi = payload.callAudioApi;
    },
    mount: function (data) {
        if (data === void 0) { data = {
            address: "",
            application_id: "180344",
            city: "",
            coverage: 5000,
            dob: "1989-02-28",
            email: "",
            first_name: "Diana",
            gender: "f",
            language: "en",
            last_name: "Test",
            middle_name: "",
            phone: "(647) 886-3453",
            postal_code: "",
            province: "ON",
            extension: "904",
            serverPayload: undefined,
            risk: "",
            term: "",
            env: "local",
            isCallCenter: 2,
            // if the value is 0 or 2 the UI will render the questions and at the end of the questionnaire multiple sliders (products) will be shown.
            smoker: "0",
            smokerFE: "0",
            product_version: "",
            product_code: "",
            force_GI: false,
            approved: false,
            products: "",
            // TODO: this need to be moved in application store
            add_everest: "1",
            // is that add_everest is used for the product from CC (when isCallCenter === 1 there will be only 1 product) whereas addEverest from products field is used for the products that are present when isCallCenter === 0 || isCallCenter === 2
            showGP: undefined,
            hasUsedVoice: false,
        }; }
        var root = document.getElementById("reflex-root");
        if (root) {
            root.style.display = "flex";
            root.style.position = "fixed";
            root.style.top = "0px";
            root.style.bottom = "0px";
            root.style.left = "0px";
            root.style.right = "0px";
            root.style.zIndex = "1";
            ReactDOM__default["default"].render(React__default["default"].createElement(React__default["default"].StrictMode, null,
                React__default["default"].createElement(reactI18next.I18nextProvider, { i18n: i18n__default["default"] },
                    React__default["default"].createElement(App$1, { initialData: data }))), root);
        }
    },
};
// import * as serviceWorker from "./serviceWorker";
// import { rasPayload } from "./store/sagas/question/rasPayload";
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

exports["default"] = Reflex;
